import {
  export_json_to_excel,
  export_json_to_excels,
  formatJson,
} from '@/utils/Export2Excel.js';
import { exportLayeredExcelWithExcelJS } from '@/utils/ExportExcelVO.js';
import { store, getRouteInfo } from '@/store/store';
import {
  fomatTime,
  getNextMonth,
  getLastMonth,
  YearDate,
  getPreviousDate,
  getTodayRange,
  getThisWeekRange,
  getThisMonthRange,
  getThisYearRange,
} from '@/utils/fomatTime';
import { getGuid } from '@/utils/getGuid.ts';
import mittBus from '@/utils/mitt';
import FileDownload from '@/components/FileCtl/download';
import FilePreview from '@/components/FileCtl/Preview';
import { useRoute } from 'vue-router';
import {
  getQueryObject,
  byteLength,
  cleanArray,
  param,
  param2Obj,
  html2Text,
  objectMerge,
  toggleClass,
  getTime,
  deepClone,
  uniqueArr,
  createUniqueString,
  generateMixed,
  getMixed,
  hasClass,
  addClass,
  removeClass,
  toJSONStr,
  changeOrder,
} from './common.js';
import convert_currency from '@/utils/convertCurrency.js';
import { de, fa } from 'element-plus/es/locale/index.mjs';
import { obj } from '@visactor/vtable/es/tools/helper.js';
function deepCopy(obj) {
  if (obj === null || typeof obj !== 'object') {
    return obj;
  }

  if (obj instanceof Date) {
    return new Date(obj.getTime());
  }

  if (obj instanceof Array) {
    return obj.reduce((arr, item, i) => {
      arr[i] = deepCopy(item);
      return arr;
    }, []);
  }

  if (obj instanceof Object) {
    return Object.keys(obj).reduce((newObj, key) => {
      newObj[key] = deepCopy(obj[key]);
      return newObj;
    }, {});
  }
}

export default function registerFunLib(
  app,
  execute,
  echarts,
  axios,
  notify,
  msgbox,
  message,
  store,
  router
) {
  app.config.globalProperties.$proxy = {
    $execute: execute,
    $echarts: echarts,
    $axios: axios,
    $notify: notify,
    $msgbox: msgbox,
    $message: message,
    $store: store,
    $router: router,
    $mittBus: mittBus,
    $initialize: (config, objsearch, objdata, iniparam, props = {}) => {
      let params;
      switch (config.type) {
        case 'PageRP':
          params = {
            cobject: config.cobjectt,
            coper: 'initialize',
            objpara: {},
          };
          config.proxy.$execute(params).then((res) => {
            if (res.iresult != 0) {
              config.proxy.$msgbox(res.cerror);
              return;
            }
            config.pageobj = new PageRP(config, objsearch, objdata, res.data); //  this.config.proxy.$utils.comm.createpagerp(this.config, this.objsearch, this.objdata, res.data);
            objdata.init_res = res.data;
            if (iniparam.fnsearch) config.pageobj.fnsearch = iniparam.fnsearch;
            if (iniparam.fnmoveid) config.pageobj.fnsearch = iniparam.fnmoveid;
            if (iniparam.fnselectrow) config.pageobj.fnsearch = iniparam.fnselectrow;
            if (props) objdata.props = props;
            //初始化数据
            if (res.data.paras) objdata.paras = res.data.paras;
            if (res.data.views) {
              objdata.views = res.data.views;
              objsearch.views = res.data.views;
            }
            if (res.data.mnus) {
              objdata.mnus = res.data.mnus;
              objsearch.mnus = res.data.mnus;
              for (let key in res.data.mnus) {
                if (res.data.mnus.hasOwnProperty(key)) {
                  // 确保是对象自有属性，不是原型链上的属性
                  objdata.com[key] = true;
                  objsearch.com[key] = true;
                }
              }
            }
            let obj = null;
            if (objsearch.columns.filter) {
              obj = config.pageobj.fncreateobj('filter');
              if (obj) objsearch.filter = obj;
            }
            if (res.data.islst) {
              objsearch.islst = res.data.islst;
            }
            for (let key in objsearch.columns) {
              if (objsearch.columns.hasOwnProperty(key)) {
                if (Object.keys(objsearch.islst).length !== 0) {
                  if (objsearch.islst[key] && objsearch.islst[key] == 1) {
                    objsearch.data[key] = [];
                  } else {
                    obj = config.pageobj.fncreateobj(key);
                    if (obj) {
                      objsearch.data[key] = obj;
                    }
                  }
                } else {
                  if (key != 'filter' && key != 'list') {
                    if (key == 'details') {
                      objsearch.data[key] = [];
                    } else if (key.indexOf('lst') !== -1) {
                      objsearch.data[key] = [];
                    } else {
                      obj = config.pageobj.fncreateobj(key);
                      if (obj) {
                        objsearch.data[key] = obj;
                      }
                    }
                  }
                }
              }
            }

            if (iniparam.authbtn) {
              if (res.data?.rolst) {
                res.data.rolst.forEach((item) => {
                  const op = item.cbaroper;
                  if (op != null) {
                    objdata.btn[op] = 1;
                  }
                });
              }
              // for (let i1 = 0; i1 <= res.data.rolst.length - 1; i1++) {
              //   if (res.data.rolst[i1].cbaroper == 'new') objdata.btn['new'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'edit') objdata.btn['edit'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'verify') objdata.btn['verify'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'verifybt')
              //     objdata.btn['verifybt'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'cancel') objdata.btn['cancel'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'cancelrbt')
              //     objdata.btn['cancelrbt'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'verifyrbt')
              //     objdata.btn['verifyrbt'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'cancelbt')
              //     objdata.btn['cancelbt'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'close') objdata.btn['close'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'closebt') objdata.btn['closebt'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'closerbt')
              //     objdata.btn['closerbt'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'import') objdata.btn['import'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'sync') objdata.btn['sync'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'changeln')
              //     objdata.btn['changeln'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'close') objdata.btn['close'] = 1;
              // }
            }
            config.pageobj.onWatchBtnStatus(config.pageobj, config.type, 'mnu');
            config.callback({
              iresult: 0,
              cerror: '',
              coper: 'initialize',
              data: res.data,
            });
            if (!iniparam || iniparam.autosearch) config.pageobj.onSearch();
          });
          break;
        case 'PageLI':
          params = {
            cobject: config.cobjectt,
            coper: 'inilst',
            objpara: {},
          };
          config.proxy.$execute(params).then((res) => {
            if (res.iresult != 0) {
              config.proxy.$msgbox(res.cerror);
              return;
            }
            config.pageobj = new PageLI(config, objsearch, objdata, res.data); //  this.config.proxy.$utils.comm.createpagerp(this.config, this.objsearch, this.objdata, res.data);
            objdata.init_res = res.data;
            if (iniparam.fnsearch) config.pageobj.fnsearch = iniparam.fnsearch;
            if (iniparam.fnmoveid) config.pageobj.fnsearch = iniparam.fnmoveid;
            if (iniparam.fnselectrow) config.pageobj.fnsearch = iniparam.fnselectrow;
            if (props) objdata.props = props;
            //初始化数据
            if (res.data.paras) objdata.paras = res.data.paras;
            if (res.data.views) {
              objdata.views = res.data.views;
              objsearch.views = res.data.views;
            }
            if (res.data.mnus) {
              objdata.mnus = res.data.mnus;
              objsearch.mnus = res.data.mnus;
              for (let key in res.data.mnus) {
                if (res.data.mnus.hasOwnProperty(key)) {
                  // 确保是对象自有属性，不是原型链上的属性
                  objdata.com[key] = true;
                  objsearch.com[key] = true;
                }
              }
            }
            let obj = null;
            if (objsearch.columns.filter) {
              // if (config.pageobj.objsearch.objini.filter && config.pageobj.objsearch.objini.filter != '') {
              obj = config.pageobj.fncreateobj('filter');
              if (obj) objsearch.filter = obj;
            }

            // if (objsearch.columns.head) {
            //   // if (config.pageobj.objsearch.objini.head && config.pageobj.objsearch.objini.head != '') {
            //   obj = config.pageobj.fncreateobj('head');
            //   if (obj) objdata.data.head = obj;
            // }
            if (objsearch.columns.list) {
              // if (config.pageobj.objsearch.objini.list && config.pageobj.objsearch.objini.list != '') {
              obj = config.pageobj.fncreateobj('list');
              if (obj) objdata.data = obj;
            }
            if (iniparam.authbtn) {
              if (res.data?.rolst) {
                res.data.rolst.forEach((item) => {
                  const op = item.cbaroper;
                  if (op != null) {
                    objdata.btn[op] = 1;
                  }
                });
              }
              // for (let i1 = 0; i1 <= res.data.rolst.length - 1; i1++) {
              //   if (res.data.rolst[i1].cbaroper == 'new') objdata.btn['new'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'edit') objdata.btn['edit'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'verify') objdata.btn['verify'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'verifybt')
              //     objdata.btn['verifybt'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'cancel') objdata.btn['cancel'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'cancelrbt')
              //     objdata.btn['cancelrbt'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'verifyrbt')
              //     objdata.btn['verifyrbt'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'cancelbt')
              //     objdata.btn['cancelbt'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'close') objdata.btn['close'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'closebt') objdata.btn['closebt'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'closerbt')
              //     objdata.btn['closerbt'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'import') objdata.btn['import'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'sync') objdata.btn['sync'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'changeln')
              //     objdata.btn['changeln'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'close') objdata.btn['close'] = 1;
              // }
            }
            if (res.data.paras) {
              objdata.paras = res.data.paras;
              if (res.data.paras.ilstst) {
                objsearch.filter.cstatus = res.data.paras.ilstst;
              }
              if (res.data.paras.ilstwf) {
                objsearch.filter.iwf = res.data.paras.ilstwf;
              }
            }
            config.pageobj.onWatchBtnStatus(config.pageobj, config.type, 'mnu');
            config.callback({ iresult: 0, cerror: '', coper: 'inilst', data: res.data });
            if (iniparam && iniparam.autosearch) config.pageobj.onSearch();
          });
          break;
        case 'PageVO':
          const route = config.proxy.$utils.comm.route();
          params = {
            cobject: config.cobjectt,
            coper: 'initialize',
            objpara: {
              id: config.proxy.$router.currentRoute.query.id,
              ilist: config.ilist ? config.ilist : 0,
            },
          };
          config.proxy.$execute(params).then((res) => {
            if (res.iresult != 0) {
              config.proxy.$msgbox(res.cerror);
              return;
            }
            config.pageobj = new PageVO(config, objsearch, objdata, res.data); //  this.config.proxy.$utils.comm.createpagerp(this.config, this.objsearch, this.objdata, res.data);
            objdata.init_res = res.data;
            if (iniparam.fnsearch) config.pageobj.fnsearch = iniparam.fnsearch;
            if (iniparam.fnmoveid) config.pageobj.fnmoveid = iniparam.fnmoveid;
            if (iniparam.fnselectrow) config.pageobj.fnsearch = iniparam.fnselectrow;
            if (iniparam.fnsave) config.pageobj.fnsave = iniparam.fnsave;
            if (props) objdata.props = props;
            //初始化数据
            if (res.data.vouch) objdata.vouch = res.data.vouch;
            if (res.data.paras) objdata.paras = res.data.paras;
            if (res.data.views) {
              objdata.views = res.data.views;
              if ('details' in objdata.views) {
                // objsearch.ibyord = 1;
                objsearch.ibyord = objdata.views.details.head.ibyord;
              }
            }
            if (res.data.mnus) {
              objdata.mnus = res.data.mnus;
              objsearch.mnus = res.data.mnus;
              for (let key in res.data.mnus) {
                if (res.data.mnus.hasOwnProperty(key)) {
                  // 确保是对象自有属性，不是原型链上的属性
                  objdata.com[key] = true;
                  objsearch.com[key] = true;
                }
              }
            }
            let obj = null;
            if (objsearch.columns.head) {
              obj = config.pageobj.fncreateobj('head');
              if (obj) {
                objdata.data.head = obj;
                let init = {};
                init = Object.assign(objdata.init, obj);
                objdata.init = init;
                objdata.init_new = init;
              }
            }
            if (res.data.islst) {
              objdata.islst = res.data.islst;
            }
            for (let key in objsearch.columns) {
              if (objsearch.columns.hasOwnProperty(key)) {
                if (Object.keys(objdata.islst).length !== 0) {
                  if (objdata.islst[key] && objdata.islst[key] == 1) {
                    objdata.data[key] = [];
                  } else {
                    obj = config.pageobj.fncreateobj(key);
                    if (obj) {
                      objdata.data[key] = obj;
                    }
                  }
                } else {
                  if (key != 'head' && key != 'ctl' && key != 'filter' && key != 'list') {
                    if (key == 'details') {
                      objdata.data[key] = [];
                    } else if (key.indexOf('lst') !== -1) {
                      objdata.data[key] = [];
                    } else {
                      obj = config.pageobj.fncreateobj(key);
                      if (obj) {
                        objdata.data[key] = obj;
                      }
                    }
                  }
                }
              }
            }
            if (iniparam.authbtn) {
              if (res.data?.rolst) {
                res.data.rolst.forEach((item) => {
                  const op = item.cbaroper;
                  if (op != null) {
                    objdata.btn[op] = 1;
                  }
                });
              }
              // for (let i1 = 0; i1 <= res.data.rolst.length - 1; i1++) {
              //   if (res.data.rolst[i1].cbaroper == 'new') objdata.btn['new'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'edit') objdata.btn['edit'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'verify') objdata.btn['verify'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'verifybt')
              //     objdata.btn['verifybt'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'cancel') objdata.btn['cancel'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'cancelrbt')
              //     objdata.btn['cancelrbt'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'verifyrbt')
              //     objdata.btn['verifyrbt'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'cancelbt')
              //     objdata.btn['cancelbt'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'close') objdata.btn['close'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'closebt') objdata.btn['closebt'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'closerbt')
              //     objdata.btn['closerbt'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'import') objdata.btn['import'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'sync') objdata.btn['sync'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'changeln')
              //     objdata.btn['changeln'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'close') objdata.btn['close'] = 1;
              // }
            }
            if (res.data.del) {
              objdata.del = res.data.del;
            }
            if (
              config.proxy.$router.currentRoute.query.coper &&
              ((config.ioper && config.ioper == 1) ||
                (!config.ioper && config.ioper !== 0))
            ) {
              if (config.proxy.$router.currentRoute.query.coper == 'new') {
                config.pageobj.fnnew();
                if (res.data.vo) {
                  objdata.loading = true;
                  objdata.data = res.data.vo;
                  objdata.isshowstate = true;
                  if (res.data.head?.idwf !== '' || res.data.head?.idwfe !== '') {
                    objdata.wf.isload = true;
                    setTimeout(() => {
                      objdata.wf.isload = false;
                    }, 100);
                  }
                  config.pageobj.onSearch_e(
                    objdata.data.head.idwfe,
                    objdata.data.head.idwf,
                    objdata.wf.isload
                  );
                  setTimeout(() => {
                    objdata.loading = false;
                  }, 1000);
                }
              } else {
                if (res.data.vo) {
                  objdata.loading = true;
                  objdata.data = res.data.vo;
                  objdata.isshowstate = true;
                  if (res.data.head?.idwf !== '' || res.data.head?.idwfe !== '') {
                    objdata.wf.isload = true;
                    setTimeout(() => {
                      objdata.wf.isload = false;
                    }, 100);
                  }
                  config.pageobj.onSearch_e(
                    objdata.data.head.idwfe,
                    objdata.data.head.idwf,
                    objdata.wf.isload
                  );
                  setTimeout(() => {
                    objdata.loading = false;
                  }, 1000);
                } else {
                  if (config.proxy.$router.currentRoute.query.id)
                    config.pageobj.fnmoveid(
                      config.proxy.$router.currentRoute.query.id,
                      config.proxy.$router.currentRoute.query.coper
                    );
                }
              }
            }
            config.pageobj.onWatchBtnStatus(config.pageobj, config.type, 'mnu');
            config.pageobj.onWatchBtnStatus(config.pageobj, config.type, 'mnudet');
            config.callback({
              iresult: 0,
              cerror: '',
              coper: 'initialize',
              data: JSON.stringify(objdata.data),
            });
          });
          break;
        case 'PageBD':
          params = {
            cobject: config.cobjectt,
            coper: 'initialize',
            objpara: {
              id: config.proxy.$router.currentRoute.query.id,
              ilist: config.ilist ? config.ilist : 0,
            },
          };
          config.proxy.$execute(params).then((res) => {
            if (res.iresult != 0) {
              config.proxy.$msgbox(res.cerror);
              return;
            }
            config.pageobj = new PageBD(config, objsearch, objdata, res.data); //  this.config.proxy.$utils.comm.createpagerp(this.config, this.objsearch, this.objdata, res.data);
            objdata.init_res = res.data;
            if (iniparam.fnsearch) config.pageobj.fnsearch = iniparam.fnsearch;
            if (iniparam.fnmoveid) config.pageobj.fnsearch = iniparam.fnmoveid;
            if (iniparam.fnselectrow) config.pageobj.fnsearch = iniparam.fnselectrow;
            if (iniparam.fnsave) config.pageobj.fnsave = iniparam.fnsave;
            if (props) {
              objdata.props = props;
            }
            //初始化数据
            if (res.data.vouch) objdata.vouch = res.data.vouch;
            if (res.data.paras) objdata.paras = res.data.paras;
            if (res.data.views) objdata.views = res.data.views;
            if (res.data.mnus) {
              objdata.mnus = res.data.mnus;
              objsearch.mnus = res.data.mnus;
              for (let key in res.data.mnus) {
                if (res.data.mnus.hasOwnProperty(key)) {
                  // 确保是对象自有属性，不是原型链上的属性
                  objdata.com[key] = true;
                  objsearch.com[key] = true;
                }
              }
            }
            let obj = null;
            if (objsearch.columns.filter) {
              obj = config.pageobj.fncreateobj('filter');
              if (obj) objsearch.filter = obj;
            }
            if (objsearch.columns.head) {
              obj = config.pageobj.fncreateobj('head');
              if (obj) {
                objdata.data.head = obj;
                let init = {};
                init = Object.assign(objdata.init, obj);
                objdata.init = init;
                objdata.init_new = init;
              }
            }
            if (objsearch.columns.ctl) {
              obj = config.pageobj.fncreateobj('ctl');
              if (obj) {
                objdata.data.ctl = obj;
                let init = {};
                init = Object.assign(objdata.initctl, obj);
                objdata.initctl = init;
              }
            }
            if (res.data.islst) {
              objdata.islst = res.data.islst;
            }
            for (let key in objsearch.columns) {
              if (objsearch.columns.hasOwnProperty(key)) {
                if (Object.keys(objdata.islst).length !== 0) {
                  if (
                    objdata.islst[key] &&
                    objdata.islst[key] == 1 &&
                    key != 'filter' &&
                    key != 'list'
                  ) {
                    objdata.data[key] = [];
                  } else {
                    obj = config.pageobj.fncreateobj(key);
                    if (obj && key != 'filter' && key != 'list') {
                      objdata.data[key] = obj;
                    }
                  }
                } else {
                  if (key != 'head' && key != 'ctl' && key != 'filter' && key != 'list') {
                    if (key == 'details') {
                      objdata.data[key] = [];
                    } else if (key.indexOf('lst') !== -1) {
                      objdata.data[key] = [];
                    } else {
                      obj = config.pageobj.fncreateobj(key);
                      if (obj) {
                        objdata.data[key] = obj;
                      }
                    }
                  }
                }
              }
            }
            if (iniparam.authbtn) {
              if (res.data?.rolst) {
                res.data.rolst.forEach((item) => {
                  const op = item.cbaroper;
                  if (op != null) {
                    objdata.btn[op] = 1;
                  }
                });
              }
              // for (let i1 = 0; i1 <= res.data.rolst.length - 1; i1++) {
              //   if (res.data.rolst[i1].cbaroper == 'new') objdata.btn['new'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'edit') objdata.btn['edit'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'verify') objdata.btn['verify'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'verifybt')
              //     objdata.btn['verifybt'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'cancel') objdata.btn['cancel'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'cancelrbt')
              //     objdata.btn['cancelrbt'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'verifyrbt')
              //     objdata.btn['verifyrbt'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'cancelbt')
              //     objdata.btn['cancelbt'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'close') objdata.btn['close'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'closebt') objdata.btn['closebt'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'closerbt')
              //     objdata.btn['closerbt'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'import') objdata.btn['import'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'sync') objdata.btn['sync'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'changeln')
              //     objdata.btn['changeln'] = 1;
              //   if (res.data.rolst[i1].cbaroper == 'close') objdata.btn['close'] = 1;
              // }
            }
            if (res.data.del) {
              objdata.del = res.data.del;
            }
            if (
              config.proxy.$router.currentRoute.query.coper &&
              ((config.ioper && config.ioper == 1) ||
                (!config.ioper && config.ioper !== 0))
            ) {
              if (config.proxy.$router.currentRoute.query.coper == 'new')
                config.pageobj.fnnew();
              if (res.data.vo) {
                objdata.loading = true;
                objdata.data = res.data.vo;
                objdata.isshowstate = true;
                setTimeout(() => {
                  objdata.loading = false;
                }, 1000);
              } else {
                if (res.data.vo) {
                  objdata.loading = true;
                  objdata.data = res.data.vo;
                  objdata.isshowstate = true;
                  setTimeout(() => {
                    objdata.loading = false;
                  }, 1000);
                } else {
                  if (config.proxy.$router.currentRoute.query.id)
                    config.pageobj.fnmoveid(
                      config.proxy.$router.currentRoute.query.id,
                      config.proxy.$router.currentRoute.query.coper
                    );
                }
              }
            }
            config.pageobj.onWatchBtnStatus(config.pageobj, config.type, 'mnu');
            config.callback({
              iresult: 0,
              cerror: '',
              coper: 'initialize',
              data: JSON.stringify(objdata.data),
            });
            if (iniparam && iniparam.autosearch) config.pageobj.onSearch();
          });
          break;
      }
    },
    $utils: {
      comm: {
        getRouteInfo: (pathname) => getRouteInfo(pathname),
        toJSONStr: (str) => toJSONStr(str),
        route: () => {
          return useRoute();
        },
        getGuid: () => getGuid(),
        convert_currency: (money) => convert_currency(money),
        closeCurrentTagsView: (route) => {
          mittBus.emit(
            'onCurrentContextmenuClick',
            Object.assign({}, { contextMenuClickId: 1, ...route })
          );
        },
        changeOrder: (lst, cfield, ctype, scope) =>
          changeOrder(lst, cfield, ctype, scope),
        createpagerp: (config, objsearch, objdata, iniobj) => {
          return new PageRP(config, objsearch, objdata, iniobj);
        },
        createpagevo: (config, objsearch, objdata, iniobj) => {
          return new PageVO(config, objsearch, objdata, iniobj);
        },
        createpagebd: (config, objsearch, objdata, iniobj) => {
          return new PageBD(config, objsearch, objdata, iniobj);
        },
      },
      dtformat: {
        fomatTime: (date, ctype) => fomatTime(date, ctype),
        getNextDate: (date, day) => getNextDate(date, day),
        getNextMonth: (now) => getNextMonth(now),
        getLastMonth: (now) => getLastMonth(now),
        YearDate: (d, num) => YearDate(d, num),
        getPreviousDate: (date, numOfDays) => getPreviousDate(date, numOfDays),
        getTodayRange: () => getTodayRange(),
        getThisWeekRange: () => getThisWeekRange(),
        getThisMonthRange: () => getThisMonthRange(),
        getThisYearRange: () => getThisYearRange(),
      },
      export: {
        export_json_to_excel: (id) => export_json_to_excel(id),
        exportLayeredExcelWithExcelJS: (id) => exportLayeredExcelWithExcelJS(id),
        export_table_to_excel: (obj) => export_table_to_excel(obj),
        formatjson: (filterVal, list) => formatJson(filterVal, list),
        fomatTime: (date, ctype) => fomatTime(date, ctype),
        exportExcelAll: (lst, collst, title, sheetname) => {
          let objsel = {
            optstatus: [
              { value: 0, label: '新建' },
              { value: 20, label: '审核' },
              { value: 99, label: '有效' },
              { value: -80, label: '作废' },
            ],
            optstft: [
              { value: 0, label: '新建' },
              { value: 10, label: '审批中' },
              { value: 20, label: '已审批' },
              { value: 99, label: '有效' },
              { value: -80, label: '作废' },
            ],
            opt10: [
              { value: 0, label: '否' },
              { value: 1, label: '是' },
            ],
            optwf: [
              { value: -1, label: '无流程' },
              { value: 0, label: '新建流程' },
              { value: 10, label: '发起' },
              { value: 15, label: '待办' },
              { value: 20, label: '已办' },
              { value: 16, label: '待阅读' },
              { value: 21, label: '已阅读' },
              { value: 99, label: '所有流程' },
            ],
            optustype: [
              { value: 0, label: '集团设置' },
              { value: 1, label: '单会话多用户' },
              { value: 2, label: '多会话多用户' },
              { value: 3, label: '询问单用户' },
              { value: 4, label: '强制单用户' },
            ],
          };
          const fnformatOpt = (row, value, lst) => {
            if (!row || !lst) return;
            let idx_s = lst.findIndex((i) => i.value == value);
            if (idx_s != -1) return lst[idx_s].label;
            else return value;
          };
          const fheader = [];
          const lheader = [];
          // objsearch.selectRow = objsearch.list;
          for (let i = 0, ilen = collst.length; i < ilen; i++) {
            if (collst[i].itype == 5) {
              lst.forEach((item) => {
                item[collst[i].prop] = fnformatOpt(
                  item,
                  item[collst[i].prop],
                  collst[i].cobject == '' ? collst[i].option : objsel[collst[i].cobject]
                );
              });
            } else if (collst[i].itype == 51) {
              lst.forEach((item) => {
                item[collst[i].prop] = fnformatOpt(
                  item,
                  item[collst[i].prop],
                  objsel.opt10
                );
              });
            } else if (collst[i].itype == 6) {
              lst.forEach((item) => {
                item[collst[i].prop] = fomatTime(
                  item[collst[i].prop],
                  collst[i].cobject == 'dates'
                    ? 'time'
                    : collst[i].cobject == 'datem'
                      ? 'month'
                      : 'date'
                );
              });
            }
            fheader.push(collst[i].prop);
            lheader.push(collst[i].label);
          }
          const data = formatJson(fheader, lst);
          if (data.length != 0) {
            export_json_to_excel({
              header: lheader,
              data,
              filename: title,
              sheetname: sheetname,
              autoWidth: true,
              bookType: 'xlsx',
            });
          }
        },
        exportExcelAlls: (lst, title) => {
          var fheader = [];
          var lheader = [];
          var datalst = [];
          // objsearch.selectRow = objsearch.list;

          for (let i1 = 0; i1 < lst.length; i1++) {
            var collst = lst[i1].collst;
            for (let i = 0, ilen = collst.length; i < ilen; i++) {
              fheader.push(collst[i].prop);
              lheader.push(collst[i].label);
            }
            var data = formatJson(fheader, lst[i1].data);
            if (data.length != 0) {
              datalst.push({ data, header: lheader, sheetname: lst[i1].sheetname });
            }
          }
          if (datalst.length > 0) {
            export_json_to_excels({
              datalst,
              filename: title,
              autoWidth: true,
              bookType: 'xlsx',
            });
          }
        },
      },
    },
    $obj: {
      onSearch: () => { },
      exportExcel: () => { },
      exportExcelAll: () => { },
      exportExcelback: () => { },
      onSelectData: () => { },
      cansel: () => { },
      fnselectrow: () => { },
      fnselectrow_moveid: () => { },
      fnselectrow_search: () => { },
      fnFileDownload: () => { },
      fnFilePreview: () => { },
      fnsearch: () => { },
      onSizeChange: () => { },
      onCurrentChange: () => { },
      fnload: () => { },
      fnExpChange: () => { },
      fnsellist: () => { },
      onRowClick: () => { },
      fnverify: () => { },
      fnverifybat: () => { },
      fnverifyrbat: () => { },
      fncancelbat: () => { },
      fncancelrbat: () => { },
      fnCancel: () => { },
      onChange: () => { },
      onSaveSwitch: () => { },
      getRowKeys: () => { },
      fninitobj: () => { },
      fnaddrow: () => { },
      fnaddrows: () => { },
      fnrefresh: () => { },
      fnnew: () => { },
      fnnew2: () => { },
      fnnew2_children: () => { },
      fnedit: () => { },
      fnedit2: () => { },
      fnmoveid: () => { },
      fnmoveid2: () => { },
      fntomoveid: () => { },
      fncancel2: () => { },
      fnclose2: () => { },
      fnsave: () => { },
      fndelete: () => { },
      fndeletebt: () => { },
      fndelete_li: () => { },
      fncreateobj: () => { },
      focusSelect: () => { },
      isnew: () => {
        return false;
      },
      isnew_children: () => {
        return false;
      },
      isedit: () => {
        return false;
      },
      isverify: () => {
        return false;
      },
      iscommit: () => {
        return false;
      },
      iscancel: () => {
        return false;
      },
      issync: () => {
        return false;
      },
      cansave: () => {
        return false;
      },
      cansavelogis: () => {
        return false;
      },
      cansee: () => {
        return false;
      },
      cannew: () => {
        return false;
      },
      cannew_children: () => {
        return false;
      },
      canedit: () => {
        return false;
      },
      canedit_5: () => {
        return false;
      },
      caneditlogis: () => {
        return false;
      },
      canedit_base: () => {
        return false;
      },
      canseeorder: () => {
        return false;
      },
      canverify: () => {
        return false;
      },
      cancommit: () => {
        return false;
      },
      cancancel: () => {
        return false;
      },
      isclose: () => {
        return false;
      },
      canclose: () => {
        return false;
      },
      candelete: () => {
        return false;
      },
      canaddrow: () => {
        return false;
      },
      pageMethods: () => { },
      onFunc: () => { },
      onFormatBtnValue: () => { },
      onBtnClick: () => { },
      onStandBtnClick: () => { },
      onBtnValueChange: () => { },
      onWatchBtnStatus: () => { },
      fnformatOpt: () => { },
      onOper: () => { },
      deleteRow: () => { },
      deepCopy: () => { },
      deepClone: () => { },
      isDeepEqual: () => { },
      isObjectDeepEqual: () => { },
      parseCshowpc: () => { },
      getTabLabel: () => { },
      exportExcelVO: () => { },
      fnprint: () => { },
      onSearch_e: () => { },
      onSave: () => { },
      onAgree: () => { },
      closeCurrentTagsView: () => { },
      onBack: () => { },
      onClose: () => { },
      onPass: () => { },
      onNoPass: () => { },
      onUnApproval: () => { },
      onCirculated: () => { },
      onTransfer: () => { },
      fnimportRow: () => { },
      fnexportRow: () => { },
      fnexecute: () => { },
      hotKey: () => { },
      juageExt: () => { },
    },
    $objsearch: () =>
      deepCopy({
        search_oper: '',
        isshow: false,
        issearch: false,
        loading: false,
        icurrpage: 1,
        ipagesize: 15,
        filter: {},
        iwf: -1,
        itot: 0,
        list: [],
        szmap: {},
        exportlst: [],
        selectRow: [],
        currrow: null,
        status: { iflag: 1 },
        columns: {},
        views: {},
        sums: [],
        com: {},
        focus: {},
        objini: {},
        objimg: {
          isfileshow: false,
          isshow: false,
          ismuti: true,
          ilimit: 0,
          cobject: '',
          coper: '',
          cparams: '',
          capp: '',
          cpath: '',
          cscope: '',
          filelst: [],
        },
        objimp: {
          isshow: false,
          cobject: '',
          coper: '',
          iheader: 1,
          csheet: '',
          csplit: ',',
          iround: 1,
          isshowSum: false,
          cparams: '',
        },
        printlst: [],
        data: {},
        islst: {},
        sumlst: [],
        ibyord: 0,
        opt_byord: [
          { id: 1, cname: '不参照订单' },
          { id: 2, cname: '参照订单' },
        ],
        mnus: {},
        initmuns: {
          PageRP: {
            lstbar: [
              {
                iindex: 0,
                id: '',
                cbar: 'Search',
                ccode: 'Search',
                cname: '搜索',
                cname2: 'Search',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 1,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Search',
                cicon2: 'Search',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'New',
                ccode: 'New',
                cname: '新建',
                cname2: 'New',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 3,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Plus',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Edit',
                ccode: 'Edit',
                cname: '编辑',
                cname2: 'Edit',
                cnameb: '放弃',
                cnameb2: 'Abandon',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 4,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Edit',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Moveid',
                ccode: 'Details',
                cname: '详情',
                cname2: 'Details',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 9,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'InfoFilled',
                cicon2: '',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Verify',
                ccode: 'Verify',
                cname: '审核',
                cname2: 'Verify',
                cnameb: '反审核',
                cnameb2: 'Reverify',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 7,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Check',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Batch Oper',
                ccode: 'Batch Oper',
                cname: '批量操作',
                cname2: 'Batch Oper',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 9,
                ibtntypes: 0,
                isize: 1,
                imode: 0,
                ileft: 0,
                idisabled: 0,
                cicon1: 'Menu',
                cicon2: '',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Verifybt',
                    ccode: 'Verifybt',
                    cname: '批量审核',
                    cname2: 'Batch Verify',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 22,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Check',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Verifyrbt',
                    ccode: 'Verifyrbt',
                    cname: '批量反审核',
                    cname2: 'Batch Reverify',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 23,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: '------',
                    ccode: '------',
                    cname: '------',
                    cname2: '',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 2,
                    ibtntypes: 0,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: '',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Cancelbt',
                    ccode: 'Cancelbt',
                    cname: '批量作废',
                    cname2: 'Batch Cancel',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 26,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Cancelrbt',
                    ccode: 'Cancelrbt',
                    cname: '批量反作废',
                    cname2: 'Batch Recancel',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 27,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                ],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'More',
                ccode: 'More',
                cname: '更多',
                cname2: 'More',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 0,
                isize: 1,
                imode: 0,
                ileft: 0,
                idisabled: 0,
                cicon1: 'Menu',
                cicon2: '',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Cancel',
                    ccode: 'Cancel',
                    cname: '作废',
                    cname2: 'Cancel',
                    cnameb: '反作废',
                    cnameb2: 'Recancel',
                    iname: 0,
                    ibtntype: 8,
                    ibtntypes: 17,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: 'Close',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                ],
              },
            ],
            detailbar: [
              {
                iindex: 0,
                id: '',
                cbar: 'Refresh',
                ccode: 'Refresh',
                cname: '刷新',
                cname2: '',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 1,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Refresh',
                cicon2: '',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Save',
                ccode: 'Save',
                cname: '保存',
                cname2: 'Save',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 2,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Check',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'New',
                ccode: 'New',
                cname: '新建',
                cname2: 'New',
                cnameb: '放弃',
                cnameb2: 'Abandon',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 3,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Plus',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Edit',
                ccode: 'Edit',
                cname: '编辑',
                cname2: 'Edit',
                cnameb: '放弃',
                cnameb2: 'Abandon',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 4,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Edit',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Verify',
                ccode: 'Verify',
                cname: '审核',
                cname2: 'Verify',
                cnameb: '反审核',
                cnameb2: 'Reverify',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 7,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Check',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Batch Oper',
                ccode: 'Batch Oper',
                cname: '批量操作',
                cname2: 'Batch Oper',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 9,
                ibtntypes: 0,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Menu',
                cicon2: '',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Verifybt',
                    ccode: 'Verifybt',
                    cname: '批量审核',
                    cname2: 'Batch Verify',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 22,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Check',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Verifyrbt',
                    ccode: 'Verifyrbt',
                    cname: '批量反审核',
                    cname2: 'Batch Reverify',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 23,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Cancelbt',
                    ccode: 'Cancelbt',
                    cname: '批量作废',
                    cname2: 'Batch Cancel',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 26,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Cancelrbt',
                    ccode: 'Cancelrbt',
                    cname: '批量反作废',
                    cname2: 'Batch Recancel',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 27,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                ],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'More',
                ccode: 'More',
                cname: '更多',
                cname2: 'More',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 0,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Menu',
                cicon2: '',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Cancel',
                    ccode: 'Cancel',
                    cname: '作废',
                    cname2: 'Cancel',
                    cnameb: '反作废',
                    cnameb2: 'Recancel',
                    iname: 0,
                    ibtntype: 8,
                    ibtntypes: 17,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: 'Close',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                ],
              },
            ],
            topbar: [
              {
                iindex: 0,
                id: '',
                cbar: 'Search',
                ccode: 'Search',
                cname: '搜索',
                cname2: 'Search',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 1,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Search',
                cicon2: 'Search',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Save',
                ccode: 'Save',
                cname: '保存',
                cname2: 'Save',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 2,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Check',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'New',
                ccode: 'New',
                cname: '新建',
                cname2: 'New',
                cnameb: '放弃',
                cnameb2: 'Abandon',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 3,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Plus',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Edit',
                ccode: 'Edit',
                cname: '编辑',
                cname2: 'Edit',
                cnameb: '放弃',
                cnameb2: 'Abandon',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 5,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Edit',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Verify',
                ccode: 'Verify',
                cname: '审核',
                cname2: 'Verify',
                cnameb: '反审核',
                cnameb2: 'Reverify',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 7,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Check',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Batch Oper',
                ccode: 'Batch Oper',
                cname: '批量操作',
                cname2: 'Batch Oper',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 9,
                ibtntypes: 0,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Menu',
                cicon2: '',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Verifybt',
                    ccode: 'Verifybt',
                    cname: '批量审核',
                    cname2: 'Batch Verify',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 22,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Check',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Verifyrbt',
                    ccode: 'Verifyrbt',
                    cname: '批量反审核',
                    cname2: 'Batch Reverify',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 23,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Cancelbt',
                    ccode: 'Cancelbt',
                    cname: '批量作废',
                    cname2: 'Batch Cancel',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 26,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Cancelrbt',
                    ccode: 'Cancelrbt',
                    cname: '批量反作废',
                    cname2: 'Batch Recancel',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 27,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                ],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'More',
                ccode: 'More',
                cname: '更多',
                cname2: 'More',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 0,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Menu',
                cicon2: '',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Cancel',
                    ccode: 'Cancel',
                    cname: '作废',
                    cname2: 'Cancel',
                    cnameb: '反作废',
                    cnameb2: 'Recancel',
                    iname: 0,
                    ibtntype: 8,
                    ibtntypes: 17,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: 'Close',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                ],
              },
            ],
            treebar: [
              {
                iindex: 0,
                id: '',
                cbar: 'Search',
                ccode: 'Search',
                cname: '搜索',
                cname2: 'Search',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 1,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Search',
                cicon2: 'Search',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Save',
                ccode: 'Save',
                cname: '保存',
                cname2: 'Save',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 2,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Check',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'New',
                ccode: 'New',
                cname: '新建根项',
                cname2: 'New Parent',
                cnameb: '放弃',
                cnameb2: 'Abandon',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 3,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Plus',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'NewChildren',
                ccode: 'NewChildren',
                cname: '新建子项',
                cname2: 'New Children',
                cnameb: '放弃',
                cnameb2: 'Abandon',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 13,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Plus',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Edit',
                ccode: 'Edit',
                cname: '编辑',
                cname2: 'Edit',
                cnameb: '放弃',
                cnameb2: 'Abandon',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 5,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Edit',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Verify',
                ccode: 'Verify',
                cname: '审核',
                cname2: 'Verify',
                cnameb: '反审核',
                cnameb2: 'Reverify',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 7,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Check',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Batch Oper',
                ccode: 'Batch Oper',
                cname: '批量操作',
                cname2: 'Batch Oper',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 9,
                ibtntypes: 0,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Menu',
                cicon2: '',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Verifybt',
                    ccode: 'Verifybt',
                    cname: '批量审核',
                    cname2: 'Batch Verify',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 22,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Check',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Verifyrbt',
                    ccode: 'Verifyrbt',
                    cname: '批量反审核',
                    cname2: 'Batch Reverify',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 23,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Cancelbt',
                    ccode: 'Cancelbt',
                    cname: '批量作废',
                    cname2: 'Batch Cancel',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 26,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Cancelrbt',
                    ccode: 'Cancelrbt',
                    cname: '批量反作废',
                    cname2: 'Batch Recancel',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 27,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                ],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'More',
                ccode: 'More',
                cname: '更多',
                cname2: 'More',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 0,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Menu',
                cicon2: '',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Cancel',
                    ccode: 'Cancel',
                    cname: '作废',
                    cname2: 'Cancel',
                    cnameb: '反作废',
                    cnameb2: 'Recancel',
                    iname: 0,
                    ibtntype: 8,
                    ibtntypes: 17,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: 'Close',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                ],
              },
            ],
          },
          PageVO: {
            lstbar: [
              {
                iindex: 0,
                id: '',
                cbar: 'Search',
                ccode: 'Search',
                cname: '搜索',
                cname2: 'Search',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 1,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Search',
                cicon2: 'Search',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'New',
                ccode: 'New',
                cname: '新建',
                cname2: 'New',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 3,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Plus',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Edit',
                ccode: 'Edit',
                cname: '编辑',
                cname2: 'Edit',
                cnameb: '放弃',
                cnameb2: 'Abandon',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 4,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Edit',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Moveid',
                ccode: 'Details',
                cname: '详情',
                cname2: 'Details',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 9,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'InfoFilled',
                cicon2: '',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Verify',
                ccode: 'Verify',
                cname: '审核',
                cname2: 'Verify',
                cnameb: '反审核',
                cnameb2: 'Reverify',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 7,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Check',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Batch Oper',
                ccode: 'Batch Oper',
                cname: '批量操作',
                cname2: 'Batch Oper',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 9,
                ibtntypes: 0,
                isize: 1,
                imode: 0,
                ileft: 0,
                idisabled: 0,
                cicon1: 'Menu',
                cicon2: '',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Verifybt',
                    ccode: 'Verifybt',
                    cname: '批量审核',
                    cname2: 'Batch Verify',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 22,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Check',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Verifyrbt',
                    ccode: 'Verifyrbt',
                    cname: '批量反审核',
                    cname2: 'Batch Reverify',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 23,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: '------',
                    ccode: '------',
                    cname: '------',
                    cname2: '',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 2,
                    ibtntypes: 0,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: '',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Cancelbt',
                    ccode: 'Cancelbt',
                    cname: '批量作废',
                    cname2: 'Batch Cancel',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 26,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Cancelrbt',
                    ccode: 'Cancelrbt',
                    cname: '批量反作废',
                    cname2: 'Batch Recancel',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 27,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                ],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'More',
                ccode: 'More',
                cname: '更多',
                cname2: 'More',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 0,
                isize: 1,
                imode: 0,
                ileft: 0,
                idisabled: 0,
                cicon1: 'Menu',
                cicon2: '',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Cancel',
                    ccode: 'Cancel',
                    cname: '作废',
                    cname2: 'Cancel',
                    cnameb: '反作废',
                    cnameb2: 'Recancel',
                    iname: 0,
                    ibtntype: 8,
                    ibtntypes: 17,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: 'Close',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                ],
              },
            ],
            detailbar: [
              {
                iindex: 0,
                id: '',
                cbar: 'Refresh',
                ccode: 'Refresh',
                cname: '刷新',
                cname2: '',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 1,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Refresh',
                cicon2: '',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Save',
                ccode: 'Save',
                cname: '保存',
                cname2: 'Save',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 2,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Check',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'New',
                ccode: 'New',
                cname: '新建',
                cname2: 'New',
                cnameb: '放弃',
                cnameb2: 'Abandon',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 3,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Plus',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Edit',
                ccode: 'Edit',
                cname: '编辑',
                cname2: 'Edit',
                cnameb: '放弃',
                cnameb2: 'Abandon',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 4,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Edit',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Verify',
                ccode: 'Verify',
                cname: '审核',
                cname2: 'Verify',
                cnameb: '反审核',
                cnameb2: 'Reverify',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 7,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Check',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Batch Oper',
                ccode: 'Batch Oper',
                cname: '批量操作',
                cname2: 'Batch Oper',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 9,
                ibtntypes: 0,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Menu',
                cicon2: '',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Verifybt',
                    ccode: 'Verifybt',
                    cname: '批量审核',
                    cname2: 'Batch Verify',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 22,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Check',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Verifyrbt',
                    ccode: 'Verifyrbt',
                    cname: '批量反审核',
                    cname2: 'Batch Reverify',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 23,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Cancelbt',
                    ccode: 'Cancelbt',
                    cname: '批量作废',
                    cname2: 'Batch Cancel',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 26,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Cancelrbt',
                    ccode: 'Cancelrbt',
                    cname: '批量反作废',
                    cname2: 'Batch Recancel',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 27,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                ],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'More',
                ccode: 'More',
                cname: '更多',
                cname2: 'More',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 0,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Menu',
                cicon2: '',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Cancel',
                    ccode: 'Cancel',
                    cname: '作废',
                    cname2: 'Cancel',
                    cnameb: '反作废',
                    cnameb2: 'Recancel',
                    iname: 0,
                    ibtntype: 8,
                    ibtntypes: 17,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: 'Close',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                ],
              },
            ],
            detbar: [
              {
                iindex: 0,
                id: '',
                cbar: 'AddRow',
                ccode: 'AddRow',
                cname: '增行',
                cname2: 'Add Row',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 11,
                ibtntypes: 80,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: '',
                cicon2: '',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'RowImport',
                ccode: 'RowImport',
                cname: '导入',
                cname2: 'Import',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 11,
                ibtntypes: 81,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: '',
                cicon2: '',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              // {
              //   iindex: 0,
              //   id: '',
              //   cbar: 'RowExport',
              //   ccode: 'RowExport',
              //   cname: '导出',
              //   cname2: 'Export',
              //   cnameb: '',
              //   cnameb2: '',
              //   iname: 0,
              //   ibtntype: 11,
              //   ibtntypes: 82,
              //   isize: 1,
              //   imode: 0,
              //   ileft: 1,
              //   idisabled: 0,
              //   cicon1: '',
              //   cicon2: '',
              //   icust: 0,
              //   ioper: 0,
              //   cview: '',
              //   cobject: '',
              //   coper: '',
              //   cparams: '',
              //   coper2: '',
              //   cparams2: '',
              //   idparent: '',
              //   itype: 1,
              //   iorder: 0,
              //   hasChildren: false,
              //   children: [],
              // },
            ],
            topbar: [
              {
                iindex: 0,
                id: '',
                cbar: 'Refresh',
                ccode: 'Refresh',
                cname: '刷新',
                cname2: '',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 0,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Refresh',
                cicon2: '',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Save',
                ccode: 'Save',
                cname: '保存',
                cname2: 'Save',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 2,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Check',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'New',
                ccode: 'New',
                cname: '新建',
                cname2: 'New',
                cnameb: '放弃',
                cnameb2: 'Abandon',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 3,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Plus',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Edit',
                ccode: 'Edit',
                cname: '编辑',
                cname2: 'Edit',
                cnameb: '放弃',
                cnameb2: 'Abandon',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 4,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Edit',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Verify',
                ccode: 'Verify',
                cname: '审核',
                cname2: 'Verify',
                cnameb: '反审核',
                cnameb2: 'Reverify',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 7,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Check',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Output',
                ccode: 'Output',
                cname: '输出',
                cname2: 'Output',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 9,
                ibtntypes: 0,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Menu',
                cicon2: '',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Print',
                    ccode: 'Print',
                    cname: '打印',
                    cname2: 'Print',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 10,
                    ibtntypes: 70,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Printer',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'OutputExcel',
                    ccode: 'OutputExcel',
                    cname: '输出 Excel',
                    cname2: 'OutputExcel',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 10,
                    ibtntypes: 71,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Document',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'OutputPdf',
                    ccode: 'OutputPdf',
                    cname: '输出 Pdf',
                    cname2: 'OutputPdf',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 10,
                    ibtntypes: 72,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Document',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                ],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'More',
                ccode: 'More',
                cname: '更多',
                cname2: 'More',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 0,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Menu',
                cicon2: '',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Cancel',
                    ccode: 'Cancel',
                    cname: '作废',
                    cname2: 'Cancel',
                    cnameb: '反作废',
                    cnameb2: 'Recancel',
                    iname: 0,
                    ibtntype: 8,
                    ibtntypes: 17,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: 'Close',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  }, {
                    iindex: 0,
                    id: '',
                    cbar: '',
                    ccode: '',
                    cname: '',
                    cname2: '',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 8,
                    ibtntypes: 17,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 1,
                    cicon1: '',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  }, {
                    iindex: 0,
                    id: '',
                    cbar: 'Delete',
                    ccode: 'Delete',
                    cname: '删除',
                    cname2: '',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 8,
                    ibtntypes: 18,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: 'Close',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                ],
              },
            ],
            treebar: [
              {
                iindex: 0,
                id: '',
                cbar: 'Search',
                ccode: 'Search',
                cname: '搜索',
                cname2: 'Search',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 1,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Search',
                cicon2: 'Search',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Save',
                ccode: 'Save',
                cname: '保存',
                cname2: 'Save',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 2,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Check',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'New',
                ccode: 'New',
                cname: '新建根项',
                cname2: 'New Parent',
                cnameb: '放弃',
                cnameb2: 'Abandon',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 3,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Plus',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'NewChildren',
                ccode: 'NewChildren',
                cname: '新建子项',
                cname2: 'New Children',
                cnameb: '放弃',
                cnameb2: 'Abandon',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 13,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Plus',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Edit',
                ccode: 'Edit',
                cname: '编辑',
                cname2: 'Edit',
                cnameb: '放弃',
                cnameb2: 'Abandon',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 5,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Edit',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Verify',
                ccode: 'Verify',
                cname: '审核',
                cname2: 'Verify',
                cnameb: '反审核',
                cnameb2: 'Reverify',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 7,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Check',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Batch Oper',
                ccode: 'Batch Oper',
                cname: '批量操作',
                cname2: 'Batch Oper',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 9,
                ibtntypes: 0,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Menu',
                cicon2: '',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Verifybt',
                    ccode: 'Verifybt',
                    cname: '批量审核',
                    cname2: 'Batch Verify',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 22,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Check',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Verifyrbt',
                    ccode: 'Verifyrbt',
                    cname: '批量反审核',
                    cname2: 'Batch Reverify',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 23,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Cancelbt',
                    ccode: 'Cancelbt',
                    cname: '批量作废',
                    cname2: 'Batch Cancel',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 26,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Cancelrbt',
                    ccode: 'Cancelrbt',
                    cname: '批量反作废',
                    cname2: 'Batch Recancel',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 27,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                ],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'More',
                ccode: 'More',
                cname: '更多',
                cname2: 'More',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 0,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Menu',
                cicon2: '',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Cancel',
                    ccode: 'Cancel',
                    cname: '作废',
                    cname2: 'Cancel',
                    cnameb: '反作废',
                    cnameb2: 'Recancel',
                    iname: 0,
                    ibtntype: 8,
                    ibtntypes: 17,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: 'Close',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                ],
              },
            ],
          },
          PageLI: {
            lstbar: [
              {
                iindex: 0,
                id: '',
                cbar: 'Search',
                ccode: 'Search',
                cname: '搜索',
                cname2: 'Search',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 1,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Search',
                cicon2: 'Search',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'New',
                ccode: 'New',
                cname: '新建',
                cname2: 'New',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 3,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Plus',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Edit',
                ccode: 'Edit',
                cname: '编辑',
                cname2: 'Edit',
                cnameb: '放弃',
                cnameb2: 'Abandon',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 4,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Edit',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Moveid',
                ccode: 'Details',
                cname: '详情',
                cname2: 'Details',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 9,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'InfoFilled',
                cicon2: '',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Verify',
                ccode: 'Verify',
                cname: '审核',
                cname2: 'Verify',
                cnameb: '反审核',
                cnameb2: 'Reverify',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 7,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Check',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Batch Oper',
                ccode: 'Batch Oper',
                cname: '批量操作',
                cname2: 'Batch Oper',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 9,
                ibtntypes: 0,
                isize: 1,
                imode: 0,
                ileft: 0,
                idisabled: 0,
                cicon1: 'Menu',
                cicon2: '',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Verifybt',
                    ccode: 'Verifybt',
                    cname: '批量审核',
                    cname2: 'Batch Verify',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 22,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Check',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Verifyrbt',
                    ccode: 'Verifyrbt',
                    cname: '批量反审核',
                    cname2: 'Batch Reverify',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 23,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: '------',
                    ccode: '------',
                    cname: '------',
                    cname2: '',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 2,
                    ibtntypes: 0,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: '',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Cancelbt',
                    ccode: 'Cancelbt',
                    cname: '批量作废',
                    cname2: 'Batch Cancel',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 26,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Cancelrbt',
                    ccode: 'Cancelrbt',
                    cname: '批量反作废',
                    cname2: 'Batch Recancel',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 27,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                ],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'More',
                ccode: 'More',
                cname: '更多',
                cname2: 'More',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 0,
                isize: 1,
                imode: 0,
                ileft: 0,
                idisabled: 0,
                cicon1: 'Menu',
                cicon2: '',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Cancel',
                    ccode: 'Cancel',
                    cname: '作废',
                    cname2: 'Cancel',
                    cnameb: '反作废',
                    cnameb2: 'Recancel',
                    iname: 0,
                    ibtntype: 8,
                    ibtntypes: 17,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: 'Close',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                ],
              },
            ],
            detailbar: [
              {
                iindex: 0,
                id: '',
                cbar: 'Refresh',
                ccode: 'Refresh',
                cname: '刷新',
                cname2: '',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 1,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Refresh',
                cicon2: '',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Save',
                ccode: 'Save',
                cname: '保存',
                cname2: 'Save',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 2,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Check',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'New',
                ccode: 'New',
                cname: '新建',
                cname2: 'New',
                cnameb: '放弃',
                cnameb2: 'Abandon',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 3,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Plus',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Edit',
                ccode: 'Edit',
                cname: '编辑',
                cname2: 'Edit',
                cnameb: '放弃',
                cnameb2: 'Abandon',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 4,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Edit',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Verify',
                ccode: 'Verify',
                cname: '审核',
                cname2: 'Verify',
                cnameb: '反审核',
                cnameb2: 'Reverify',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 7,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Check',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Batch Oper',
                ccode: 'Batch Oper',
                cname: '批量操作',
                cname2: 'Batch Oper',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 9,
                ibtntypes: 0,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Menu',
                cicon2: '',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Verifybt',
                    ccode: 'Verifybt',
                    cname: '批量审核',
                    cname2: 'Batch Verify',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 22,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Check',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Verifyrbt',
                    ccode: 'Verifyrbt',
                    cname: '批量反审核',
                    cname2: 'Batch Reverify',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 23,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Cancelbt',
                    ccode: 'Cancelbt',
                    cname: '批量作废',
                    cname2: 'Batch Cancel',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 26,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Cancelrbt',
                    ccode: 'Cancelrbt',
                    cname: '批量反作废',
                    cname2: 'Batch Recancel',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 27,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                ],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'More',
                ccode: 'More',
                cname: '更多',
                cname2: 'More',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 0,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Menu',
                cicon2: '',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Cancel',
                    ccode: 'Cancel',
                    cname: '作废',
                    cname2: 'Cancel',
                    cnameb: '反作废',
                    cnameb2: 'Recancel',
                    iname: 0,
                    ibtntype: 8,
                    ibtntypes: 17,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: 'Close',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                ],
              },
            ],
            topbar: [
              {
                iindex: 0,
                id: '',
                cbar: 'Search',
                ccode: 'Search',
                cname: '搜索',
                cname2: 'Search',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 1,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Search',
                cicon2: 'Search',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Save',
                ccode: 'Save',
                cname: '保存',
                cname2: 'Save',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 2,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Check',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'New',
                ccode: 'New',
                cname: '新建',
                cname2: 'New',
                cnameb: '放弃',
                cnameb2: 'Abandon',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 3,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Plus',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Edit',
                ccode: 'Edit',
                cname: '编辑',
                cname2: 'Edit',
                cnameb: '放弃',
                cnameb2: 'Abandon',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 5,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Edit',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Verify',
                ccode: 'Verify',
                cname: '审核',
                cname2: 'Verify',
                cnameb: '反审核',
                cnameb2: 'Reverify',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 7,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Check',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Batch Oper',
                ccode: 'Batch Oper',
                cname: '批量操作',
                cname2: 'Batch Oper',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 9,
                ibtntypes: 0,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Menu',
                cicon2: '',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Verifybt',
                    ccode: 'Verifybt',
                    cname: '批量审核',
                    cname2: 'Batch Verify',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 22,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Check',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Verifyrbt',
                    ccode: 'Verifyrbt',
                    cname: '批量反审核',
                    cname2: 'Batch Reverify',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 23,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Cancelbt',
                    ccode: 'Cancelbt',
                    cname: '批量作废',
                    cname2: 'Batch Cancel',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 26,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Cancelrbt',
                    ccode: 'Cancelrbt',
                    cname: '批量反作废',
                    cname2: 'Batch Recancel',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 27,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                ],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'More',
                ccode: 'More',
                cname: '更多',
                cname2: 'More',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 0,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Menu',
                cicon2: '',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Cancel',
                    ccode: 'Cancel',
                    cname: '作废',
                    cname2: 'Cancel',
                    cnameb: '反作废',
                    cnameb2: 'Recancel',
                    iname: 0,
                    ibtntype: 8,
                    ibtntypes: 17,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: 'Close',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                ],
              },
            ],
            treebar: [
              {
                iindex: 0,
                id: '',
                cbar: 'Search',
                ccode: 'Search',
                cname: '搜索',
                cname2: 'Search',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 1,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Search',
                cicon2: 'Search',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Save',
                ccode: 'Save',
                cname: '保存',
                cname2: 'Save',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 2,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Check',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'New',
                ccode: 'New',
                cname: '新建根项',
                cname2: 'New Parent',
                cnameb: '放弃',
                cnameb2: 'Abandon',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 3,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Plus',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'NewChildren',
                ccode: 'NewChildren',
                cname: '新建子项',
                cname2: 'New Children',
                cnameb: '放弃',
                cnameb2: 'Abandon',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 13,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Plus',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Edit',
                ccode: 'Edit',
                cname: '编辑',
                cname2: 'Edit',
                cnameb: '放弃',
                cnameb2: 'Abandon',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 5,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Edit',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Verify',
                ccode: 'Verify',
                cname: '审核',
                cname2: 'Verify',
                cnameb: '反审核',
                cnameb2: 'Reverify',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 7,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Check',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Batch Oper',
                ccode: 'Batch Oper',
                cname: '批量操作',
                cname2: 'Batch Oper',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 9,
                ibtntypes: 0,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Menu',
                cicon2: '',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Verifybt',
                    ccode: 'Verifybt',
                    cname: '批量审核',
                    cname2: 'Batch Verify',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 22,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Check',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Verifyrbt',
                    ccode: 'Verifyrbt',
                    cname: '批量反审核',
                    cname2: 'Batch Reverify',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 23,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Cancelbt',
                    ccode: 'Cancelbt',
                    cname: '批量作废',
                    cname2: 'Batch Cancel',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 26,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Cancelrbt',
                    ccode: 'Cancelrbt',
                    cname: '批量反作废',
                    cname2: 'Batch Recancel',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 27,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                ],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'More',
                ccode: 'More',
                cname: '更多',
                cname2: 'More',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 0,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Menu',
                cicon2: '',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Cancel',
                    ccode: 'Cancel',
                    cname: '作废',
                    cname2: 'Cancel',
                    cnameb: '反作废',
                    cnameb2: 'Recancel',
                    iname: 0,
                    ibtntype: 8,
                    ibtntypes: 17,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: 'Close',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                ],
              },
            ],
          },
          PageBD: {
            lstbar: [
              {
                iindex: 0,
                id: '',
                cbar: 'Search',
                ccode: 'Search',
                cname: '搜索',
                cname2: 'Search',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 1,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Search',
                cicon2: 'Search',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'New',
                ccode: 'New',
                cname: '新建',
                cname2: 'New',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 3,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Plus',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Edit',
                ccode: 'Edit',
                cname: '编辑',
                cname2: 'Edit',
                cnameb: '放弃',
                cnameb2: 'Abandon',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 4,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Edit',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Moveid',
                ccode: 'Details',
                cname: '详情',
                cname2: 'Details',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 9,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'InfoFilled',
                cicon2: '',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Verify',
                ccode: 'Verify',
                cname: '审核',
                cname2: 'Verify',
                cnameb: '反审核',
                cnameb2: 'Reverify',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 7,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Check',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Batch Oper',
                ccode: 'Batch Oper',
                cname: '批量操作',
                cname2: 'Batch Oper',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 9,
                ibtntypes: 0,
                isize: 1,
                imode: 0,
                ileft: 0,
                idisabled: 0,
                cicon1: 'Menu',
                cicon2: '',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Verifybt',
                    ccode: 'Verifybt',
                    cname: '批量审核',
                    cname2: 'Batch Verify',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 22,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Check',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Verifyrbt',
                    ccode: 'Verifyrbt',
                    cname: '批量反审核',
                    cname2: 'Batch Reverify',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 23,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: '------',
                    ccode: '------',
                    cname: '------',
                    cname2: '',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 2,
                    ibtntypes: 0,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: '',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Cancelbt',
                    ccode: 'Cancelbt',
                    cname: '批量作废',
                    cname2: 'Batch Cancel',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 26,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Cancelrbt',
                    ccode: 'Cancelrbt',
                    cname: '批量反作废',
                    cname2: 'Batch Recancel',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 27,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                ],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'More',
                ccode: 'More',
                cname: '更多',
                cname2: 'More',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 0,
                isize: 1,
                imode: 0,
                ileft: 0,
                idisabled: 0,
                cicon1: 'Menu',
                cicon2: '',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Cancel',
                    ccode: 'Cancel',
                    cname: '作废',
                    cname2: 'Cancel',
                    cnameb: '反作废',
                    cnameb2: 'Recancel',
                    iname: 0,
                    ibtntype: 8,
                    ibtntypes: 17,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: 'Close',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                ],
              },
            ],
            detailbar: [
              {
                iindex: 0,
                id: '',
                cbar: 'Refresh',
                ccode: 'Refresh',
                cname: '刷新',
                cname2: '',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 1,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Refresh',
                cicon2: '',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Save',
                ccode: 'Save',
                cname: '保存',
                cname2: 'Save',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 2,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Check',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'New',
                ccode: 'New',
                cname: '新建',
                cname2: 'New',
                cnameb: '放弃',
                cnameb2: 'Abandon',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 3,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Plus',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Edit',
                ccode: 'Edit',
                cname: '编辑',
                cname2: 'Edit',
                cnameb: '放弃',
                cnameb2: 'Abandon',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 4,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Edit',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Verify',
                ccode: 'Verify',
                cname: '审核',
                cname2: 'Verify',
                cnameb: '反审核',
                cnameb2: 'Reverify',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 7,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Check',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Batch Oper',
                ccode: 'Batch Oper',
                cname: '批量操作',
                cname2: 'Batch Oper',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 9,
                ibtntypes: 0,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Menu',
                cicon2: '',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Verifybt',
                    ccode: 'Verifybt',
                    cname: '批量审核',
                    cname2: 'Batch Verify',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 22,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Check',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Verifyrbt',
                    ccode: 'Verifyrbt',
                    cname: '批量反审核',
                    cname2: 'Batch Reverify',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 23,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Cancelbt',
                    ccode: 'Cancelbt',
                    cname: '批量作废',
                    cname2: 'Batch Cancel',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 26,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Cancelrbt',
                    ccode: 'Cancelrbt',
                    cname: '批量反作废',
                    cname2: 'Batch Recancel',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 27,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                ],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'More',
                ccode: 'More',
                cname: '更多',
                cname2: 'More',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 0,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Menu',
                cicon2: '',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Cancel',
                    ccode: 'Cancel',
                    cname: '作废',
                    cname2: 'Cancel',
                    cnameb: '反作废',
                    cnameb2: 'Recancel',
                    iname: 0,
                    ibtntype: 8,
                    ibtntypes: 17,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: 'Close',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                ],
              },
            ],
            topbar: [
              {
                iindex: 0,
                id: '',
                cbar: 'Search',
                ccode: 'Search',
                cname: '搜索',
                cname2: 'Search',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 1,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Search',
                cicon2: 'Search',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Save',
                ccode: 'Save',
                cname: '保存',
                cname2: 'Save',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 2,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Check',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'New',
                ccode: 'New',
                cname: '新建',
                cname2: 'New',
                cnameb: '放弃',
                cnameb2: 'Abandon',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 3,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Plus',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Edit',
                ccode: 'Edit',
                cname: '编辑',
                cname2: 'Edit',
                cnameb: '放弃',
                cnameb2: 'Abandon',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 5,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Edit',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Verify',
                ccode: 'Verify',
                cname: '审核',
                cname2: 'Verify',
                cnameb: '反审核',
                cnameb2: 'Reverify',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 7,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Check',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Batch Oper',
                ccode: 'Batch Oper',
                cname: '批量操作',
                cname2: 'Batch Oper',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 9,
                ibtntypes: 0,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Menu',
                cicon2: '',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Verifybt',
                    ccode: 'Verifybt',
                    cname: '批量审核',
                    cname2: 'Batch Verify',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 22,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Check',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Verifyrbt',
                    ccode: 'Verifyrbt',
                    cname: '批量反审核',
                    cname2: 'Batch Reverify',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 23,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Cancelbt',
                    ccode: 'Cancelbt',
                    cname: '批量作废',
                    cname2: 'Batch Cancel',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 26,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Cancelrbt',
                    ccode: 'Cancelrbt',
                    cname: '批量反作废',
                    cname2: 'Batch Recancel',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 27,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                ],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'More',
                ccode: 'More',
                cname: '更多',
                cname2: 'More',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 0,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Menu',
                cicon2: '',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Cancel',
                    ccode: 'Cancel',
                    cname: '作废',
                    cname2: 'Cancel',
                    cnameb: '反作废',
                    cnameb2: 'Recancel',
                    iname: 0,
                    ibtntype: 8,
                    ibtntypes: 17,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: 'Close',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                ],
              },
            ],
            treebar: [
              {
                iindex: 0,
                id: '',
                cbar: 'Search',
                ccode: 'Search',
                cname: '搜索',
                cname2: 'Search',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 1,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Search',
                cicon2: 'Search',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Save',
                ccode: 'Save',
                cname: '保存',
                cname2: 'Save',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 2,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Check',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'New',
                ccode: 'New',
                cname: '新建根项',
                cname2: 'New Parent',
                cnameb: '放弃',
                cnameb2: 'Abandon',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 3,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Plus',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'NewChildren',
                ccode: 'NewChildren',
                cname: '新建子项',
                cname2: 'New Children',
                cnameb: '放弃',
                cnameb2: 'Abandon',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 13,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Plus',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Edit',
                ccode: 'Edit',
                cname: '编辑',
                cname2: 'Edit',
                cnameb: '放弃',
                cnameb2: 'Abandon',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 5,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Edit',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Verify',
                ccode: 'Verify',
                cname: '审核',
                cname2: 'Verify',
                cnameb: '反审核',
                cnameb2: 'Reverify',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 7,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Check',
                cicon2: 'Close',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'Batch Oper',
                ccode: 'Batch Oper',
                cname: '批量操作',
                cname2: 'Batch Oper',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 9,
                ibtntypes: 0,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Menu',
                cicon2: '',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Verifybt',
                    ccode: 'Verifybt',
                    cname: '批量审核',
                    cname2: 'Batch Verify',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 22,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Check',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Verifyrbt',
                    ccode: 'Verifyrbt',
                    cname: '批量反审核',
                    cname2: 'Batch Reverify',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 23,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Cancelbt',
                    ccode: 'Cancelbt',
                    cname: '批量作废',
                    cname2: 'Batch Cancel',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 26,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Cancelrbt',
                    ccode: 'Cancelrbt',
                    cname: '批量反作废',
                    cname2: 'Batch Recancel',
                    cnameb: '',
                    cnameb2: '',
                    iname: 0,
                    ibtntype: 9,
                    ibtntypes: 27,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: '',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                ],
              },
              {
                iindex: 0,
                id: '',
                cbar: 'More',
                ccode: 'More',
                cname: '更多',
                cname2: 'More',
                cnameb: '',
                cnameb2: '',
                iname: 0,
                ibtntype: 8,
                ibtntypes: 0,
                isize: 1,
                imode: 0,
                ileft: 1,
                idisabled: 0,
                cicon1: 'Menu',
                cicon2: '',
                icust: 0,
                ioper: 0,
                cview: '',
                cobject: '',
                coper: '',
                cparams: '',
                coper2: '',
                cparams2: '',
                idparent: '',
                itype: 1,
                iorder: 0,
                hasChildren: false,
                children: [
                  {
                    iindex: 0,
                    id: '',
                    cbar: 'Cancel',
                    ccode: 'Cancel',
                    cname: '作废',
                    cname2: 'Cancel',
                    cnameb: '反作废',
                    cnameb2: 'Recancel',
                    iname: 0,
                    ibtntype: 8,
                    ibtntypes: 17,
                    isize: 1,
                    imode: 0,
                    ileft: 1,
                    idisabled: 0,
                    cicon1: 'Close',
                    cicon2: 'Close',
                    icust: 0,
                    ioper: 0,
                    cview: '',
                    cobject: '',
                    coper: '',
                    cparams: '',
                    coper2: '',
                    cparams2: '',
                    idparent: '',
                    itype: 1,
                    iorder: 0,
                    hasChildren: false,
                    children: [],
                  },
                ],
              },
            ],
          },
        },
        optstatus: [
          { value: 0, label: '新建' },
          { value: 20, label: '审核' },
          { value: 99, label: '有效' },
          { value: -80, label: '作废' },
        ],
      }),
    $objdata: () =>
      deepCopy({
        btn: {
          new: 0,
          verify: 0,
          verifybt: 0,
          verifyrbt: 0,
          commit: 0,
          commitbt: 0,
          commitrbt: 0,
          cancel: 0,
          cancelbt: 0,
          cancelrbt: 0,
          cansync: 0,
          changeln: 0,
          send: 0,
          newaddr: 0,
          showpwd: 0,
          inipwd: 0,
          using: 0,
          usingbt: 0,
          usingrbt: 0,
          usingaddr: 0,
          ktyear: 0,
          showio: 0,
          import: 0,
          sync: 0,
          chgcustfi: 0,
          custfihis: 0,
          checkng: 0,
          close: 0,
          sync_dn: 0,
          save_14064: 0,
          delicr: 0,
          crcycle: 0,
          repair: 0,
        },
        props: null,
        inewtype: 0,
        iflag: 0,
        loading: false,
        isshowatt: true,
        isshowwf: true,
        isshowstate: false,
        showadd: false,
        printlst: [],
        sellst: [],
        // 流程
        wf: {
          idwf: '',
          idwfe: '',
          copright: '',
          id_td: '',
          isorttype: 0, // 0：顺序 1：逆序
          canreply: false,
          isload: false,
        },
        //缺省业务类型
        vouch: {
          idvouch: '',
          ccodevouch: '',
          cnamevouch: '',
          idvouchr: '',
          iinout: 0,
          iinouth: 0,
          idobject: '',
          ctableflow: '',
          ctablebus: '',
          idbustype: '',
          ccodebustype: '',
          cnamebustype: '',
          idbustype2: '',
          cnamebustype2: '',
          idpayway: '',
          cnamepayway: '',
          idarapitem: '',
          cnamearapitem: '',
          iwf: 0,
          idwf: '',
          cnamewf: '',
          idwf2: '',
          cnamewf2: '',
          isearch: 0,
        },
        paras: {},
        views: {},
        //数据
        data: {
          head: {
            id: '',
            idwf: '',
            cnamewf: '',
            iwf: 0,
            idwfe: '',
            ctheme: '',
            ccode: '',
            ddate: new Date(),
            idbustype: '',
            ccodebustype: '',
            idvouch: '',
            ccodevouch: '',
            cnamevouch: '',
            idvouchr: '',
            iddept: '',
            cbardept: '',
            ccodedept: '',
            cnamedept: '',
            idpsn: '',
            cnamepsn: '',
            dmake: new Date(),
            idmaker: '',
            cmaker: '',
            cmodifier: '',
            dverify: null,
            cverifier: '',
            istatus: 0,
          },
        },
        del: {},
        islst: {},
        detailsdel: [],
        detailbdel: [],
        afdel: [],
        index: -1,
        currrow: null, //当前行
        icurrrow: -1,
        newrow: null, //新行
        inewrow: -1,
        index_s: -1,
        currrow_s: null, //当前行
        init: {
          iorder: 0,
          iindex: 0,
          istatus: 0,
          cstatus: '',
          irowstatus: 2,
          dmodify: new Date(),
        },
        initctl: {
          iorder: 0,
          iindex: 0,
          istatus: 0,
          cstatus: '',
          irowstatus: 2,
          dmodify: new Date(),
        },
        init_new: {},
        print: {
          itype: 0,
          ctitle: '',
        },
        // table形式
        status: {
          iflag: 0,
          icol: 3,
          ilayout: 2,
        },
        // flex
        statusf: {
          iflag: 0,
          icol: 3,
          ilayout: 0,
        },
        columns: {
          head: [],
          details: [],
        },
        com: {
          head: false,
          details: false,
        },
        init_res: {},
        focus: {},
        rowlazy: {},
        curr: {
          idparent: '',
          cbarparent: '',
          ccodeparent: '',
          cnameparent: '',
          itier: 0,
          idpath: '',
          cbarpath: '',
          ccodepath: '',
          cnamepath: '',
        },
        activeName: 'base',
        mnus: {},
        btnstatus: {
          isnew: false,
          cannew: false,
          isnew_children: false,
          cannew_children: false,
          isedit: false,
          canedit: false,
          canedit_base: false,
          cansave: false,
          iscommit: false,
          cancommit: false,
          isverify: false,
          canverify: false,
          isclose: false,
          canclose: false,
          iscancel: false,
          cancancel: false,
          candelete: false,
          canaddrow: false,
        },
        printRef: null,
      }),
  };
  app.provide('$proxy', app.config.globalProperties.$proxy);
}
class PageRP {
  constructor(config, objsearch, objdata, inidata) {
    try {
      this.config = config;
      this.objdata = objdata;
      this.objsearch = objsearch;
      this.detailinfo = this.config.proxy.$utils.comm.getRouteInfo(this.config.name);
      if (!this.detailinfo) this.detailinfo = { path: '', name: '', title: '' };
      this.objsearch.issearch = false;
      this.objsearch.loading = false;
      if (!this.objsearch.ipagesize) this.objsearch.ipagesize = 15;
      if (!this.objsearch.icurrpage) this.objsearch.icurrpage = 0;
      this.objsearch.list = [];
      //权限
      if (!this.objsearch.btn) this.objsearch.btn = {};
      if (inidata && inidata.rolst) {
        for (let i1 = 0; i1 <= inidata.rolst.length - 1; i1++) {
          objdata.btn[inidata.rolst[i1].cbaroper] = 1;
        }
      }
      //列字段
      if (!this.objsearch.columns) this.objsearch.columns = {};
      if (!this.objsearch.com) this.objsearch.com = {};
      let result = {};
      if (inidata && inidata.views && Object.keys(inidata.views).length != 0) {
        for (let key in inidata.views) {
          if (inidata.views.hasOwnProperty(key)) {
            if (
              inidata.views[key].tablelst &&
              Object.keys(inidata.views[key].tablelst).length != 0
            ) {
              let col = [];
              for (let key1 in inidata.views[key].tablelst) {
                if (inidata.views[key].head && inidata.views[key].head.ilayout != 3) {
                  col = col.concat(inidata.views[key].tablelst[key1]);
                  result[key] = col;
                } else {
                  for (let key2 in inidata.views[key].tablelst[key1]) {
                    col = col.concat(inidata.views[key].tablelst[key1][key2]);
                    result[key] = col;
                  }
                }
              }
            } else {
              // tablelst = {} 就取查找paras的
              if (inidata && inidata.paras) {
                if (inidata.paras.hasOwnProperty(key)) {
                  result[key] = inidata.paras[key];
                }
              }
            }
          }
        }
      } else if (inidata && inidata.paras) {
        for (let key in inidata.paras) {
          if (inidata.paras.hasOwnProperty(key)) {
            // 确保是对象自有属性，不是原型链上的属性
            result[key] = inidata.paras[key];
          }
        }
      }
      for (let key in result) {
        if (result.hasOwnProperty(key)) {
          // 确保是对象自有属性，不是原型链上的属性
          this.objsearch.columns[key] = result[key];
          this.objsearch.com[key] = true;
          this.objsearch.focus[key] = false;
        }
      }
      if (!this.objsearch.objini) this.objsearch.objini = {};
      if (inidata && inidata.objini) {
        for (let key in inidata.objini) {
          if (inidata.objini.hasOwnProperty(key)) {
            // 确保是对象自有属性，不是原型链上的属性
            this.objsearch.objini[key] = inidata.objini[key].replace(/[\r\n]+/g, '');
          }
        }
      }
    } catch (e1) {
      console.log('create error......', e1);
    }
  }
  exportExcel = () => {
    if (this.objsearch.selectRow.length == 0) {
      this.config.proxy.$notify({
        title: '系统提示',
        message: '请先搜索获取数据后勾选需要导出的数据',
        type: 'warning',
      });
      return;
    }
    this.config.proxy.$utils.export.exportExcelAll(
      this.objsearch.selectRow,
      this.objsearch.columns.list.filter(
        (item) => item.iignore == 0 && item.ihide == 0 && item.itype != 99
      ),
      this.config.detailinfo.title == '' ? '导出' : this.config.detailinfo.title
    );
    this.config.callback({ iresult: 0, cerror: '', coper: 'exportExcel', data: null });
    //ref_sel.value.clearSelection();
  };
  exportExcelAll = () => {
    if (this.objsearch.list.length == 0) {
      this.config.proxy.$notify({
        title: '系统提示',
        message: '无导出数据',
        type: 'warning',
      });
      return;
    }
    this.config.proxy.$utils.export.exportExcelAll(
      this.objsearch.list,
      this.objsearch.columns.list.filter(
        (item) => item.iignore == 0 && item.ihide == 0 && item.itype != 99
      ),
      this.config.detailinfo.title == '' ? '导出' : this.config.detailinfo.title
    );
    this.config.callback({ iresult: 0, cerror: '', coper: 'exportExcelAll', data: null });
    //ref_sel.value.clearSelection();
  };
  exportExcelback = (objpara) => {
    let params = {
      cobject: this.config.cobjectt,
      coper: 'export',
      objpara: {
        ctheme: this.config.detailinfo.title + '导出',
        cpagename: this.config.name,
        ...this.objsearch.filter,
        ...objpara,
      },
    };
    this.config.proxy.$execute(params).then((res) => {
      this.objsearch.loading = false;
      if (res.iresult > 300) {
        alert(res.cerror);
        return;
      }
      if (res.iresult == 0) {
        if (res.data.length == 0) {
          this.config.proxy.$notify({
            title: '系统提示',
            message: '无导出数据',
            type: 'warning',
          });
          return;
        }
        this.config.proxy.$utils.export.exportExcelAll(
          res.data.lst ? res.data.lst : res.data,
          this.objsearch.columns.list.filter(
            (item) => item.iignore == 0 && item.ihide == 0 && item.itype != 99
          ),
          this.config.detailinfo.title == '' ? '导出' : this.config.detailinfo.title
        );
        this.config.callback({
          iresult: 0,
          cerror: '',
          coper: 'exportExcelback',
          data: null,
        });
      } else if (res.iresult == 1) {
        this.config.proxy.$message({
          showClose: true,
          message: '已加入任务列表',
          type: 'success',
        });
      }
    });
  };
  fnFileDownload = (idfile, cnamefile, bdown) => {
    FileDownload(idfile, cnamefile, bdown, fnhandleDownload);
  };
  fnFilePreview = (idfile, cnamefile) => {
    FilePreview(idfile, cnamefile);
  };
  fnhandleDownload = (dataurl, contenttype, cnamefile, blob) => {
    switch (contenttype) {
      case 'image/png':
      case 'image/jpeg':
      case 'image/jpg':
      case 'application/pdf': {
        let page = window.open(dataurl);
        setTimeout(() => {
          page.document.title = cnamefile;
        }, 500);
        break;
      }
      case 'application/vnd.ms-excel':
        //后台导出excel
        break;
    }
  };
  fnexecute = (cobject, coper) => {
    let params = {
      cobject: cobject,
      coper: coper,
      objpara: {},
    };
    this.config.proxy.$execute(params).then((res) => {
      if (res.iresult != 0) {
        this.config.proxy.$msgbox.alert(res.cerror);
        return;
      }
      this.config.proxy.$message({
        showClose: true,
        message: '操作成功',
        type: 'success',
      });
    });
  };
  onSearch = () => {
    this.objsearch.icurrpage = 1;
    this.fnsearch(true);
  };
  fnsearch = (boolean) => {
    this.objsearch.issearch = true;
    let params = {
      cobject: this.config.cobjectt,
      coper: this.objsearch.search_oper != '' ? this.objsearch.search_oper : 'search',
      objpara: {
        ...this.objsearch.filter,
        ipagesize: this.objsearch.ipagesize,
        ipage: this.objsearch.icurrpage,
      },
    };
    this.config.proxy.$execute(params).then((res) => {
      if (res.iresult != 0) {
        this.config.proxy.$msgbox.alert(res.cerror);
        return;
      }
      this.objsearch.list.length = 0;
      if (res?.data?.hasOwnProperty('lst')) {
        this.objsearch.list.push(...res.data.lst);
        // if (boolean) {
        if (res?.data?.hasOwnProperty('itot')) this.objsearch.itot = res.data.itot;
        else if (res.data.sum) {
          if (res.data.sum.itot) this.objsearch.itot = res.data.sum.itot;
        } else if (
          this.objsearch.list.length !== 0 &&
          this.objsearch.list[0].itot !== null &&
          this.objsearch.list[0].itot !== 0 &&
          this.objsearch.list[0].itot &&
          boolean
        ) {
          this.objsearch.itot = this.objsearch.list[0].itot;
        } else {
          this.objsearch.itot = this.objsearch.list.length;
        }
        // }
      } else {
        this.objsearch.list.push(...res.data);
        if (boolean) {
          if (
            this.objsearch.list.length !== 0 &&
            this.objsearch.list[0].itot !== null &&
            this.objsearch.list[0].itot !== 0 &&
            this.objsearch.list[0].itot
          ) {
            this.objsearch.itot = this.objsearch.list[0].itot;
          } else {
            this.objsearch.itot = this.objsearch.list.length;
          }
        }
      }
      if (res.data.szmap) this.objsearch.szmap = res.data.szmap;
      this.objsearch.issearch = false;
      this.config.callback({ iresult: 0, cerror: '', coper: 'search', data: res.data });
    });
  };
  onSizeChange = (size) => {
    this.objsearch.ipagesize = size;
    this.fnsearch(false);
  };
  onCurrentChange = (currentPage) => {
    this.objsearch.icurrpage = currentPage;
    this.fnsearch(false);
  };
  fnload = (res, objpara) => {
    let params = {
      cobject: this.config.cobjectt,
      coperation: 'search',
      objparameter: objpara
        ? objpara
        : {
          ...this.objsearch.filter,
          idparent: res.id,
          ipagesize: this.objsearch.ipagesize,
          ipage: this.objsearch.icurrpage,
        },
    };
    this.config.proxy.$execute(params).then((result) => {
      if (result.iresult != 0) {
        alert(result.cerror);
        return;
      }
      this.objdata.rowlazy = res.rowlazy;
      if (result.data.lst) {
        res.callback(result.data.lst);
      } else res.callback(result.data);
    });
  };
  fnExpChange = (force, row, expanded, objpara) => {
    if (!row) return;
    // 获取到之前保存的全局变量
    const curr = this.objdata.rowlazy[row.id];
    // 展开次数 +1
    curr.expandCount++;
    // 如果是展开状态，且展开次数大于1，且上一次的状态为折叠，则请求api数据，更新子菜单
    if (expanded && (force || (curr.expandCount > 1 && !curr.prevStatus))) {
      let params = {
        cobject: this.config.cobjectt,
        coperation: 'search',
        objparameter: objpara
          ? objpara
          : {
            ...this.objsearch.filter,
            idparent: this.objdata.rowlazy[row.id].row.id,
            ipagesize: this.objsearch.ipagesize,
            ipage: this.objsearch.icurrpage,
          },
      };
      this.config.proxy.$execute(params).then((res) => {
        if (res.iresult != 0) {
          alert(res.cerror);
          return;
        }
        if (res?.data?.hasOwnProperty('lst')) {
          curr.resolve(res.data.lst);
        } else curr.resolve(res.data);
      });
    }
    // 保存本次的展开或折叠状态，用于下次判断
    curr.prevStatus = expanded;
  };
  onSelectData = (res) => {
    this.objsearch.selectRow = res.data;
  };
  onSelAll = (res) => {
    this.objsearch.selectRow = res.data;
  };
  fnselectrow = (res) => {
    this.objsearch.currrow = res.data.row;
  };
  fndbselectrow = (res) => {
    this.objsearch.currrow = res.data.row;
  };
  cansel = (res) => {
    if (res.data.row.id == '') {
      return false;
    } else {
      return true;
    }
  };
  onChange = (res) => {
    if (!res) return;
    let cscope = res.cscope ? res.cscope : '';
    let cfield = res.cfield ? res.cfield : '';
    let itype = res.column.itype ? res.column.itype : 0;
    let isearch = res.column.isearch ? res.column.isearch : 0;
    switch (cscope) {
      case 'filter':
        this.onSearch();
        break;
    }
  };
  onSaveSwitch = (res) => {
    setTimeout(() => {
      let params = {
        cobject: this.config.cobjectt,
        coperation: 'save_switch',
        objparameter: {
          id: res.data.id,
          iswitch: res.data.value,
          cswitch: res.data.cswitch,
          [res.data.cswitch]: res.data.value,
        },
      };
      this.config.proxy.$execute(params).then((res) => {
        if (res.iresult != 0) {
          alert(res.cerror);
          return;
        }
        this.config.proxy.$message({
          showClose: true,
          message: '修改成功~',
          type: 'success',
        });
      });
    }, 300);
  };
  focusSelect = (event) => {
    if ('select' in event.target && typeof event.target.select == 'function') {
      event.target.select();
    }
  };
  getRowKeys = (row) => {
    return row.id;
  };
  fncreateobj = (cobj) => {
    let obj = null;
    let temp = null;
    let isAllSpaces = false;
    try {
      if (this.objsearch.columns[cobj]) {
        obj = {};
        for (let i1 = 0; i1 < this.objsearch.columns[cobj].length; i1++) {
          if (this.objsearch.columns[cobj][i1].cfield == '') {
            switch (this.objsearch.columns[cobj][i1].cobject) {
              case 'i':
                obj[this.objsearch.columns[cobj][i1].prop] = 0;
                continue;
              case 'o':
                obj[this.objsearch.columns[cobj][i1].prop] = {};
                continue;
              case 'a':
                obj[this.objsearch.columns[cobj][i1].prop] = [];
                continue;
            }
          }
          if (
            this.objsearch.columns[cobj][i1].cdefault &&
            this.objsearch.columns[cobj][i1].cdefault != '' &&
            this.objsearch.columns[cobj][i1].cdefault.startsWith('props')
          ) {
            let params = this.objsearch.columns[cobj][i1].cdefault.split('.');
            if (params.length >= 2) {
              obj[this.objsearch.columns[cobj][i1].prop] = this.objdata.props[params[1]];
            }
          } else if (
            this.objsearch.columns[cobj][i1].cdefault &&
            this.objsearch.columns[cobj][i1].cdefault != '' &&
            this.objsearch.columns[cobj][i1].cdefault.startsWith('paras')
          ) {
            let params = this.objsearch.columns[cobj][i1].cdefault.split('.');
            if (params.length >= 2) {
              obj[this.objdata.columns[cobj][i1].prop] = this.objdata.paras[params[1]];
            }
          } else {
            switch (this.objsearch.columns[cobj][i1].itype) {
              case 5:
                if (
                  this.objsearch.columns[cobj][i1].cdefault &&
                  this.objsearch.columns[cobj][i1].cdefault != ''
                ) {
                  isAllSpaces = /^ +$/.test(this.objsearch.columns[cobj][i1].cdefault);
                  temp = parseInt(this.objsearch.columns[cobj][i1].cdefault);
                  if (isAllSpaces)
                    obj[this.objsearch.columns[cobj][i1].prop] = this.objsearch.columns[
                      cobj
                    ][i1].cdefault;
                  else if (!isNaN(temp))
                    obj[this.objsearch.columns[cobj][i1].prop] = temp;
                  else if (this.objsearch.columns[cobj][i1].option.length > 0)
                    obj[this.objsearch.columns[cobj][i1].prop] = this.objsearch.columns[
                      cobj
                    ][i1].option[0].value;
                  else obj[this.objsearch.columns[cobj][i1].prop] = 0;
                } else {
                  if (this.objsearch.columns[cobj][i1].option.length > 0)
                    obj[this.objsearch.columns[cobj][i1].prop] = this.objsearch.columns[
                      cobj
                    ][i1].option[0].value;
                  else obj[this.objsearch.columns[cobj][i1].prop] = 0;
                }
                break;
              case 51:
                if (
                  this.objsearch.columns[cobj][i1].cdefault &&
                  this.objsearch.columns[cobj][i1].cdefault != ''
                ) {
                  isAllSpaces = /^ +$/.test(this.objsearch.columns[cobj][i1].cdefault);
                  temp = parseInt(this.objsearch.columns[cobj][i1].cdefault);
                  if (isAllSpaces)
                    obj[this.objsearch.columns[cobj][i1].prop] = this.objsearch.columns[
                      cobj
                    ][i1].cdefault;
                  else if (!isNaN(temp))
                    obj[this.objsearch.columns[cobj][i1].prop] = temp;
                  else obj[this.objsearch.columns[cobj][i1].prop] = 0;
                } else {
                  obj[this.objsearch.columns[cobj][i1].prop] = 0;
                }
                break;
              case 1:
              case 2:
                if (
                  this.objsearch.columns[cobj][i1].cdefault &&
                  this.objsearch.columns[cobj][i1].cdefault != ''
                ) {
                  temp = parseFloat(this.objsearch.columns[cobj][i1].cdefault);
                  if (!isNaN(temp)) obj[this.objsearch.columns[cobj][i1].prop] = temp;
                  else obj[this.objsearch.columns[cobj][i1].prop] = 0;
                } else {
                  obj[this.objsearch.columns[cobj][i1].prop] = 0;
                }
                break;
              case 6:
                if (
                  this.objsearch.columns[cobj][i1].cdefault &&
                  this.objsearch.columns[cobj][i1].cdefault != ''
                ) {
                  obj[
                    this.objsearch.columns[cobj][i1].prop
                  ] = this.config.proxy.$utils.dtformat.fomatTime(
                    new Date(),
                    this.objsearch.columns[cobj][i1].cdefault
                  );
                } else {
                  if (this.objsearch.columns[cobj][i1].imust > 0) {
                    obj[this.objsearch.columns[cobj][i1].prop] = new Date();
                  } else {
                    obj[this.objsearch.columns[cobj][i1].prop] = null;
                  }
                }
                if (
                  this.objsearch.columns[cobj][i1].prop2 &&
                  this.objsearch.columns[cobj][i1].prop2 != ''
                ) {
                  let prop2Obj = this.format_prop2(
                    this.objsearch.columns[cobj][i1].prop2
                  );
                  if (prop2Obj) {
                    if (prop2Obj.length == 1) {
                      obj[this.objsearch.columns[cobj][i1].prop2] = null;
                    } else {
                      for (const key in prop2Obj.obj) {
                        if (prop2Obj.obj.hasOwnProperty(key)) {
                          obj[key] = null;
                        }
                      }
                    }
                  }
                }
                if (
                  this.objsearch.columns[cobj][i1].propdp &&
                  this.objsearch.columns[cobj][i1].propdp != ''
                ) {
                  obj[this.objsearch.columns[cobj][i1].propdp] = null;
                }
                break;
              case 9:
                obj[this.objsearch.columns[cobj][i1].prop] = [''];
                if (
                  this.objsearch.columns[cobj][i1].prop2 &&
                  this.objsearch.columns[cobj][i1].prop2 != ''
                ) {
                  let prop2Obj = this.format_prop2(
                    this.objsearch.columns[cobj][i1].prop2
                  );
                  if (prop2Obj) {
                    if (prop2Obj.length == 1) {
                      obj[this.objsearch.columns[cobj][i1].prop2] = '';
                    } else {
                      for (const key in prop2Obj.obj) {
                        if (prop2Obj.obj.hasOwnProperty(key)) {
                          obj[key] = '';
                        }
                      }
                    }
                  }
                }
                if (
                  this.objsearch.columns[cobj][i1].propdp &&
                  this.objsearch.columns[cobj][i1].propdp != ''
                ) {
                  obj[this.objsearch.columns[cobj][i1].propdp] = '';
                }
                continue;
              case 90:
                obj[this.objsearch.columns[cobj][i1].prop] = [];
                continue;
              default:
                if (
                  this.objsearch.columns[cobj][i1].cdefault &&
                  this.objsearch.columns[cobj][i1].cdefault != ''
                ) {
                  if (this.objsearch.columns[cobj][i1].cdefault.startsWith('user')) {
                    let defaultlst = this.objsearch.columns[cobj][i1].cdefault.split('.');
                    if (defaultlst.length == 2) {
                      obj[
                        this.objsearch.columns[cobj][i1].prop
                      ] = this.config.proxy.$store.state.user[defaultlst[1]];
                    }
                  } else if (
                    this.objsearch.columns[cobj][i1].cdefault.startsWith('vouch')
                  ) {
                    let defaultlst = this.objsearch.columns[cobj][i1].cdefault.split('.');
                    if (defaultlst.length == 2) {
                      obj[this.objsearch.columns[cobj][i1].prop] = this.objdata.vouch[
                        defaultlst[1]
                      ];
                    }
                  } else {
                    obj[this.objsearch.columns[cobj][i1].prop] = this.objsearch.columns[
                      cobj
                    ][i1].cdefault;
                  }
                } else {
                  obj[this.objsearch.columns[cobj][i1].prop] = '';
                }

                if (
                  this.objsearch.columns[cobj][i1].prop2 &&
                  this.objsearch.columns[cobj][i1].prop2 != ''
                ) {
                  let prop2Obj = this.format_prop2(
                    this.objsearch.columns[cobj][i1].prop2
                  );
                  if (prop2Obj) {
                    if (prop2Obj.length == 1) {
                      obj[this.objsearch.columns[cobj][i1].prop2] = '';
                    } else {
                      for (const key in prop2Obj.obj) {
                        if (prop2Obj.obj.hasOwnProperty(key)) {
                          obj[key] = '';
                        }
                      }
                    }
                  }
                }
                if (
                  this.objsearch.columns[cobj][i1].propdp &&
                  this.objsearch.columns[cobj][i1].propdp != ''
                ) {
                  obj[this.objsearch.columns[cobj][i1].propdp] = '';
                }

                break;
            }
          }
        }
      }
    } catch (e) {
      console.log('createobj error....', e);
      this.config.proxy.$msgbox(e.message);
    }
    console.log('------------obj', obj);
    return obj;
  };
  format_prop2 = (prop2) => {
    if (prop2 == '') return null;
    let obj = {};
    let delobj = {};
    // let prop2 = 'idcust:id,cbarcust:cbar,cnamecust:cname,idorg:idsaorg,cnameorg:cnamesaorg';
    let prop2lst = prop2.split(',');
    for (let i1 = 0; i1 < prop2lst.length; i1++) {
      let params = prop2lst[i1].split(':');
      if (params.length >= 2) {
        const key = params[0];
        const value = params[1];
        let delvalue = '';
        if (params.length >= 3) {
          delvalue = params[2];
        }
        obj[key] = value;
        delobj[key] = delvalue;
      }
    }
    var res = {
      length: prop2lst.length,
      obj,
      delobj,
    };
    return res;
  };

  onFunc = (cfield) => {
    switch (cfield) {
      case 'Refresh':
        this.fnrefresh();
        break;
      case 'Search':
        this.onSearch();
        break;
      case 'Save':
        this.fnsave(true);
        break;
      case 'New':
        this.fnnew2();
        break;
      case 'NewChildren':
        this.fnnew2_children();
        break;
      case 'Edit':
        this.fnedit();
        break;
      case 'Commit':
        this.fncommit();
        break;
      case 'Verify':
        this.fnverify();
        break;
      case 'Close':
        this.fnClose();
        break;
      case 'Cancel':
        this.fnCancel();
        break;
      case 'Delete':
        this.fndelete();
        break;
      case 'Commitbt':
        this.fncommitbat();
        break;
      case 'Commitrbt':
        this.fncommitrbat();
        break;
      case 'Verifybt':
        this.fnverifybat();
        break;
      case 'Verifyrbt':
        this.fnverifyrbat();
        break;
      case 'Cancelbt':
        this.fncancelbat();
        break;
      case 'Verifyrbt':
        this.fncancelrbat();
        break;
      case 'Deletebt':
        this.fndeletebt();
        break;

      case 'Today':
        result = this.config.proxy.$utils.dtformat.getTodayRange();
        this.objsearch.filter.dstart = result.dstart;
        this.objsearch.filter.dend = result.dend;
        this.onSearch();
        break;
      case 'Week':
        result = this.config.proxy.$utils.dtformat.getThisWeekRange();
        this.objsearch.filter.dstart = result.dstart;
        this.objsearch.filter.dend = result.dend;
        this.onSearch();
        break;
      case 'Month':
        result = this.config.proxy.$utils.dtformat.getThisMonthRange();
        this.objsearch.filter.dstart = result.dstart;
        this.objsearch.filter.dend = result.dend;
        this.onSearch();
        break;
      case 'Year':
        result = this.config.proxy.$utils.dtformat.getThisYearRange();
        this.objsearch.filter.dstart = result.dstart;
        this.objsearch.filter.dend = result.dend;
        this.onSearch();
        break;

      case 'isnew':
        return this.isnew;
      case 'cannew':
        return this.cannew;
      case 'isnew_children':
        return this.isnew_children;
      case 'cannew_children':
        return this.cannew_children;
      case 'isedit':
        return this.isedit;
      case 'canedit':
        return this.canedit;
      case 'canedit_base':
        return this.canedit_base;
      case 'cansave':
        return this.cansave;
      case 'iscommit':
        return this.iscommit;
      case 'cancommit':
        return this.cancommit;
      case 'isverify':
        return this.isverify;
      case 'canverify':
        return this.canverify;
      case 'isclose':
        return this.isclose;
      case 'canclose':
        return this.canclose;
      case 'iscancel':
        return this.iscancel;
      case 'cancancel':
        return this.cancancel;
      case 'candelete':
        return this.candelete;
    }
  };
  onFormatBtnValue = (value, cfield) => {
    switch (cfield) {
      case 'iname':
      case 'idisabled':
        if (value) return 0;
        else return 1;
    }
  };
  onStandBtnClick = (res) => {
    this.onBtnClick(this, res.ibtntypes, res);
  };
  onBtnClick = (ref, ibtntypes, res) => {
    switch (ibtntypes) {
      case 0:
        ref.onFunc('Refresh', res);
        break;
      case 1:
        ref.onFunc('Search', res);
        break;
      case 2:
        ref.onFunc('Save', res);
        break;
      case 3:
        ref.onFunc('New', res);
        break;
      case 4:
      case 5:
        ref.onFunc('Edit', res);
        break;
      case 6:
        ref.onFunc('Commit', res);
        break;
      case 7:
        ref.onFunc('Verify', res);
        break;
      case 8:
        ref.onFunc('Close', res);
        break;
      case 13:
        ref.onFunc('NewChildren', res);
        break;
      case 17:
        ref.onFunc('Cancel', res);
        break;
      case 18:
      case 19:
        ref.onFunc('Delete', res);
        break;
      case 20:
        ref.onFunc('Commitbt', res);
        break;
      case 21:
        ref.onFunc('Commitrbt', res);
        break;
      case 22:
        ref.onFunc('Verifybt', res);
        break;
      case 23:
        ref.onFunc('Verifyrbt', res);
        break;
      case 26:
        ref.onFunc('Cancelbt', res);
        break;
      case 27:
        ref.onFunc('Cancelrbt', res);
        break;
      case 28:
      case 29:
        ref.onFunc('Deletebt', res);
        break;
      case 31:
        ref.onFunc('Today', res);
        break;
      case 32:
        ref.onFunc('Week', res);
        break;
      case 33:
        ref.onFunc('Month', res);
        break;
      case 34:
        ref.onFunc('Year', res);
        break;
      case 70:
        ref.onFunc('Print', res);
        break;
      case 71:
        ref.onFunc('OutputExcel', res);
        break;
      case 72:
        ref.onFunc('OutputPdf', res);
        break;
      case 80:
        // 子表增行
        break;
      case 81:
        // 子表导入
        break;
      case 82:
        // 子表导出
        break;
    }
  };
  onBtnValueChange = (ref, ibtntypes) => {
    switch (ibtntypes) {
      case 2:
        if ('cansave' in this.objdata.btnstatus) {
          this.objdata.btnstatus.cansave = ref.onFunc('cansave');
        }
        break;
      case 3:
        if ('isnew' in this.objdata.btnstatus) {
          this.objdata.btnstatus.isnew = ref.onFunc('isnew');
        }
        if ('cannew' in this.objdata.btnstatus) {
          this.objdata.btnstatus.cannew = ref.onFunc('cannew');
        }
        console.log('this.objdata.btnstatus', this.objdata.btnstatus);
        break;
      case 4:
        if ('isedit' in this.objdata.btnstatus) {
          this.objdata.btnstatus.isedit = ref.onFunc('isedit');
        }
        if ('canedit' in this.objdata.btnstatus) {
          this.objdata.btnstatus.canedit = ref.onFunc('canedit');
        }
        break;
      case 5:
        if ('isedit' in this.objdata.btnstatus) {
          this.objdata.btnstatus.isedit = ref.onFunc('isedit');
        }
        if ('canedit_base' in this.objdata.btnstatus) {
          this.objdata.btnstatus.canedit_base = ref.onFunc('canedit_base');
        }
        break;
      case 6:
        if ('iscommit' in this.objdata.btnstatus) {
          this.objdata.btnstatus.iscommit = ref.onFunc('iscommit');
        }
        if ('cancommit' in this.objdata.btnstatus) {
          this.objdata.btnstatus.cancommit = ref.onFunc('cancommit');
        }
        break;
      case 7:
        if ('isverify' in this.objdata.btnstatus) {
          this.objdata.btnstatus.isverify = ref.onFunc('isverify');
        }
        if ('canverify' in this.objdata.btnstatus) {
          this.objdata.btnstatus.canverify = ref.onFunc('canverify');
        }
        break;
      case 8:
        if ('isclose' in this.objdata.btnstatus) {
          this.objdata.btnstatus.isclose = ref.onFunc('isclose');
        }
        if ('canclose' in this.objdata.btnstatus) {
          this.objdata.btnstatus.canclose = ref.onFunc('canclose');
        }
        break;
      case 13:
        if ('isnew_children' in this.objdata.btnstatus) {
          this.objdata.btnstatus.isnew_children = ref.onFunc('isnew_children');
        }
        if ('cannew_children' in this.objdata.btnstatus) {
          this.objdata.btnstatus.cannew_children = ref.onFunc('cannew_children');
        }
        break;
      case 17:
        if ('iscancel' in this.objdata.btnstatus) {
          this.objdata.btnstatus.iscancel = ref.onFunc('iscancel');
        }
        if ('cancancel' in this.objdata.btnstatus) {
          this.objdata.btnstatus.cancancel = ref.onFunc('cancancel');
        }
        break;
      case 18:
        if ('candelete' in this.objdata.btnstatus) {
          this.objdata.btnstatus.candelete = ref.onFunc('candelete');
        }
        break;
    }
  };
  onWatchBtnStatus = (ref, type, sourceType) => {
    // 1. 解构+可选链提取所有公共变量，统一兜底，减少重复调用
    const { mnus } = this.objsearch || {};
    const mnuData = mnus?.[sourceType] || {};
    const { lst = [], csysbar = '' } = mnuData;
    const targetList = this.objsearch?.initmuns?.[type]?.[csysbar] ?? [];

    // 2. 核心：抽离重复的按钮处理逻辑为独立函数（复用核心）
    const handleBtnItem = (btnItem) => {
      if (btnItem?.ibtntype === 8 || btnItem?.ibtntype === 11) {
        ref.onBtnValueChange(ref, btnItem?.ibtntypes);
      }
    };

    // 3. 抽离列表遍历逻辑（处理单层item+嵌套children）
    const traverseBtnList = (list) => {
      list.forEach((item) => {
        const children = item?.children ?? [];
        // 无子节点处理当前item，有子节点遍历子节点处理
        children.length === 0 ? handleBtnItem(item) : children.forEach(handleBtnItem);
      });
    };

    // 4. 精简判断条件，执行对应列表的遍历
    const isUseInitMuns = lst.length === 0 && csysbar !== '';
    traverseBtnList(isUseInitMuns ? targetList : lst);
  };
  fnformatOpt = (row, value, lst) => {
    if (!row || !lst) return;
    let idx_s = lst.findIndex((i) => i.value == value);
    if (idx_s != -1) return lst[idx_s].label;
    else return value;
  };
  deepClone(obj, cache = new WeakMap()) {
    // 1. 处理 null/undefined/基本类型（直接返回，兜底）
    if (obj === null || typeof obj !== 'object') return obj;

    // 2. 处理循环引用（关键：避免递归死循环）
    if (cache.has(obj)) return cache.get(obj);

    // 3. 处理 Vue 响应式对象（Proxy）- 先解包
    if (obj.__v_isReactive || obj.__v_isRef) {
      // 简易解包：如果项目引入了 Vue，也可以用 toRaw(obj)
      obj = JSON.parse(JSON.stringify(obj));
    }

    // 4. 处理 Date 类型
    if (obj instanceof Date) {
      const newDate = new Date(obj.getTime());
      cache.set(obj, newDate); // 加入缓存
      return newDate;
    }

    // 5. 处理 RegExp 类型
    if (obj instanceof RegExp) {
      const newReg = new RegExp(obj.source, obj.flags);
      cache.set(obj, newReg); // 加入缓存
      return newReg;
    }

    // 6. 处理数组
    if (Array.isArray(obj)) {
      const newArr = [];
      cache.set(obj, newArr); // 加入缓存
      obj.forEach((item, index) => {
        newArr[index] = this.deepClone(item, cache); // 注意：用 this. 调用自身
      });
      return newArr;
    }

    // 7. 处理纯对象（核心：加异常捕获）
    if (obj instanceof Object && !Array.isArray(obj)) {
      const newObj = {};
      cache.set(obj, newObj); // 加入缓存
      // 遍历属性 + try/catch 防止访问异常
      Reflect.ownKeys(obj).forEach(key => {
        try {
          newObj[key] = this.deepClone(obj[key], cache); // 注意：用 this. 调用自身
        } catch (e) {
          console.warn(`拷贝属性 ${String(key)} 失败:`, e);
          newObj[key] = obj[key]; // 降级返回原属性，避免整体崩溃
        }
      });
      return newObj;
    }

    // 8. 其他类型（函数/内置对象等，直接返回原引用）
    return obj;
  }
  isDeepEqual(a, b) {
    // 1. 先判断类型是否相同
    if (typeof a !== typeof b) return false;

    // 2. 处理 null/undefined
    if (a === null || b === null) return a === b;

    // 3. 处理基本类型（数字、字符串、布尔、Symbol）
    if (typeof a !== 'object') return a === b;

    // 4. 处理 Date 类型
    if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();

    // 5. 处理 Array 类型
    if (a instanceof Array && b instanceof Array) {
      // 先判断长度是否一致
      if (a.length !== b.length) return false;
      // 遍历每个元素，递归对比
      for (let i = 0; i < a.length; i++) {
        if (!this.isDeepEqual(a[i], b[i])) return false;
      }
      return true;
    }

    // 6. 处理 Object 类型（排除数组/Date）
    if (a instanceof Object && b instanceof Object) {
      // 获取所有自有属性名（包括不可枚举属性）
      const keysA = Reflect.ownKeys(a);
      const keysB = Reflect.ownKeys(b);
      // 先判断属性数量是否一致
      if (keysA.length !== keysB.length) return false;
      // 遍历每个属性，递归对比
      for (const key of keysA) {
        if (!keysB.includes(key)) return false; // 属性名不存在
        if (!this.isDeepEqual(a[key], b[key])) return false; // 属性值不一致
      }
      return true;
    }

    // 7. 其他类型（如 Function，判断引用是否一致）
    return a === b;
  }
  isObjectDeepEqual(obj1, obj2) {
    // 1. 首先严格判断是否为纯 Object 类型（排除数组、null、Date等）
    const isPureObject = (val) =>
      val !== null && typeof val === 'object' && !Array.isArray(val) && !(val instanceof Date);

    // 非纯对象直接返回 false
    if (!isPureObject(obj1) || !isPureObject(obj2)) return false;

    // 2. 获取两个对象的所有自有属性名（包括不可枚举、Symbol 属性）
    const keys1 = Reflect.ownKeys(obj1);
    const keys2 = Reflect.ownKeys(obj2);

    // 3. 属性数量不一致，直接不相等
    if (keys1.length !== keys2.length) return false;

    // 4. 遍历所有属性，递归对比值
    for (const key of keys1) {
      // 属性名不存在，直接不相等
      if (!keys2.includes(key)) return false;

      const val1 = obj1[key];
      const val2 = obj2[key];

      // 子值是纯对象：递归判断
      if (isPureObject(val1) && isPureObject(val2)) {
        if (!this.isObjectDeepEqual(val1, val2)) return false;
      }
      // 子值是基本类型/其他类型：直接严格相等判断
      else {
        // 特殊处理 Date 子值（如果对象属性里有 Date）
        if (val1 instanceof Date && val2 instanceof Date) {
          if (val1.getTime() !== val2.getTime()) return false;
        }
        // 数组子值：长度+每一项严格相等（可选，根据你的需求）
        else if (Array.isArray(val1) && Array.isArray(val2)) {
          if (val1.length !== val2.length || !val1.every((item, idx) => item === val2[idx])) {
            return false;
          }
        }
        // 基本类型/函数等：严格相等
        else if (val1 !== val2) {
          return false;
        }
      }
    }

    // 所有属性都匹配，返回相等
    return true;
  }
  parseCshowpc = (cshowpcStr, ishowpcVal, iname2Val) => {
    // {0: "Base Info|基础属性", 1: "Other Info|其它属性"}
    const cshowpcObj = {};
    cshowpcStr.split(',').forEach((item) => {
      const [key, value] = item.split(':');
      cshowpcObj[key] = value;
    });
    const rawValue = cshowpcObj[ishowpcVal];
    if (!rawValue) return '';
    let result = '';
    if (iname2Val != 0) {
      result = rawValue.replace('|', ' ');
    } else {
      result = rawValue.split('|')[0];
    }
    return result;
  };
  getTabLabel(mblstKey, defaultText, ishowpc) {
    // 提取head对象，减少重复链式调用
    const head = this.objdata?.views?.[mblstKey]?.head || {};
    // 提前获取cshowpc值，避免重复判断
    const cshowpc = head.cshowpc || '';

    // 如果cshowpc有值，先解析它
    if (cshowpc) {
      const parsedValue = this.parseCshowpc(cshowpc, ishowpc, head.iname2) || '';
      // 解析结果有值则返回，否则用cname或默认值
      return parsedValue || head.cname || defaultText;
    }

    // cshowpc无值时，直接用cname或默认值
    return head.cname || defaultText;
  }
  hotKey(event, ref) {
    if (event.keyCode == 38) {
      event.preventDefault();
      // console.log('上');
      if (this.objdata.index > 0) {
        this.objdata.index -= 1;
        ref.setCurrentRow(this.objdata.data.details[this.objdata.index]);
      }
    } else if (event.keyCode == 40) {
      event.preventDefault();
      // console.log('下');
      if (this.objdata.index < this.objdata.data.details.length - 1) {
        this.objdata.index += 1;
        ref.setCurrentRow(this.objdata.data.details[this.objdata.index]);
      }
    }
  }
  isEmptyObject(obj) {
    if (obj === null || typeof obj !== 'object' || Array.isArray(obj)) {
      return false;
    }
    // 遍历自有属性，有则返回false
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        return false;
      }
    }
    return true;
  }
  juageExt(cext) {
    const imageExts = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg', 'heic', 'tiff'];
    const videoExts = [
      'mp4',
      'mov',
      'avi',
      'mkv',
      'flv',
      'wmv',
      'webm',
      'mpeg',
      'mpg',
      '3gp',
      'rmvb',
      'mts',
    ];
    const ext = cext.toLowerCase();
    const obj = {
      isImage: false,
      isVideo: false,
      isDefault: false,
    };
    if (imageExts.includes(ext)) {
      obj.isImage = true;
    } else if (videoExts.includes(ext)) {
      obj.isVideo = true;
    } else obj.isDefault = true;
    return obj;
  };
}
class PageVO {
  constructor(config, objsearch, objdata, inidata) {
    try {
      this.config = config;
      this.objdata = objdata;
      this.objsearch = objsearch;
      this.detailinfo = this.config.proxy.$utils.comm.getRouteInfo(this.config.name);
      if (!this.detailinfo) this.detailinfo = { path: '', name: '', title: '' };
      this.objsearch.issearch = false;
      this.objsearch.loading = false;
      if (!this.objsearch.ipagesize) this.objsearch.ipagesize = 15;
      if (!this.objsearch.icurrpage) this.objsearch.icurrpage = 0;
      this.objsearch.list = [];
      //权限
      if (!this.objdata.btn) this.objdata.btn = {};
      if (inidata && inidata.rolst) {
        for (let i1 = 0; i1 <= inidata.rolst.length - 1; i1++) {
          objdata.btn[inidata.rolst[i1].cbaroper] = 1;
        }
      }
      if (!this.objdata.columns) this.objdata.columns = {};
      let result = {};
      if (inidata && inidata.views && Object.keys(inidata.views).length != 0) {
        for (let key in inidata.views) {
          if (inidata.views.hasOwnProperty(key)) {
            if (
              inidata.views[key].tablelst &&
              Object.keys(inidata.views[key].tablelst).length != 0
            ) {
              let col = [];
              for (let key1 in inidata.views[key].tablelst) {
                if (inidata.views[key].head && inidata.views[key].head.ilayout != 3) {
                  col = col.concat(inidata.views[key].tablelst[key1]);
                  result[key] = col;
                } else {
                  for (let key2 in inidata.views[key].tablelst[key1]) {
                    col = col.concat(inidata.views[key].tablelst[key1][key2]);
                    result[key] = col;
                  }
                }
              }
            } else {
              // tablelst = {} 就取查找paras的
              if (inidata && inidata.paras) {
                if (inidata.paras.hasOwnProperty(key)) {
                  result[key] = inidata.paras[key];
                }
              }
            }
          }
        }
      } else if (inidata && inidata.paras) {
        for (let key in inidata.paras) {
          if (inidata.paras.hasOwnProperty(key)) {
            // 确保是对象自有属性，不是原型链上的属性
            result[key] = inidata.paras[key];
          }
        }
      }
      for (let key in result) {
        if (result.hasOwnProperty(key)) {
          // 确保是对象自有属性，不是原型链上的属性
          this.objdata.columns[key] = result[key];
          this.objdata.com[key] = true;
          this.objdata.focus[key] = false;
          this.objsearch.columns[key] = result[key];
          this.objsearch.com[key] = true;
          this.objsearch.focus[key] = false;
        }
      }
      if (!this.objdata.objini) this.objdata.objini = {};
      if (inidata && inidata.objini) {
        for (let key in inidata.objini) {
          if (inidata.objini.hasOwnProperty(key)) {
            // 确保是对象自有属性，不是原型链上的属性
            this.objdata.objini[key] = inidata.objini[key].replace(/[\r\n]+/g, '');
          }
        }
      }
      console.log('create...end...', this.objdata);
    } catch (e1) {
      console.log('create error......', e1);
    }
  }
  exportExcel = () => {
    for (let i = 0; i < this.objdata.data.details.length; i++) {
      var nqtysum = Number(0);
      this.objdata.data.details[i].ccode = this.objdata.data.head.id;
      this.objdata.data.details[i].ddate = this.objdata.data.head.ddate.slice(0, 10);
      this.objdata.data.details[i].ccodebak = this.objdata.data.head.idbak;
      this.objdata.data.details[i].cnamebuspsn = this.objdata.data.head.cnamebuspsn;
      this.objdata.data.details[i].cnamebusdept = this.objdata.data.head.cnamebusdept;
      this.objdata.data.details[i].cnamepos = this.objdata.data.head.cnamepos;
      this.objdata.data.details[i].cnamefidept = this.objdata.data.head.cnamefidept;
      this.objdata.data.details[i].cnamecust = this.objdata.data.head.cnamecust;
      this.objdata.data.details[i].cartirep = this.objdata.data.head.cartirep;
      this.objdata.data.details[i].cnametype = this.objdata.data.head.cnametype;
      this.objdata.data.details[i].clinkman = this.objdata.data.head.creceiver;
      this.objdata.data.details[i].clinkphone = this.objdata.data.head.cphonerec;
      this.objdata.data.details[i].caddress = this.objdata.data.head.caddress;
      this.objdata.data.details[i].cnamebusorg = this.objdata.data.head.cnamebusorg;
      this.objdata.data.details[i].ipaytype =
        this.objdata.data.details[i].ipaytype == 0 ? '现金' : '货补';
      this.objdata.data.details[i].cmemo = this.objdata.data.head.cmemo;
      this.objdata.data.head.cnamefile = '';
      if (this.objdata.data.details.length !== 0) {
        this.objdata.data.details.forEach((item) => {
          nqtysum += Number(item.nqtyb);
        });
        this.objdata.data.head.cnamefile =
          this.objdata.data.head.cnamefile +
          this.objdata.data.head.cnamecust +
          '-' +
          nqtysum;
      }
    }
    let cnamefile = this.objdata.data.head.cnamefile;
    let tHeader = [
      '单据号',
      '单据日期',
      '同步信息',
      '业务员',
      '部门',
      '所属岗位',
      '分公司',
      '客户',
      '法人',
      '收货人',
      '收货电话',
      '收货地址',
      '区域',
      '组织',
      '支付类型',
      '编码',
      '商品名称',
      '条码',
      '规格',
      '件数',
      '瓶数',
      // '结算价',
      // '结算金额',
      '原价',
      '单价',
      '单位',
      '可退数量',
      '退货仓',
      '内部备注',
      '备注',
    ];
    let filterVal = [
      'ccode',
      'ddate',
      'ccodebak',
      'cnamebuspsn',
      'cnamebusdept',
      'cnamepos',
      'cnamefidept',
      'cnamecust',
      'cartirep',
      'clinkman',
      'clinkphone',
      'caddress',
      'cnametype',
      'cnamebusorg',
      'ipaytype',
      'cbarct',
      'cnamect',
      'ceanucc',
      'cspecct',
      'nqty',
      'nqtyb',
      // 'nppurch',
      // 'nmpurch',
      'nqpriceb',
      'npriceb',
      'cnameunitb',
      'nqtyavail',
      'cnameloca',
      'cmemoinner',
      'cmemo',
    ];
    let list = this.objdata.data.details;
    let data = formatJson(filterVal, list);
    if (list.length != 0) {
      export_json_to_excel({
        header: tHeader,
        data,
        filename: this.objdata.data.head.ddate.slice(0, 10) + '-' + cnamefile,
        autoWidth: true,
        bookType: 'xlsx',
      });
    } else {
      proxy.$notify({
        title: '系统提示',
        message: '请先搜索获取数据',
        type: 'warning',
      });
    }
  };

  exportExcelVO = () => {
    // 过滤一级/二级表头
    const firstHeaderList = this.objdata.columns.head.filter(
      (item) =>
        item.iignore == 0 && item.ihide == 0 && item.ishowpc == 0 && item.itype != 99
    );
    const secondHeaderList = this.objdata.columns.details.filter(
      (item) =>
        item.iignore == 0 && item.ihide == 0 && item.ishowpc == 0 && item.itype != 99
    );

    // 构造一级表头+数据
    const firstHeader = firstHeaderList.map((item) => ({
      name: item.label,
      span: item.icolspan || 1,
    }));
    const firstData = firstHeaderList.map(
      (item) => this.objdata.data.head[item.prop] || ''
    );

    // 构造二级表头+数据
    const secondHeader = secondHeaderList.map((item) => ({
      name: item.label,
      span: item.icolspan || 1,
    }));
    const secondData = this.objdata.data.details.map((record) => {
      return secondHeaderList.map((item) => record[item.prop] || '');
    });

    // 调用导出函数
    this.config.proxy.$utils.export.exportLayeredExcelWithExcelJS({
      title: this.config.detailinfo.title,
      firstHeader: firstHeader,
      firstData: firstData,
      secondHeader: secondHeader,
      secondData: secondData,
      fileName: `${this.config.detailinfo.title
        }-${this.config.proxy.$utils.dtformat.fomatTime(
          this.objdata.data.head.ddate,
          'date'
        )}.xlsx`,
      sheetName: `${this.config.detailinfo.title} `,
    });
  };
  fnprint = () => {
    if (this.objdata.printRef) {
      this.objdata.printRef.fnprint(false);
    }
  };
  fnexecute = (cobject, coper) => {
    let params = {
      cobject: cobject,
      coper: coper,
      objpara: {},
    };
    this.config.proxy.$execute(params).then((res) => {
      if (res.iresult != 0) {
        this.config.proxy.$msgbox.alert(res.cerror);
        return;
      }
      this.config.proxy.$message({
        showClose: true,
        message: '操作成功',
        type: 'success',
      });
    });
  };
  get isnew() {
    if (this.objdata.status.iflag === 2 || this.objdata.statusf.iflag === 2) {
      return true;
    } else {
      return false;
    }
  }
  get isedit() {
    if (this.objdata.status.iflag === 1 || this.objdata.statusf.iflag === 1) {
      return true;
    } else {
      return false;
    }
  }
  get isverify() {
    if (
      this.objdata.data.head.istatus === 20 ||
      this.objdata.statusf.iflag === 20 ||
      this.objdata.status.iflag === 20
    ) {
      return true;
    } else {
      return false;
    }
  }
  get iscommit() {
    if (
      this.objdata.data.head.istatus === 10 ||
      this.objdata.statusf.iflag === 10 ||
      this.objdata.status.iflag === 10
    ) {
      return true;
    } else {
      return false;
    }
  }
  get issync() {
    if (
      this.objdata.data.head.istexch > 0 &&
      this.objdata.data.head.istexch < 20 &&
      this.objdata.data.head.istatus === 20
    ) {
      return true;
    } else {
      return false;
    }
  }
  get cansave() {
    if (
      (this.objdata.status.iflag > 0 || this.objdata.statusf.iflag > 0) &&
      (this.objdata.status.iflag < 10 || this.objdata.statusf.iflag < 10)
    ) {
      return true;
    } else {
      return false;
    }
  }
  get cansavelogis() {
    if (this.objdata.iflaglogis > 0) {
      return true;
    } else {
      return false;
    }
  }
  get cansee() {
    if (this.objdata.status.iflag > 0 || this.objdata.statusf.iflag > 0) {
      return true;
    } else return false;
  }
  get cannew() {
    if (
      this.objdata.status.iflag === 0 ||
      this.objdata.status.iflag === 2 ||
      this.objdata.statusf.iflag === 0 ||
      this.objdata.statusf.iflag === 2
    ) {
      return true;
    } else return false;
  }
  get canedit() {
    if (
      this.objdata.data.head &&
      this.objdata.data.head.id != '' &&
      this.objdata.data.head.istatus === 0 &&
      (this.objdata.status.iflag == 0 ||
        this.objdata.status.iflag == 1 ||
        this.objdata.statusf.iflag == 0 ||
        this.objdata.statusf.iflag == 1)
    ) {
      return true;
    } else return false;
  }
  get canedit_5() {
    if (
      this.objdata.data.head &&
      this.objdata.data.head.id != '' &&
      this.objdata.data.head.istatus <= 5 &&
      (this.objdata.status.iflag == 0 ||
        this.objdata.status.iflag == 1 ||
        this.objdata.statusf.iflag == 0 ||
        this.objdata.statusf.iflag == 1)
    ) {
      return true;
    } else return false;
  }
  get caneditlogis() {
    if (
      this.objdata.data.head &&
      this.objdata.data.head.id != '' &&
      this.objdata.data.head.istatus === 20 &&
      (this.objdata.iflaglogis == 0 || this.objdata.iflaglogis == 1)
    ) {
      return true;
    } else return false;
  }
  get canedit_base() {
    if (
      this.objdata.data.head &&
      this.objdata.data.head.id != '' &&
      (this.objdata.status.iflag == 0 ||
        this.objdata.status.iflag == 1 ||
        this.objdata.statusf.iflag == 0 ||
        this.objdata.statusf.iflag == 1)
    ) {
      return true;
    } else return false;
  }
  get canseeorder() {
    if (
      this.objdata.data.head &&
      this.objdata.data.head.id != '' &&
      this.objdata.data.head.istatus === 20 &&
      (this.objdata.status.iflag == 0 ||
        this.objdata.status.iflag == 1 ||
        this.objdata.statusf.iflag == 0 ||
        this.objdata.statusf.iflag == 1)
    ) {
      return true;
    } else return false;
  }
  get canverify() {
    if (
      this.objdata.data.head &&
      this.objdata.data.head.id != '' &&
      (this.objdata.status.iflag === 0 || this.objdata.statusf.iflag === 0) &&
      this.objdata.data.head.istatus >= 0 &&
      this.objdata.data.head.istatus <= 20
    ) {
      return true;
    } else return false;
  }
  get cancommit() {
    if (
      this.objdata.data.head &&
      this.objdata.data.head.id != '' &&
      (this.objdata.status.iflag === 0 || this.objdata.statusf.iflag === 0) &&
      this.objdata.data.head.istatus >= 0 &&
      this.objdata.data.head.istatus <= 10
    ) {
      return true;
    } else return false;
  }

  get iscancel() {
    if (this.objdata.data.head.id === '') {
      return false;
    }
    if (this.objdata.data.head.istatus === -80) {
      return true;
    } else {
      return false;
    }
  }
  get cancancel() {
    if (
      this.objdata.data.head.id === '' ||
      this.objdata.status.iflag != 0 ||
      this.objdata.statusf.iflag != 0
    ) {
      return false;
    }
    if (
      (this.objdata.data.head &&
        this.objdata.data.head.id != '' &&
        this.objdata.data.head.istatus < 10) ||
      this.objdata.data.head.istatus >= 99
    ) {
      return true;
    } else return false;
  }
  get canaddrow() {
    if (this.objdata.status.iflag != 0 || this.objdata.statusf.iflag != 0) {
      return true;
    } else return false;
  }
  get cansync() {
    if (
      this.objdata.data.head.ccode != '' &&
      this.objdata.data.head.idcust != '' &&
      (this.objdata.status.iflag === 0 || this.objdata.statusf.iflag === 0) &&
      this.objdata.data.head.istatus == 20 &&
      this.objdata.data.head.istexch >= 0 &&
      this.objdata.data.head.istexch <= 9
    ) {
      return true;
    } else return false;
  }
  get cancelsync() {
    if (
      this.objdata.data.head.ccode != '' &&
      this.objdata.data.head.idcust != '' &&
      (this.objdata.status.iflag === 0 || this.objdata.statusf.iflag === 0) &&
      this.objdata.data.head.istatus == 20 &&
      this.objdata.data.head.istexch > 0 &&
      this.objdata.data.head.istexch <= 20
    ) {
      return true;
    } else return false;
  }
  get isclose() {
    if (this.objdata.data.head.id === '') {
      return false;
    }
    if (this.objdata.data.head.istatus === 40) {
      return true;
    } else {
      return false;
    }
  }
  get canclose() {
    if (
      this.objdata.data.head.ccode != '' &&
      (this.objdata.status.iflag === 0 || this.objdata.statusf.iflag === 0) &&
      this.objdata.data.head.istatus >= 20 &&
      this.objdata.data.head.istatus <= 40
    ) {
      return true;
    } else return false;
  }
  fnrefresh = () => {
    if (this.objdata.status.iflag > 0 || this.objdata.statusf.iflag > 0) {
      this.config.proxy.$msgbox
        .confirm('您确定要放弃当前编辑吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          this.objdata.status.iflag = 0;
          this.objdata.statusf.iflag = 0;
          if (
            (this.objdata.data.head.id == '' || this.objdata.data.head.id == null) &&
            this.config.proxy.$router.currentRoute.query.id
          ) {
            this.fnmoveid(this.config.proxy.$router.currentRoute.query.id, 'moveid');
          } else {
            this.fnmoveid(this.objdata.data.head.id, 'moveid');
          }
          if (this.objdata.data.head.idwf !== '' || this.objdata.data.head.idwfe !== '') {
            this.objdata.wf.isload = true;
            setTimeout(() => {
              this.objdata.wf.isload = false;
            }, 100);
          }
        })
        .catch(() => {
          this.config.proxy.$message({
            showClose: true,
            message: '已取消~',
            type: 'success',
          });
        });
    } else {
      if (
        (this.objdata.data.head.id == '' || this.objdata.data.head.id == null) &&
        this.config.proxy.$router.currentRoute.query.id
      ) {
        this.fnmoveid(this.config.proxy.$router.currentRoute.query.id, 'moveid');
      } else {
        this.fnmoveid(this.objdata.data.head.id, 'moveid');
      }
      if (this.objdata.data.head.idwf !== '' || this.objdata.data.head.idwfe !== '') {
        this.objdata.wf.isload = true;
        setTimeout(() => {
          this.objdata.wf.isload = false;
        }, 100);
      }
    }
  };
  fnmoveid = (id, coper, obj) => {
    if (!obj) obj = {};
    if (id == '' || id == null) return;
    this.objdata.loading = true;
    let params = {
      cobject: this.config.cobjectt,
      coper: 'moveid',
      objpara: {
        id: id,
        ...obj,
      },
    };
    this.config.proxy.$execute(params).then((res) => {
      if (res.iresult !== 0) {
        alert(res.cerror);
        this.objdata.loading = false;
        return;
      }
      this.objdata.data = res.data;
      // 初始化删除列表
      for (let key in this.objdata.del) {
        if (this.objdata.del.hasOwnProperty(key)) {
          // 确保是对象自身的属性，而不是继承的属性
          // 对每个属性进行赋值操作
          this.objdata.del[key] = []; // 例如，将每个属性的值乘以2
        }
      }
      this.objdata.isshowstate = true;
      this.objdata.printlst.length = 0;
      if (res.data.head?.idwf !== '' || res.data.head?.idwfe !== '') {
        this.objdata.wf.isload = true;
        setTimeout(() => {
          this.objdata.wf.isload = false;
        }, 100);
      }
      this.onSearch_e(
        this.objdata.data.head.idwfe,
        this.objdata.data.head.idwf,
        this.objdata.wf.isload
      );
      setTimeout(() => {
        this.objdata.loading = false;
      }, 1000);
      if (coper && coper == 'edit') this.fnedit();
      this.config.callback({
        iresult: 0,
        cerror: '',
        coper: 'moveid',
        data: JSON.stringify(res.data),
      });
    });
  };
  //新建
  fnnew = (itype) => {
    this.objdata.inewtype = itype;
    if (this.objdata.data.head.id && this.objdata.data.head.id !== '') {
      if (!this.config.detailinfo) {
        alert('详情路由信息不存在');
        return;
      }
      this.config.proxy.$router.push({
        path: this.config.detailinfo.path,
        query: {
          tagsViewName:
            this.config.detailinfo.title +
            '_' +
            Math.round(new Date().getTime() / 1000)
              .toString()
              .slice(4, 10),
          coper: itype == 1 ? 'newquick' : 'new',
        },
      });
      return;
    }
    if (this.objdata.status.iflag === 0 || this.objdata.statusf.iflag === 0) {
      this.fninitobj();
      if (this.objdata.data.head.idwf !== '' || this.objdata.data.head.idwfe !== '') {
        this.objdata.wf.isload = true;
        setTimeout(() => {
          this.objdata.wf.isload = false;
        }, 100);
      }
      this.objdata.showadd = true;
      this.objdata.status.iflag = 2;
      this.objdata.statusf.iflag = 2;
      // this.fnaddrow('details');
      this.objdata.isshowstate = false;
      if (itype == 1) {
        this.objsearch.isshownew = true;
      }
    } else if (this.objdata.status.iflag === 2 || this.objdata.statusf.iflag === 2) {
      this.fninitobj();
      if (this.objdata.data.head.idwf !== '' || this.objdata.data.head.idwfe !== '') {
        this.objdata.wf.isload = true;
        setTimeout(() => {
          this.objdata.wf.isload = false;
        }, 100);
      }
      this.objdata.showadd = false;
      this.objdata.status.iflag = 0;
      this.objdata.statusf.iflag = 0;
      this.objdata.data.details.splice(this.objdata.inewrow, 1);
      this.objdata.newrow = null;
      this.objdata.isshowstate = false;
      if (itype == 1) {
        this.objsearch.itype = 1;
        this.objsearch.isshownew = false;
      }
    }
  };

  fnedit = () => {
    if (this.objdata.status.iflag === 0 || this.objdata.statusf.iflag === 0) {
      this.objdata.status.iflag = 1;
      this.objdata.statusf.iflag = 1;
      this.objdata.showadd = true;
      // if (this.objdata.inewtype == 0)
      this.fnaddrow('details');
      this.objdata.isshowstate = false;
    } else if (this.objdata.status.iflag === 1 || this.objdata.statusf.iflag === 1) {
      this.objdata.status.iflag = 0;
      this.objdata.statusf.iflag = 0;
      this.objdata.data.details.splice(this.objdata.inewrow, 1);
      this.objdata.newrow = null;
      this.fnmoveid(this.objdata.data.head.id, 'moveid');
      this.objdata.showadd = false;
      this.objdata.isshowstate = true;
    }
  };
  fnsave = (boolean, obj) => {
    if (!obj) obj = {};
    this.config.callback({ iresult: 0, cerror: '', coper: 'beforesave', data: null });
    let cfield = '';
    const detailsList = this.objdata.columns?.details ?? []; // 先获取数组，明确边界
    const targetItem = detailsList.find((item) => item.iautonl === 1);
    if (targetItem) {
      cfield = targetItem.prop;
    }
    if (cfield != '') {
      if (this.objdata.newrow != null && this.objdata.newrow[cfield] === '') {
        this.objdata.data.details.splice(this.objdata.inewrow, 1);
        this.objdata.newrow = null;
      }
    }
    let params = {
      cobject: this.config.cobjectt,
      coperation: 'save',
      objparameter: {
        ...obj,
        data: this.objdata.data,
        del: this.objdata.del,
      },
    };
    this.config.proxy.$execute(params).then((res) => {
      if (res.iresult == 0) {
        this.objdata.data = res.data;
        // 初始化删除列表
        for (let key in this.objdata.del) {
          if (this.objdata.del.hasOwnProperty(key)) {
            // 确保是对象自身的属性，而不是继承的属性
            // 对每个属性进行赋值操作
            this.objdata.del[key] = []; // 例如，将每个属性的值乘以2
          }
        }
        this.objdata.status.iflag = 0;
        this.objdata.statusf.iflag = 0;
        this.objdata.isshow = false;
        // this.objdata.data.head.irowstatus = 0;
        if (this.objdata.data.head.istatus < 20) {
          this.config.proxy.$message({
            showClose: true,
            message: '保存成功,审核才生效哦~',
            type: 'success',
          });
        } else {
          this.config.proxy.$message({
            showClose: true,
            message: '保存成功~',
            type: 'success',
          });
        }
        this.objdata.isshowstate = true;
        this.config.callback({ iresult: 0, cerror: '', coper: 'save', data: res });
      } else {
        this.config.proxy.$msgbox(res.cerror);
      }
    });
  };
  fndelete = (obj) => {
    if (!obj) obj = {};
    if (this.objdata.data.head.id == '') {
      this.config.proxy.$msgbox.alert('请选择删除记录');
      return;
    }

    this.config.proxy.$msgbox
      .confirm(
        `您确定要删除单据【${this.objdata.data.head.ccode}】吗？`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      )
      .then(() => {
        let params = {
          cobject: this.config.cobjectt,
          coper: 'delete',
          objpara: {
            ...obj,
            id: this.objdata.data.head.id,
          },
        };
        this.config.proxy.$execute(params).then((res) => {
          if (res.iresult == 0) {
            this.config.proxy.$message({
              showClose: true,
              message: '已删除~',
              type: 'success',
            });
            this.closeCurrentTagsView();
          } else {
            this.config.proxy.$msgbox.alert(res.cerror);
          }
        });
      })
      .catch(() => {
        this.config.proxy.$msgbox.alert('已取消删除操作');
      });
  };
  fnselectrow_search = (res) => {
    this.objsearch.currrow = res.data.row;
  };
  fnselectrow = (res) => {
    this.objdata.currrow = res.data.row;
    this.objdata.index = res.data.index;
  };
  onRowClick = (res) => {
    this.objdata.currrow = res.data.row;
    this.objdata.index = res.data.index;
  };
  onChange = (res) => {
    if (!res) return;
    let cscope = res.cscope ? res.cscope : '';
    let cfield = res.cfield ? res.cfield : '';
    let itype = res.column.itype ? res.column.itype : 0;
    let isearch = res.column.isearch ? res.column.isearch : 0;
    switch (cscope) {
      case 'filter':
        this.onSearch();
        break;
    }
  };
  onSaveSwitch = (res) => {
    setTimeout(() => {
      let params = {
        cobject: this.config.cobjectt,
        coperation: 'save_switch',
        objparameter: {
          id: res.data.id,
          iswitch: res.data.value,
          cswitch: res.data.cswitch,
          [res.data.cswitch]: res.data.value,
        },
      };
      this.config.proxy.$execute(params).then((res) => {
        if (res.iresult != 0) {
          alert(res.cerror);
          return;
        }
        this.config.proxy.$message({
          showClose: true,
          message: '修改成功~',
          type: 'success',
        });
      });
    }, 300);
  };
  // 焦点
  handleFocusIn = (res) => {
    this.objdata.focus[res.cscope] = res.value;
    let boolean = false;
    console.log(res.cscope + '焦点进入', res, this.objdata.focus[res.cscope]);
    switch (res.cscope) {
      case 'head':
        break;
      case 'details':
        // 子表聚焦 判断cviewh是否存在
        // 存在 就判断cviewh是否检验通过
        switch (this.objdata.views[res.cscope].head.cviewh) {
          case 'head':
            boolean = this.fnvalid(
              this.objdata.data.head,
              this.objdata.views[res.cscope].head.cviewh
            );
            if ('ivalid' in this.objdata.data.head) {
              this.objdata.data.head.ivalid = boolean ? 1 : 0;
            }
            break;
        }
        break;
    }
  };
  handleFocusOut = (res) => {
    this.objdata.focus[res.cscope] = res.value;
    let boolean = false;
    console.log(res.cscope + '焦点离开', res, this.objdata.focus[res.cscope]);
    switch (res.cscope) {
      case 'head':
        // head  焦点移开就检测head是否检验通过
        boolean = this.fnvalid(this.objdata.data.head, res.cscope);
        if ('ivalid' in this.objdata.data.head) {
          this.objdata.data.head.ivalid = boolean ? 1 : 0;
        }

        break;
      case 'details':
        // details 焦点移开就检测当前行是否检验通过
        if ('ivalid' in this.objdata.data.head) {
          if (this.objdata.data.head.ivalid != 1) return;
        }
        boolean = this.fnvalid(this.objdata.currrow, res.cscope);
        if ('ivalid' in this.objdata.currrow) {
          this.objdata.currrow.ivalid = boolean ? 1 : 0;
        }
        break;
    }
  };
  fnvalid = (data, key) => {
    if (key in this.objdata.columns) {
      for (let i1 = 0; i1 < this.objdata.columns[key].length; i1++) {
        if (
          this.objdata.columns[key][i1].imust == 1 &&
          this.objdata.columns[key][i1].prop != 'id' &&
          this.objdata.columns[key][i1].prop != 'ccode' &&
          this.objdata.columns[key][i1].ihide !== 1 &&
          this.objdata.columns[key][i1].iignore !== 1
        ) {
          if (
            this.objdata.columns[key][i1].itype == 1 ||
            this.objdata.columns[key][i1].itype == 2
          ) {
            if (
              this.isEmpty(
                data[this.objdata.columns[key][i1].prop],
                this.objdata.columns[key][i1].cvalid,
                'Number'
              )
            ) {
              if (
                data[this.objdata.columns[key][i1].prop] === 0 ||
                data[this.objdata.columns[key][i1].prop] === '' ||
                data[this.objdata.columns[key][i1].prop] === null ||
                data[this.objdata.columns[key][i1].prop] === undefined
              ) {
                this.config.proxy.$msgbox.alert(
                  `${this.objdata.columns[key][i1].label}必填`
                );
                return false;
              }
            }
          } else {
            if (
              this.isEmpty(
                data[this.objdata.columns[key][i1].prop],
                this.objdata.columns[key][i1].cvalid,
                'String'
              )
            ) {
              this.config.proxy.$msgbox.alert(
                `${this.objdata.columns[key][i1].label}必填`
              );
              return false;
            }
          }
        }
      }
      return true;
    }
  };
  // 是否可以增行
  fnvalidate = (key) => {
    let boolean = this.fnvalid(this.objdata.data.head, 'head');
    if (!boolean) return;
    if (key in this.objdata.columns) {
      for (let i1 = 0; i1 < this.objdata.columns[key].length; i1++) {
        if (this.objdata.columns[key][i1].imust == 2) {
          if (
            this.objdata.columns[key][i1].itype == 1 ||
            this.objdata.columns[key][i1].itype == 2
          ) {
            if (
              this.isEmpty(
                this.objdata.currrow[this.objdata.columns[key][i1].prop],
                this.objdata.columns[key][i1].cvalid,
                'Number'
              )
            ) {
              if (
                this.objdata.currrow[this.objdata.columns[key][i1].prop] === 0 ||
                this.objdata.currrow[this.objdata.columns[key][i1].prop] === '' ||
                this.objdata.currrow[this.objdata.columns[key][i1].prop] === null ||
                this.objdata.currrow[this.objdata.columns[key][i1].prop] === undefined
              ) {
                this.config.proxy.$msgbox.alert(
                  `${this.objdata.columns[key][i1].label}必填`
                );
                return false;
              }
            }
          } else {
            if (
              this.isEmpty(
                this.objdata.currrow[this.objdata.columns[key][i1].prop],
                this.objdata.columns[key][i1].cvalid,
                'String'
              )
            ) {
              this.config.proxy.$msgbox.alert(
                `${this.objdata.columns[key][i1].label}必填`
              );
              return false;
            }
          }
        }
      }
      return true;
    }
  };
  isEmpty = (value, cvalid, type) => {
    if (value == null || value == undefined) {
      return true;
    }
    if (cvalid && cvalid != '') {
      let boolean = cvalid.startsWith('!');
      if (boolean) {
        return !new RegExp(cvalid.slice(1)).test(value);
      } else return new RegExp(cvalid).test(value);
    }
    switch (type) {
      case 'String':
        value = String(value);
        return /^\s*$/.test(value);
      case 'Number':
        value = String(value);
        return !/^(0\.\d*[1-9]\d*|[1-9]\d*(?:\.\d+)?|\.\d*[1-9]\d*)$/.test(value);
    }
  };
  fnaddrow = (lst) => {
    if (this.objdata.currrow && this.objdata.data[lst].length >= 1) {
      let bpass = this.fnvalidate(lst);
      if (!bpass) return;
    }
    if (lst) {
      this.objdata.newrow = this.fncreateobj(lst);
      if (!this.objdata.newrow) return;
      if ('iorder' in this.objdata.newrow) {
        this.objdata.newrow.iorder = this.objdata.data[lst].length + 1;
      }
      if ('id' in this.objdata.newrow) {
        this.objdata.newrow.id = this.config.proxy.$utils.comm.getGuid();
      }
      if ('irowstatus' in this.objdata.newrow) {
        this.objdata.newrow.irowstatus = 2;
      }
      this.objdata.data[lst].push(this.objdata.newrow);
    } else {
      if (this.objdata.newrow === null) {
        this.objdata.newrow = this.fncreateobj('details');
      }
      if (!this.objdata.newrow) return;
      this.objdata.data.details.push(this.objdata.newrow);
      this.objdata.inewrow = this.objdata.data.details.length - 1;
      if ('irowstatus' in this.objdata.newrow) {
        this.objdata.newrow.irowstatus = 2;
      }
    }
    if ('details' in this.objdata.data) {
      if (this.objdata.data.details.length == 1) {
        this.objdata.currrow = this.objdata.data.details[0];
        this.objdata.index = 0;
      }
    }
    this.config.callback({ iresult: 0, cerror: '', coper: 'addrow', data: lst });
  };
  fneditlogis = () => {
    if (this.objdata.data.head.istatus !== 20) return;
    if (this.objdata.iflaglogis === 0) {
      this.objdata.iflaglogis = 1;
    } else if (this.objdata.iflaglogis === 1) {
      this.objdata.iflaglogis = 0;
      this.fnmoveid(this.objdata.data.head.id, 'moveid');
    }
  };
  fnverify = (obj) => {
    if (!this.canverify) return;
    if (!obj) obj = {};
    let params = {
      cobject: this.config.cobjectt,
      coper: this.objdata.data.head.istatus === 20 ? 'verifyr' : 'verify',
      objpara: {
        ...obj,
        id: this.objdata.data.head.id,
      },
    };
    this.config.proxy.$execute(params).then((res) => {
      if (res.iresult == 0) {
        this.objdata.data.head.istatus = res.data;
        this.objsearch.list.some((item) => {
          if (item.id === res.data.id) {
            item.istatus = res.data;
            return true;
          }
        });
        this.config.proxy.$message({
          showClose: true,
          message: this.objdata.data.head.istatus === 20 ? '审核成功~' : '反审核成功',
          type: 'success',
        });
        this.fnmoveid(this.objdata.data.head.id, 'moveid');
      } else {
        this.config.proxy.$msgbox(res.cerror);
      }
      this.config.callback({ iresult: 0, cerror: '', coper: 'verify', data: res.data });
    });
  };
  fncommit = () => {
    if (!this.cancommit) return;
    let params = {
      cobject: this.config.cobjectt,
      coper: this.objdata.data.head.istatus === 10 ? 'commitr' : 'commit',
      objpara: {
        id: this.objdata.data.head.id,
      },
    };
    this.config.proxy.$execute(params).then((res) => {
      if (res.iresult == 0) {
        this.objdata.data.head.istatus = res.data;
        this.objsearch.list.some((item) => {
          if (item.id === res.data.id) {
            item.istatus = res.data;
            return true;
          }
        });
        this.config.proxy.$message({
          showClose: true,
          message: this.objdata.data.head.istatus === 10 ? '提交成功~' : '反提交成功',
          type: 'success',
        });
        this.fnmoveid(this.objdata.data.head.id, 'moveid');
      } else {
        this.config.proxy.$msgbox(res.cerror);
      }
    });
  };

  fnCancel = () => {
    if (this.objdata.data.head.id === '') {
      this.config.proxy.$msgbox.alert('请选择单据');
    }
    if (this.objdata.data.head.istatus >= -80) {
      this.config.proxy.$msgbox
        .confirm(
          this.objdata.data.head.istatus === -80 ? '确认反作废?' : '确认作废',
          '提醒',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
        )
        .then(() => {
          this.config.callback({
            iresult: 0,
            cerror: '',
            coper: 'beforecancel',
            data: null,
          });
          let params = {
            cobject: this.config.cobjectt,
            coper: this.objdata.data.head.istatus === -80 ? 'cancelr' : 'cancel',
            objpara: {
              id: this.objdata.data.head.id,
            },
          };
          this.config.proxy.$execute(params).then((res) => {
            if (res.iresult == 0) {
              this.objdata.data.head.istatus = res.data;
              this.config.proxy.$message({
                showClose: true,
                message:
                  this.objdata.data.head.istatus === -80 ? '作废成功~' : '反作废成功',
                type: 'success',
              });
              this.onSearch();
            } else {
              this.config.proxy.$msgbox(res.cerror);
            }
          });
        });
    }
  };

  fnsync = (scope) => {
    this.objdata.loading = true;
    setTimeout(() => {
      let params = {
        cobject: this.config.cobjectt,
        coperation: scope,
        objparameter: {
          id: this.objdata.data.head.id,
        },
      };
      this.config.proxy.$execute(params).then((res) => {
        if (res.iresult != 0) {
          alert(res.cerror);
          this.objdata.loading = false;
          return;
        }
        this.objdata.data.head.istexch = res.data.istexch;
        this.objdata.data.head.idbak = res.data.idbak;
        this.objdata.data.head.ccodebak = res.data.ccodebak;
        this.objdata.data.head.cexch = res.data.cexch;
        this.objdata.data.head.iexch = res.data.iexch;
        this.config.proxy.$message({
          showClose: true,
          message: scope == 'cancel_ex' ? '撤销同步成功' : '同步成功',
          type: 'success',
        });
        this.objdata.loading = false;
      });
    }, 300);
  };

  fnClose = () => {
    if (this.objdata.data.head.id === '') {
      alert('请选择订单');
      return;
    }
    if (this.objdata.data.head.istatus <= 40) {
      this.config.proxy.$msgbox
        .confirm(
          this.objdata.data.head.istatus === 40 ? '确认反关闭?' : '确认关闭',
          '提醒',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
        )
        .then(() => {
          let params = {
            cobject: this.config.cobjectt,
            coperation: this.objdata.data.head.istatus === 40 ? 'closer' : 'close',
            objparameter: {
              id: this.objdata.data.head.id,
            },
          };
          this.config.proxy.$execute(params).then((res) => {
            if (res.iresult == 0) {
              this.objdata.data.head.istatus = res.data;
              this.config.proxy.$message({
                showClose: true,
                message:
                  this.objdata.data.head.istatus === 40 ? '关闭成功~' : '反关闭成功',
                type: 'success',
              });
            } else {
              this.config.proxy.$msgbox(res.cerror);
            }
          });
        });
    }
  };
  fninitobj = () => {
    if (this.objdata.props) {
      this.objdata.data.head = this.fncreateobj('head');
    } else {
      Object.keys(this.objdata.data.head).forEach(
        (key) => (this.objdata.data.head[key] = this.objdata.init[key])
      );
    }
    // this.objdata.data.head.id = this.config.proxy.$utils.comm.getGuid();
    if ('irowstatus' in this.objdata.data.head) {
      this.objdata.data.head.irowstatus = 2;
    }
    if ('iinout' in this.objdata.data.head) {
      this.objdata.data.head.iinout = this.objdata.vouch.iinout;
    }
    if ('iinouth' in this.objdata.data.head) {
      this.objdata.data.head.iinouth = this.objdata.vouch.iinouth;
    }
    // this.objdata.data.head.id = this.config.proxy.$utils.comm.getGuid();
    if (this.objdata.status.iflag == 0) {
      // YYYY-MM-DD HH:mm:ss
      this.objdata.data.head.ddate = this.config.proxy.$utils.dtformat.fomatTime(new Date(), 'time');
      this.objdata.data.head.idwf = !this.objdata.data.head.idwf
        ? this.objdata.vouch.idwf
        : this.objdata.data.head.idwf;
      this.objdata.data.head.cnamewf = !this.objdata.data.head.cnamewf
        ? this.objdata.vouch.cnamewf
        : this.objdata.data.head.cnamewf;
      this.objdata.data.head.iwf = !this.objdata.data.head.iwf
        ? this.objdata.vouch.iwf
        : this.objdata.data.head.iwf;
      this.objdata.data.head.idtable = !this.objdata.data.head.idtable
        ? this.objdata.vouch.idtable
        : this.objdata.data.head.idtable;
      this.objdata.data.head.ccodetable = !this.objdata.data.head.ccodetable
        ? this.objdata.vouch.ccodetable
        : this.objdata.data.head.ccodetable;
      this.objdata.data.head.idbustype = !this.objdata.data.head.idbustype
        ? this.objdata.vouch.idbustype
        : this.objdata.data.head.idbustype;
      this.objdata.data.head.ccodebustype = !this.objdata.data.head.ccodebustype
        ? this.objdata.vouch.ccodebustype
        : this.objdata.data.head.ccodebustype;
      this.objdata.data.head.cnamebustype = !this.objdata.data.head.cnamebustype
        ? this.objdata.vouch.cnamebustype
        : this.objdata.data.head.cnamebustype;
      this.objdata.data.head.idvouch = !this.objdata.data.head.idvouch
        ? this.objdata.vouch.idvouch
        : this.objdata.data.head.idvouch;
      this.objdata.data.head.ccodevouch = !this.objdata.data.head.ccodevouch
        ? this.objdata.vouch.ccodevouch
        : this.objdata.data.head.ccodevouch;
      this.objdata.data.head.cnamevouch = !this.objdata.data.head.cnamevouch
        ? this.objdata.vouch.cnamevouch
        : this.objdata.data.head.cnamevouch;
      this.objdata.data.head.idvouchr = !this.objdata.data.head.idvouchr
        ? this.objdata.vouch.idvouchr
        : this.objdata.data.head.idvouchr;
      this.objdata.data.head.iddept = !this.objdata.data.head.iddept
        ? this.objdata.vouch.iwf == 1
          ? store.state.user.idwfdept
          : store.state.user.iddept
        : this.objdata.data.head.iddept;
      this.objdata.data.head.cbardept = !this.objdata.data.head.cbardept
        ? this.objdata.vouch.iwf == 1
          ? store.state.user.cbarwfdept
          : store.state.user.cbardept
        : this.objdata.data.head.cbardept;
      this.objdata.data.head.ccodedept = !this.objdata.data.head.ccodedept
        ? this.objdata.vouch.iwf == 1
          ? store.state.user.ccodewfdept
          : store.state.user.ccodedept
        : this.objdata.data.head.ccodedept;
      this.objdata.data.head.cnamedept = !this.objdata.data.head.cnamedept
        ? this.objdata.vouch.iwf == 1
          ? store.state.user.cnamewfdept
          : store.state.user.cnamedept
        : this.objdata.data.head.cnamedept;
      this.objdata.data.head.idbusdept = !this.objdata.data.head.idbusdept
        ? store.state.user.idfidept
        : this.objdata.data.head.idbusdept;
      this.objdata.data.head.cbarbusdept = !this.objdata.data.head.cbarbusdept
        ? store.state.user.cbardept
        : this.objdata.data.head.cbarbusdept;
      this.objdata.data.head.ccodebusdept = !this.objdata.data.head.ccodebusdept
        ? store.state.user.ccodedept
        : this.objdata.data.head.ccodebusdept;
      this.objdata.data.head.cnamebusdept = !this.objdata.data.head.cnamebusdept
        ? store.state.user.cnamefidept
        : this.objdata.data.head.cnamebusdept;
      this.objdata.data.head.idfidept = !this.objdata.data.head.idfidept
        ? store.state.user.idfidept
        : this.objdata.data.head.idfidept;
      this.objdata.data.head.cbarfidept = !this.objdata.data.head.cbarfidept
        ? store.state.user.cbarfidept
        : this.objdata.data.head.cbarfidept;
      this.objdata.data.head.ccodefidept = !this.objdata.data.head.ccodefidept
        ? store.state.user.ccodefidept
        : this.objdata.data.head.ccodefidept;
      this.objdata.data.head.cnamefidept = !this.objdata.data.head.cnamefidept
        ? store.state.user.cnamefidept
        : this.objdata.data.head.cnamefidept;
      this.objdata.data.head.idpsn = !this.objdata.data.head.idpsn
        ? store.state.user.idempl
        : this.objdata.data.head.idpsn;
      this.objdata.data.head.cnamepsn = !this.objdata.data.head.cnamepsn
        ? store.state.user.cnameempl
        : this.objdata.data.head.cnamepsn;
      this.objdata.data.head.idbuspsn = !this.objdata.data.head.idbuspsn
        ? store.state.user.idempl
        : this.objdata.data.head.idbuspsn;
      this.objdata.data.head.cnamebuspsn = !this.objdata.data.head.cnamebuspsn
        ? store.state.user.cnameempl
        : this.objdata.data.head.cnamebuspsn;
      this.objdata.data.head.idpos = !this.objdata.data.head.idpos
        ? this.objdata.vouch.iwf == 1
          ? store.state.user.idwfpos
          : store.state.user.idpos
        : this.objdata.data.head.idpos;
      this.objdata.data.head.cnamepos = !this.objdata.data.head.cnamepos
        ? this.objdata.vouch.iwf == 1
          ? store.state.user.cnamewfpos
          : store.state.user.cnamepo
        : this.objdata.data.head.cnamepos;
      this.objdata.data.head.idbuspos = !this.objdata.data.head.idbuspos
        ? store.state.user.idpos
        : this.objdata.data.head.idbuspos;
      this.objdata.data.head.cnamebuspos = !this.objdata.data.head.cnamebuspos
        ? store.state.user.cnamepos
        : this.objdata.data.head.cnamebuspos;
      this.objdata.data.head.idmaker = !this.objdata.data.head.idmaker
        ? store.state.user.iduser
        : this.objdata.data.head.idmaker;
      this.objdata.data.head.cmaker = !this.objdata.data.head.cmaker
        ? store.state.user.cnameuser
        : this.objdata.data.head.cmaker;
      this.objdata.data.head.idempl = !this.objdata.data.head.idempl
        ? store.state.user.idempl
        : this.objdata.data.head.idempl;
      this.objdata.data.head.cnameempl = !this.objdata.data.head.cnameempl
        ? store.state.user.cnameempl
        : this.objdata.data.head.cnameempl;
      this.objdata.data.head.idbusorg = !this.objdata.data.head.idbusorg
        ? ''
        : this.objdata.data.head.idbusorg;
      this.objdata.data.head.cnamebusorg = !this.objdata.data.head.cnamebusorg
        ? ''
        : this.objdata.data.head.cnamebusorg;
      this.objdata.data.head.idpayway = !this.objdata.data.head.idpayway
        ? this.objdata.vouch.idpayway
        : this.objdata.data.head.idpayway;
      this.objdata.data.head.cnamepayway = !this.objdata.data.head.cnamepayway
        ? this.objdata.vouch.cnamepayway
        : this.objdata.data.head.cnamepayway;
      Object.keys(this.objdata.init_new).forEach(
        (key) => (this.objdata.init_new[key] = this.objdata.data.head[key])
      );
    }
    if (this.objdata.data.ctl)
      Object.keys(this.objdata.data.ctl).forEach(
        (key) => (this.objdata.data.ctl[key] = this.objdata.initctl[key])
      );
    for (let key in this.objdata.data) {
      if (this.objdata.data.hasOwnProperty(key)) {
        if (Object.keys(this.objdata.islst).length !== 0) {
          if (this.objdata.islst[key] && this.objdata.islst[key] == 1) {
            this.objdata.data[key] = [];
          } else if (key != 'head' && key != 'ctl') {
            let obj = null;
            obj = this.fncreateobj(key);
            if (obj) {
              this.objdata.data[key] = obj;
            }
          }
        } else {
          if (key != 'head' && key != 'ctl') {
            if (key == 'details') {
              this.objdata.data[key] = [];
            } else if (key.indexOf('lst') !== -1) {
              this.objdata.data[key] = [];
            } else {
              let obj = null;
              obj = this.fncreateobj(key);
              if (obj) {
                this.objdata.data[key] = obj;
              }
            }
          }
        }

        if (this.objdata.status.iflag == 0 || this.objdata.statusf.iflag == 0) {
          if (key == 'details') {
            this.fnaddrow('details');
          }
        }
      }
    }
    for (let key in this.objdata.del) {
      if (this.objdata.del.hasOwnProperty(key)) {
        this.objdata.del[key] = [];
      }
    }
    this.objdata.isshowstate = false;
    this.objsearch.iiptype = 0;
    this.objsearch.itype = 0;
    this.config.callback({ iresult: 0, cerror: '', coper: 'initobj', data: null });
  };
  focusSelect = (event) => {
    if ('select' in event.target && typeof event.target.select == 'function') {
      event.target.select();
    }
  };
  fncreateobj = (cobj) => {
    let obj = null;
    let temp = null;
    let isAllSpaces = false;
    try {
      if (this.objdata.columns[cobj]) {
        obj = {};
        for (let i1 = 0; i1 < this.objdata.columns[cobj].length; i1++) {
          if (this.objdata.columns[cobj][i1].cfield == '') {
            switch (this.objdata.columns[cobj][i1].cobject) {
              case 'i':
                obj[this.objdata.columns[cobj][i1].prop] = 0;
                continue;
              case 'o':
                obj[this.objdata.columns[cobj][i1].prop] = {};
                continue;
              case 'a':
                obj[this.objdata.columns[cobj][i1].prop] = [];
                continue;
            }
          }
          if (
            this.objdata.columns[cobj][i1].cdefault &&
            this.objdata.columns[cobj][i1].cdefault != '' &&
            this.objdata.columns[cobj][i1].cdefault.startsWith('props')
          ) {
            let params = this.objdata.columns[cobj][i1].cdefault.split('.');
            if (params.length >= 2) {
              obj[this.objdata.columns[cobj][i1].prop] = this.objdata.props[params[1]];
            }
          } else if (
            this.objdata.columns[cobj][i1].cdefault &&
            this.objdata.columns[cobj][i1].cdefault != '' &&
            this.objdata.columns[cobj][i1].cdefault.startsWith('paras')
          ) {
            let params = this.objdata.columns[cobj][i1].cdefault.split('.');
            if (params.length >= 2) {
              obj[this.objdata.columns[cobj][i1].prop] = this.objdata.paras[params[1]];
            }
          } else {
            switch (this.objdata.columns[cobj][i1].itype) {
              case 5:
                if (
                  this.objdata.columns[cobj][i1].cdefault &&
                  this.objdata.columns[cobj][i1].cdefault != ''
                ) {
                  isAllSpaces = /^ +$/.test(this.objdata.columns[cobj][i1].cdefault);
                  temp = parseInt(this.objdata.columns[cobj][i1].cdefault);
                  if (isAllSpaces)
                    obj[this.objdata.columns[cobj][i1].prop] = this.objdata.columns[cobj][
                      i1
                    ].cdefault;
                  else if (!isNaN(temp)) obj[this.objdata.columns[cobj][i1].prop] = temp;
                  else if (this.objdata.columns[cobj][i1].option.length > 0)
                    obj[this.objdata.columns[cobj][i1].prop] = this.objdata.columns[cobj][
                      i1
                    ].option[0].value;
                  else obj[this.objdata.columns[cobj][i1].prop] = 0;
                } else {
                  if (this.objdata.columns[cobj][i1].option.length > 0)
                    obj[this.objdata.columns[cobj][i1].prop] = this.objdata.columns[cobj][
                      i1
                    ].option[0].value;
                  else obj[this.objdata.columns[cobj][i1].prop] = 0;
                }
                break;
              case 51:
                if (
                  this.objdata.columns[cobj][i1].cdefault &&
                  this.objdata.columns[cobj][i1].cdefault != ''
                ) {
                  isAllSpaces = /^ +$/.test(this.objdata.columns[cobj][i1].cdefault);
                  temp = parseInt(this.objdata.columns[cobj][i1].cdefault);
                  if (isAllSpaces)
                    obj[this.objdata.columns[cobj][i1].prop] = this.objdata.columns[cobj][
                      i1
                    ].cdefault;
                  else if (!isNaN(temp)) obj[this.objdata.columns[cobj][i1].prop] = temp;
                  else obj[this.objdata.columns[cobj][i1].prop] = 0;
                } else {
                  obj[this.objdata.columns[cobj][i1].prop] = 0;
                }
                break;
              case 1:
              case 2:
                if (
                  this.objdata.columns[cobj][i1].cdefault &&
                  this.objdata.columns[cobj][i1].cdefault != ''
                ) {
                  temp = parseFloat(this.objdata.columns[cobj][i1].cdefault);
                  if (!isNaN(temp)) obj[this.objdata.columns[cobj][i1].prop] = temp;
                  else obj[this.objdata.columns[cobj][i1].prop] = 0;
                } else {
                  obj[this.objdata.columns[cobj][i1].prop] = 0;
                }
                break;
              case 6:
                if (
                  this.objdata.columns[cobj][i1].cdefault &&
                  this.objdata.columns[cobj][i1].cdefault != ''
                ) {
                  obj[
                    this.objdata.columns[cobj][i1].prop
                  ] = this.config.proxy.$utils.dtformat.fomatTime(
                    new Date(),
                    this.objdata.columns[cobj][i1].cdefault
                  );
                } else {
                  if (this.objdata.columns[cobj][i1].imust > 0) {
                    obj[this.objdata.columns[cobj][i1].prop] = new Date();
                  } else {
                    obj[this.objdata.columns[cobj][i1].prop] = null;
                  }
                }
                if (
                  this.objdata.columns[cobj][i1].prop2 &&
                  this.objdata.columns[cobj][i1].prop2 != ''
                ) {
                  let prop2Obj = this.format_prop2(this.objdata.columns[cobj][i1].prop2);
                  if (prop2Obj) {
                    if (prop2Obj.length == 1) {
                      obj[this.objdata.columns[cobj][i1].prop2] = null;
                    } else {
                      for (const key in prop2Obj.obj) {
                        if (prop2Obj.obj.hasOwnProperty(key)) {
                          obj[key] = null;
                        }
                      }
                    }
                  }
                }
                if (
                  this.objdata.columns[cobj][i1].propdp &&
                  this.objdata.columns[cobj][i1].propdp != ''
                ) {
                  obj[this.objdata.columns[cobj][i1].propdp] = null;
                }
                break;
              case 9:
                obj[this.objdata.columns[cobj][i1].prop] = [''];
                if (
                  this.objdata.columns[cobj][i1].prop2 &&
                  this.objdata.columns[cobj][i1].prop2 != ''
                ) {
                  let prop2Obj = this.format_prop2(this.objdata.columns[cobj][i1].prop2);
                  if (prop2Obj) {
                    if (prop2Obj.length == 1) {
                      obj[this.objdata.columns[cobj][i1].prop2] = '';
                    } else {
                      for (const key in prop2Obj.obj) {
                        if (prop2Obj.obj.hasOwnProperty(key)) {
                          obj[key] = '';
                        }
                      }
                    }
                  }
                }
                if (
                  this.objdata.columns[cobj][i1].propdp &&
                  this.objdata.columns[cobj][i1].propdp != ''
                ) {
                  obj[this.objdata.columns[cobj][i1].propdp] = '';
                }
                continue;
              case 90:
                obj[this.objdata.columns[cobj][i1].prop] = [];
                continue;
              default:
                if (
                  this.objdata.columns[cobj][i1].cdefault &&
                  this.objdata.columns[cobj][i1].cdefault != ''
                ) {
                  if (this.objdata.columns[cobj][i1].cdefault.startsWith('user')) {
                    let defaultlst = this.objdata.columns[cobj][i1].cdefault.split('.');
                    if (defaultlst.length == 2) {
                      obj[
                        this.objdata.columns[cobj][i1].prop
                      ] = this.config.proxy.$store.state.user[defaultlst[1]];
                    }
                  } else if (
                    this.objdata.columns[cobj][i1].cdefault.startsWith('vouch')
                  ) {
                    let defaultlst = this.objdata.columns[cobj][i1].cdefault.split('.');
                    if (defaultlst.length == 2) {
                      obj[this.objdata.columns[cobj][i1].prop] = this.objdata.vouch[
                        defaultlst[1]
                      ];
                    }
                  } else {
                    obj[this.objdata.columns[cobj][i1].prop] = this.objdata.columns[cobj][
                      i1
                    ].cdefault;
                  }
                } else {
                  obj[this.objdata.columns[cobj][i1].prop] = '';
                }

                if (
                  this.objdata.columns[cobj][i1].prop2 &&
                  this.objdata.columns[cobj][i1].prop2 != ''
                ) {
                  let prop2Obj = this.format_prop2(this.objdata.columns[cobj][i1].prop2);
                  if (prop2Obj) {
                    if (prop2Obj.length == 1) {
                      obj[this.objdata.columns[cobj][i1].prop2] = '';
                    } else {
                      for (const key in prop2Obj.obj) {
                        if (prop2Obj.obj.hasOwnProperty(key)) {
                          obj[key] = '';
                        }
                      }
                    }
                  }
                }
                if (
                  this.objdata.columns[cobj][i1].propdp &&
                  this.objdata.columns[cobj][i1].propdp != ''
                ) {
                  obj[this.objdata.columns[cobj][i1].propdp] = '';
                }

                break;
            }
          }
        }
      }
    } catch (e) {
      console.log('createobj error....', e);
      this.config.proxy.$msgbox(e.message);
    }
    return obj;
  };

  fncreateobj_def = (cobj, lst) => {
    let obj = null;
    let temp = null;
    let isAllSpaces = false;
    try {
      if (lst[cobj]) {
        obj = {};
        for (let i1 = 0; i1 < lst[cobj].length; i1++) {
          if (lst[cobj][i1].cfield == '') {
            switch (lst[cobj][i1].cobject) {
              case 'i':
                obj[lst[cobj][i1].prop] = 0;
                continue;
              case 'o':
                obj[lst[cobj][i1].prop] = {};
                continue;
              case 'a':
                obj[lst[cobj][i1].prop] = [];
                continue;
            }
          }
          if (
            lst[cobj][i1].cdefault &&
            lst[cobj][i1].cdefault != '' &&
            lst[cobj][i1].cdefault.startsWith('props')
          ) {
            let params = lst[cobj][i1].cdefault.split('.');
            if (params.length >= 2) {
              obj[lst[cobj][i1].prop] = this.objdata.props[params[1]];
            }
          } else if (
            lst[cobj][i1].cdefault &&
            lst[cobj][i1].cdefault != '' &&
            lst[cobj][i1].cdefault.startsWith('paras')
          ) {
            let params = lst[cobj][i1].cdefault.split('.');
            if (params.length >= 2) {
              obj[lst[cobj][i1].prop] = this.objdata.paras[params[1]];
            }
          } else {
            switch (lst[cobj][i1].itype) {
              case 5:
                if (lst[cobj][i1].cdefault && lst[cobj][i1].cdefault != '') {
                  isAllSpaces = /^ +$/.test(lst[cobj][i1].cdefault);
                  temp = parseInt(lst[cobj][i1].cdefault);
                  if (isAllSpaces) obj[lst[cobj][i1].prop] = lst[cobj][i1].cdefault;
                  else if (!isNaN(temp)) obj[lst[cobj][i1].prop] = temp;
                  else if (lst[cobj][i1].option.length > 0)
                    obj[lst[cobj][i1].prop] = lst[cobj][i1].option[0].value;
                  else obj[lst[cobj][i1].prop] = 0;
                } else {
                  if (lst[cobj][i1].option.length > 0)
                    obj[lst[cobj][i1].prop] = lst[cobj][i1].option[0].value;
                  else obj[lst[cobj][i1].prop] = 0;
                }
                break;
              case 51:
                if (lst[cobj][i1].cdefault && lst[cobj][i1].cdefault != '') {
                  isAllSpaces = /^ +$/.test(lst[cobj][i1].cdefault);
                  temp = parseInt(lst[cobj][i1].cdefault);
                  if (isAllSpaces) obj[lst[cobj][i1].prop] = lst[cobj][i1].cdefault;
                  else if (!isNaN(temp)) obj[lst[cobj][i1].prop] = temp;
                  else obj[lst[cobj][i1].prop] = 0;
                } else {
                  obj[lst[cobj][i1].prop] = 0;
                }
                break;
              case 1:
              case 2:
                if (lst[cobj][i1].cdefault && lst[cobj][i1].cdefault != '') {
                  temp = parseFloat(lst[cobj][i1].cdefault);
                  if (!isNaN(temp)) obj[lst[cobj][i1].prop] = temp;
                  else obj[lst[cobj][i1].prop] = 0;
                } else {
                  obj[lst[cobj][i1].prop] = 0;
                }
                break;
              case 6:
                if (lst[cobj][i1].cdefault && lst[cobj][i1].cdefault != '') {
                  obj[lst[cobj][i1].prop] = this.config.proxy.$utils.dtformat.fomatTime(
                    new Date(),
                    lst[cobj][i1].cdefault
                  );
                } else {
                  if (lst[cobj][i1].imust > 0) {
                    obj[lst[cobj][i1].prop] = new Date();
                  } else {
                    obj[lst[cobj][i1].prop] = null;
                  }
                }
                if (lst[cobj][i1].prop2 && lst[cobj][i1].prop2 != '') {
                  let prop2Obj = this.format_prop2(lst[cobj][i1].prop2);
                  if (prop2Obj) {
                    if (prop2Obj.length == 1) {
                      obj[lst[cobj][i1].prop2] = null;
                    } else {
                      for (const key in prop2Obj.obj) {
                        if (prop2Obj.obj.hasOwnProperty(key)) {
                          obj[key] = null;
                        }
                      }
                    }
                  }
                }
                if (lst[cobj][i1].propdp && lst[cobj][i1].propdp != '') {
                  obj[lst[cobj][i1].propdp] = null;
                }
                break;
              case 9:
                obj[lst[cobj][i1].prop] = [''];
                if (lst[cobj][i1].prop2 && lst[cobj][i1].prop2 != '') {
                  let prop2Obj = this.format_prop2(lst[cobj][i1].prop2);
                  if (prop2Obj) {
                    if (prop2Obj.length == 1) {
                      obj[lst[cobj][i1].prop2] = '';
                    } else {
                      for (const key in prop2Obj.obj) {
                        if (prop2Obj.obj.hasOwnProperty(key)) {
                          obj[key] = '';
                        }
                      }
                    }
                  }
                }
                if (lst[cobj][i1].propdp && lst[cobj][i1].propdp != '') {
                  obj[lst[cobj][i1].propdp] = '';
                }
                continue;
              case 90:
                obj[lst[cobj][i1].prop] = [];
                continue;
              default:
                if (lst[cobj][i1].cdefault && lst[cobj][i1].cdefault != '') {
                  if (lst[cobj][i1].cdefault.startsWith('user')) {
                    let defaultlst = lst[cobj][i1].cdefault.split('.');
                    if (defaultlst.length == 2) {
                      obj[lst[cobj][i1].prop] = this.config.proxy.$store.state.user[
                        defaultlst[1]
                      ];
                    }
                  } else if (lst[cobj][i1].cdefault.startsWith('vouch')) {
                    let defaultlst = lst[cobj][i1].cdefault.split('.');
                    if (defaultlst.length == 2) {
                      obj[lst[cobj][i1].prop] = this.objdata.vouch[defaultlst[1]];
                    }
                  } else {
                    obj[lst[cobj][i1].prop] = lst[cobj][i1].cdefault;
                  }
                } else {
                  obj[lst[cobj][i1].prop] = '';
                }

                if (lst[cobj][i1].prop2 && lst[cobj][i1].prop2 != '') {
                  let prop2Obj = this.format_prop2(lst[cobj][i1].prop2);
                  if (prop2Obj) {
                    if (prop2Obj.length == 1) {
                      obj[lst[cobj][i1].prop2] = '';
                    } else {
                      for (const key in prop2Obj.obj) {
                        if (prop2Obj.obj.hasOwnProperty(key)) {
                          obj[key] = '';
                        }
                      }
                    }
                  }
                }
                if (lst[cobj][i1].propdp && lst[cobj][i1].propdp != '') {
                  obj[lst[cobj][i1].propdp] = '';
                }

                break;
            }
          }
        }
      }
    } catch (e) {
      console.log('createobj error....', e);
      this.config.proxy.$msgbox(e.message);
    }
    return obj;
  };
  format_prop2 = (prop2) => {
    if (prop2 == '') return null;
    let obj = {};
    let delobj = {};
    // let prop2 = 'idcust:id,cbarcust:cbar,cnamecust:cname,idorg:idsaorg,cnameorg:cnamesaorg';
    let prop2lst = prop2.split(',');
    for (let i1 = 0; i1 < prop2lst.length; i1++) {
      let params = prop2lst[i1].split(':');
      if (params.length >= 2) {
        const key = params[0];
        const value = params[1];
        let delvalue = '';
        if (params.length >= 3) {
          delvalue = params[2];
        }
        obj[key] = value;
        delobj[key] = delvalue;
      }
    }
    var res = {
      length: prop2lst.length,
      obj,
      delobj,
    };
    return res;
  };
  onSearch_e = (idwfe, idwf, boolean) => {
    this.objdata.wf.idwfe = idwfe;
    this.objdata.wf.idwf = idwf;
    this.objdata.wf.isload = boolean;
    if (idwfe !== '' && idwf !== '' && this.objdata.data.head.istatus != 0) {
      let params = {
        cobject: 'com.ddnc.S700302T.WF7_WorkFlowT',
        coperation: 'search_e',
        objparameter: {
          id: idwfe,
          idwf: idwf,
        },
      };
      this.config.proxy.$execute(params).then((res) => {
        if (res.iresult != 0) {
          alert(res.cerror);
          return;
        }
        this.objdata.wf.copright = res.data.copright;
        this.objdata.wf.id_td = res.data.id_td;
        if (this.objdata.wf.copright == 'reply') this.objdata.wf.canreply = true;
        this.config.callback({ iresult: 0, cerror: '', coper: 'search_e', data: null });
      });
    }
  };
  onSave = (result) => {
    let details = [];
    if (this.objdata.data.head.istatus > 0) {
      this.objdata.wf.isload = true;
      let params = {
        cobject: this.config.cobjectt,
        coperation: 'wfsave',
        objparameter: {
          id: result.data.id,
          idwfes: result.data.id_td,
          ccmts: result.data.ccmts,
          copright:
            result.data.copright == '' ||
              result.data.copright == null ||
              result.data.copright == undefined
              ? null
              : result.data.copright,
          objright:
            result.data.copright == '' ||
              result.data.copright == null ||
              result.data.copright == undefined
              ? null
              : { details: details },
        },
      };
      this.config.proxy.$execute(params).then((res) => {
        if (res.iresult != 0) {
          this.objdata.wf.isload = false;
          alert(res.cerror);
          return;
        }
        result.data.ccmts = '';
        this.config.proxy.$message({
          showClose: true,
          message: '已暂存',
          type: 'success',
        });
        this.objdata.wf.isload = false;
        this.config.pageobj.fnmoveid(objdata.data.head.id);
      });
    } else {
      this.config.proxy.$message({
        showClose: true,
        message: '不可执行此操作',
        type: 'error',
      });
    }
  };
  onAgree = (result) => {
    if (this.objdata.data.head.istatus > 0) {
      this.objdata.wf.isload = true;
      let params = {
        cobject: this.config.cobjectt,
        coperation: 'wfapproval',
        objparameter: {
          id: result.data.id,
          idwfes: result.data.id_td,
          ccmts: result.data.ccmts,
        },
      };
      this.config.proxy.$execute(params).then((res) => {
        if (res.iresult != 0) {
          this.objdata.wf.isload = false;
          alert(res.cerror);
          return;
        }
        result.data.ccmts = '';
        this.config.proxy.$message({
          showClose: true,
          message: '已同意',
          type: 'success',
        });
        this.objdata.wf.isload = false;
        this.config.pageobj.fnmoveid(objdata.data.head.id);
      });
    } else {
      this.config.proxy.$message({
        showClose: true,
        message: '不可执行此操作',
        type: 'error',
      });
    }
  };
  closeCurrentTagsView = () => {
    this.config.proxy.$utils.comm.closeCurrentTagsView(this.config.route);
  };
  onBack = (result) => {
    console.log(result, 'res-back');
    if (this.objdata.data.head.istatus > 0) {
      let params = {
        cobject: this.config.cobjectt,
        coperation: 'wfreturn',
        objparameter: {
          id: result.data.id,
          idwfes: result.data.id_td,
          ccmts: result.data.ccmts,
          idret: result.data.idret,
          irettype: result.data.irettype,
        },
      };
      this.config.proxy.$execute(params).then((res) => {
        if (res.iresult != 0) {
          alert(res.cerror);
          return;
        }
        result.data.ccmts = '';
        this.config.proxy.$message({
          showClose: true,
          message: '已退回',
          type: 'success',
        });
        this.closeCurrentTagsView();
      });
    } else {
      this.config.proxy.$message({
        showClose: true,
        message: '不可执行此操作',
        type: 'error',
      });
    }
  };
  onClose = (result) => {
    if (this.objdata.data.head.istatus > 0) {
      let params = {
        cobject: this.config.cobjectt,
        coperation: 'wfreserved',
        objparameter: {
          id: result.data.id,
          idwfes: result.data.id_td,
          ccmts: result.data.ccmts,
        },
      };
      this.config.proxy.$execute(params).then((res) => {
        if (res.iresult != 0) {
          alert(res.cerror);
          return;
        }
        result.data.ccmts = '';
        this.config.proxy.$message({
          showClose: true,
          message: '已放弃',
          type: 'success',
        });
        this.config.pageobj.fnmoveid(this.objdata.data.head.id);
      });
    } else {
      this.config.proxy.$message({
        showClose: true,
        message: '不可执行此操作',
        type: 'error',
      });
    }
  };
  onPass = (result) => {
    if (this.objdata.data.head.istatus > 0) {
      this.objdata.wf.isload = true;
      let params = {
        cobject: this.config.cobjectt,
        coperation: 'wfpass',
        objparameter: {
          id: result.data.id,
          idwfes: result.data.id_td,
          ccmts: result.data.ccmts,
        },
      };
      this.config.proxy.$execute(params).then((res) => {
        if (res.iresult != 0) {
          this.objdata.wf.isload = false;
          alert(res.cerror);
          return;
        }
        result.data.ccmts = '';
        this.config.proxy.$message({
          showClose: true,
          message: '通过',
          type: 'success',
        });
        this.objdata.wf.isload = false;
        this.config.pageobj.fnmoveid(this.objdata.data.head.id);
      });
    } else {
      this.config.proxy.$message({
        showClose: true,
        message: '不可执行此操作',
        type: 'error',
      });
    }
  };
  onNoPass = (result) => {
    if (this.objdata.data.head.istatus > 0) {
      this.objdata.wf.isload = true;
      let params = {
        cobject: this.config.cobjectt,
        coperation: 'wfnopass',
        objparameter: {
          id: result.data.id,
          idwfes: result.data.id_td,
          ccmts: result.data.ccmts,
        },
      };
      this.config.proxy.$execute(params).then((res) => {
        if (res.iresult != 0) {
          this.objdata.wf.isload = false;
          alert(res.cerror);
          return;
        }
        result.data.ccmts = '';
        this.config.proxy.$message({
          showClose: true,
          message: '不通过',
          type: 'success',
        });
        this.objdata.wf.isload = false;
        this.config.pageobj.fnmoveid(this.objdata.data.head.id);
      });
    } else {
      this.config.proxy.$message({
        showClose: true,
        message: '不可执行此操作',
        type: 'error',
      });
    }
  };
  onUnApproval = (result) => {
    let params = {
      cobject: this.config.cobjectt,
      coperation: 'wfunapproval',
      objparameter: {
        id: this.objdata.data.head.idwfe,
        idwf: this.objdata.data.head.idwf,
        idwfes: result.data.ids,
      },
    };
    this.config.proxy.$execute(params).then((res) => {
      if (res.iresult != 0) {
        alert(res.cerror);
        sessionStorage.removeItem(result.data.ids);
        return;
      }
      result.data.ccmts = '';
      this.config.proxy.$message({
        showClose: true,
        message: '撤回成功',
        type: 'success',
      });
      this.config.pageobj.fnmoveid(this.objdata.data.head.id);
    });
  };
  onCirculated = (result) => {
    let params = {
      cobject: this.config.cobjectt,
      coperation: 'wfcirculate',
      objparameter: {
        idwfe: this.objdata.data.head.idwfe,
        idwfes: result.data.id_td,
        psnlst: result.data.psnlst,
      },
    };
    this.config.proxy.$execute(params).then((res) => {
      if (res.iresult != 0) {
        alert(res.cerror);
        return;
      }
      this.config.proxy.$message({
        showClose: true,
        message: '操作成功~',
        type: 'success',
      });
      this.config.pageobj.fnmoveid(this.objdata.data.head.id);
    });
  };
  onTransfer = (result) => {
    let params = {
      cobject: this.config.cobjectt,
      coperation: 'wftransfer',
      objparameter: {
        idwfe: this.objdata.data.head.idwfe,
        idwfes: result.data.id_td,
        psnlst: result.data.tflst,
      },
    };
    this.config.proxy.$execute(params).then((res) => {
      if (res.iresult != 0) {
        alert(res.cerror);
        return;
      }
      this.config.proxy.$message({
        showClose: true,
        message: '操作成功~',
        type: 'success',
      });
      this.config.pageobj.fnmoveid(this.objdata.data.head.id);
    });
  };

  onUpload = (cscope) => {
    if (this.objdata.status.iflag === 0 && this.objdata.data.head.istatus < 10) return;
    if (this.objdata.data.head.istatus >= 10 && this.objdata.wf.id_td == '') return;
    this.objsearch.objimg.cscope = cscope;
    this.objsearch.objimg.capp = 'oa';
    this.objsearch.objimg.cpath = 'attach';
    if (this.objdata.data.head.istatus >= 10) {
      this.objsearch.objimg.cobject = this.config.cobjectt;
      this.objsearch.objimg.coper = 'save_file';
      this.objsearch.objimg.cparams = this.objdata.data.head.id;
    }
    switch (this.objsearch.objimg.cscope) {
      case 'file':
        // objimg.ilimit = 1;
        break;
    }
    this.objsearch.objimg.isshow = true;
  };
  onSelectFile = (res) => {
    if (res.iresult != 0) {
      this.config.proxy.$msgbox(res.cerror);
    } else {
      switch (this.objsearch.objimg.cscope) {
        case 'file':
          if (res.data.length > 0) {
            let istart = this.objdata.data.aflst.length;
            for (let i1 = 0; i1 < res.data.length; i1++) {
              this.objdata.data.aflst.push({
                id: res.data[i1].cparams,
                idpsn: this.objdata.data.head.istatus == 0 ? '' : store.state.user.idempl,
                cnamepsn:
                  this.objdata.data.head.istatus == 0 ? '' : store.state.user.cnameempl,
                cnamefile: res.data[i1].cnamefile,
                idfile: res.data[i1].idfile,
                cfile: [res.data[i1].cfile],
                iorder: istart + i1 + 1,
                irowstatus: 2,
              });
            }
          }
          break;
      }
    }
    this.objsearch.objimg.isshow = false;
  };
  delfile = (item, index) => {
    if (this.objdata.status.iflag === 0 && this.objdata.data.head.istatus < 10) return;
    if (this.objdata.data.head.istatus >= 10 && item.idpsn !== store.state.user.idempl)
      return;
    if (this.objdata.data.head.istatus >= 10 && this.objdata.wf.id_td == '') return;
    this.config.proxy.$msgbox
      .confirm('确认删除?', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
      .then(() => {
        this.objdata.afdel.push(item.id);
        this.objdata.data.aflst.splice(index, 1);
        if (
          this.objdata.data.head.istatus >= 10 &&
          item.idpsn == store.state.user.idempl
        ) {
          let params = {
            cobject: this.config.cobjectt,
            coperation: 'delete_file',
            objparameter: {
              id: item.id,
            },
          };
          this.config.proxy.$execute(params).then((res) => {
            if (res.iresult != 0) {
              alert(res.cerror);
              return;
            }
          });
        }
      })
      .catch(() => { });
    return;
  };
  onDnload = (item, bdown) => {
    if (bdown) {
      this.fnFileDownload(item.idfile, item.cnamefile, bdown, this.fnhandleDownload);
    } else {
      this.fnFilePreview(item.idfile, item.cnamefile);
    }
  };
  onCloseImg = () => {
    this.objsearch.objimg.isshow = false;
  };

  fnFileDownload = (idfile, cnamefile, bdown) => {
    FileDownload(idfile, cnamefile, bdown, this.fnhandleDownload);
  };
  fnFilePreview = (idfile, cnamefile) => {
    FilePreview(idfile, cnamefile);
  };
  fnhandleDownload = (dataurl, contenttype, cnamefile, blob) => {
    switch (contenttype) {
      case 'image/png':
      case 'image/jpeg':
      case 'image/jpg':
      case 'application/pdf': {
        let page = window.open(dataurl);
        setTimeout(() => {
          page.document.title = cnamefile;
        }, 500);
        break;
      }
      case 'application/vnd.ms-excel':
        //后台导出excel
        break;
    }
  };
  deleteRow = (index, row, scope) => {
    if (this.objdata.status.iflag == 0 || this.objdata.statusf.iflag == 0) return;
    this.config.proxy.$msgbox
      .confirm('确认删除?', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
      .then(() => {
        if (row.irowstatus !== 2) {
          this.objdata.del[scope].push(row.id);
        }
        this.objdata.data[scope].splice(index, 1);
        this.objdata.inewrow = this.objdata.data[scope].length - 1;
      })
      .catch(() => { });
  };
  parseAndCheckCparams(cparams) {
    if (!cparams) {
      // 若cparams为空，返回默认结果
      return {
        allValid: true,
        emptyPaths: [],
        cparams: '',
      };
    }

    // 初始化变量
    const pairs = cparams.split(',');
    const queryArr = []; // 存储查询字符串片段
    const emptyPaths = []; // 存储空值路径

    // 提取公共的路径取值逻辑为内部函数，避免重复代码
    const getValueByPath = (path) => {
      let dataObj = null;
      // 支持head前缀（可扩展details等）
      if (path.startsWith('head')) {
        dataObj = this.objdata.data;
      }

      let value = dataObj;
      const pathSegments = path.split('.');
      for (const segment of pathSegments) {
        if (value === null || value === undefined) {
          value = '';
          break;
        }
        value = value[segment];
      }
      return value;
    };

    // 遍历每个键值对，同时完成解析和校验
    pairs.forEach((pair) => {
      const [key, path] = pair.split(':');
      if (!key || !path) return; // 跳过格式错误的项

      // 1. 调用公共方法获取路径对应的值
      const value = getValueByPath(path);

      // 2. 校验空值：空字符串、null、undefined 都视为空
      if (value === '' || value === null || value === undefined) {
        emptyPaths.push(path); // 记录空值路径
      }

      // 3. 拼接查询字符串（空字符串转成''）
      if (value !== null && value !== undefined) {
        const finalValue = value === '' ? "''" : value;
        queryArr.push(`${key}=${finalValue}`);
      }
    });

    // 生成最终返回结果
    return {
      allValid: emptyPaths.length === 0, // 所有字段非空则为true
      emptyPaths: emptyPaths, // 为空的字段路径数组
      cparams: queryArr.join('&'), // 拼接后的查询字符串
    };
  }
  fnimportRow = (cobject, coper, cparams) => {
    // cparams = 'idbustype:head.idbustype,idsupp:head.idsupp'
    let emptyFiled = [];
    if (!this.parseAndCheckCparams(cparams).allValid) {
      this.parseAndCheckCparams(cparams).emptyPaths.forEach((item) => {
        const [obj, cfield] = item.split('.');
        if (obj.startsWith('head')) {
          const targetItem = this.objdata.columns.head.find(
            (itemCol) => itemCol.prop === cfield
          );
          if (targetItem) {
            emptyFiled.push(targetItem.label);
          }
        }
      });
      this.config.proxy.$msgbox.alert(`以下字段值为空：${emptyFiled.join(', ')}`);
      return;
    }
    this.objsearch.objimp.cobject = !cobject ? this.config.cobjectt : cobject;
    this.objsearch.objimp.coper = !coper ? 'import' : coper;
    this.objsearch.objimp.cparams = this.parseAndCheckCparams(cparams).cparams;
    this.objsearch.objimp.isshow = true;
  };
  onImport = (res, cfield) => {
    //导入
    for (let i1 = 0; i1 < res.data.length; i1++) {
      let idx = this.objdata.data.details.findIndex(
        (i) => i[cfield] === res.data[i1][cfield]
      );
      if (idx === -1) {
        fninputImp(res.data[i1]);
      } else {
        this.objdata.del.details.push(this.objdata.data.details[idx].id);
        this.objdata.data.details.splice(idx, 1);
        fninputImp(res.data[i1]);
      }
    }
    this.objsearch.objimp.isshow = false;
  };
  onCloseImp = () => {
    this.objsearch.objimp.isshow = false;
  };
  fninputImp = (row) => {
    row.irowstatus = 2;
    // if ('nqty' in row) {
    //   row.nqty = row.nqty.toFixed(row.idec);
    // }
    // if ('nqtyb' in row) {
    //   row.nqtyb = row.nqtyb.toFixed(row.idecb);
    // }
    // if ('nmoney' in row) {
    //   row.nmoney = (row.npriceb * row.nqtyb).toFixed(store.state.user.imdec);
    // }
    this.objdata.data.details.unshift(row);
    this.objdata.inewrow = objdata.data.details.length - 1;
  };

  onFunc = (cfield, res) => {
    switch (cfield) {
      case 'Refresh':
        this.fnrefresh();
        break;
      case 'Search':
        this.onSearch();
        break;
      case 'Save':
        this.fnsave(true);
        break;
      case 'New':
        this.fnnew();
        break;
      case 'NewChildren':
        this.fnnew2_children();
        break;
      case 'Edit':
        this.fnedit();
        break;
      case 'Commit':
        this.fncommit();
        break;
      case 'Verify':
        this.fnverify();
        break;
      case 'Close':
        this.fnClose();
        break;
      case 'Cancel':
        this.fnCancel();
        break;
      case 'Delete':
        this.fndelete();
        break;
      case 'Commitbt':
        this.fncommitbat();
        break;
      case 'Commitrbt':
        this.fncommitrbat();
        break;
      case 'Verifybt':
        this.fnverifybat();
        break;
      case 'Verifyrbt':
        this.fnverifyrbat();
        break;
      case 'Cancelbt':
        this.fncancelbat();
        break;
      case 'Verifyrbt':
        this.fncancelrbat();
        break;
      case 'Deletebt':
        this.fndeletebt();
        break;

      case 'Today':
        result = this.config.proxy.$utils.dtformat.getTodayRange();
        this.objsearch.filter.dstart = result.dstart;
        this.objsearch.filter.dend = result.dend;
        this.onSearch();
        break;
      case 'Week':
        result = this.config.proxy.$utils.dtformat.getThisWeekRange();
        this.objsearch.filter.dstart = result.dstart;
        this.objsearch.filter.dend = result.dend;
        this.onSearch();
        break;
      case 'Month':
        result = this.config.proxy.$utils.dtformat.getThisMonthRange();
        this.objsearch.filter.dstart = result.dstart;
        this.objsearch.filter.dend = result.dend;
        this.onSearch();
        break;
      case 'Year':
        result = this.config.proxy.$utils.dtformat.getThisYearRange();
        this.objsearch.filter.dstart = result.dstart;
        this.objsearch.filter.dend = result.dend;
        this.onSearch();
        break;

      case 'Print':
        this.fnprint();
        break;
      case 'OutputExcel':
        this.exportExcelVO();
        break;
      case 'OutputPdf':
        this.fnprint();
        break;

      case 'AddRow':
        this.fnaddrow('details');
        break;
      case 'RowImport':
        this.fnimportRow(res.item.cobject, res.item.coper, res.item.cparams);
        break;
      case 'RowExport':
        this.fnexportRow();
        break;

      case 'isnew':
        return this.isnew;
      case 'cannew':
        return this.cannew;
      case 'isnew_children':
        return this.isnew_children;
      case 'cannew_children':
        return this.cannew_children;
      case 'isedit':
        return this.isedit;
      case 'canedit':
        return this.canedit;
      case 'canedit_base':
        return this.canedit_base;
      case 'cansave':
        return this.cansave;
      case 'iscommit':
        return this.iscommit;
      case 'cancommit':
        return this.cancommit;
      case 'isverify':
        return this.isverify;
      case 'canverify':
        return this.canverify;
      case 'isclose':
        return this.isclose;
      case 'canclose':
        return this.canclose;
      case 'iscancel':
        return this.iscancel;
      case 'cancancel':
        return this.cancancel;
      case 'candelete':
        return this.candelete;
      case 'canaddrow':
        return this.canaddrow;
    }
  };
  onFormatBtnValue = (value, cfield) => {
    switch (cfield) {
      case 'iname':
      case 'idisabled':
        if (value) return 0;
        else return 1;
    }
  };
  onStandBtnClick = (res) => {
    console.log('-----res', res);
    this.onBtnClick(this, res.ibtntypes, res);
  };
  onBtnClick = (ref, ibtntypes, res) => {
    switch (ibtntypes) {
      case 0:
        ref.onFunc('Refresh', res);
        break;
      case 1:
        ref.onFunc('Search', res);
        break;
      case 2:
        ref.onFunc('Save', res);
        break;
      case 3:
        ref.onFunc('New', res);
        break;
      case 4:
      case 5:
        ref.onFunc('Edit', res);
        break;
      case 6:
        ref.onFunc('Commit', res);
        break;
      case 7:
        ref.onFunc('Verify', res);
        break;
      case 8:
        ref.onFunc('Close', res);
        break;
      case 13:
        ref.onFunc('NewChildren', res);
        break;
      case 17:
        ref.onFunc('Cancel', res);
        break;
      case 18:
      case 19:
        ref.onFunc('Delete', res);
        break;
      case 20:
        ref.onFunc('Commitbt', res);
        break;
      case 21:
        ref.onFunc('Commitrbt', res);
        break;
      case 22:
        ref.onFunc('Verifybt', res);
        break;
      case 23:
        ref.onFunc('Verifyrbt', res);
        break;
      case 26:
        ref.onFunc('Cancelbt', res);
        break;
      case 27:
        ref.onFunc('Cancelrbt', res);
        break;
      case 28:
      case 29:
        ref.onFunc('Deletebt', res);
        break;
      case 31:
        ref.onFunc('Today', res);
        break;
      case 32:
        ref.onFunc('Week', res);
        break;
      case 33:
        ref.onFunc('Month', res);
        break;
      case 34:
        ref.onFunc('Year', res);
        break;
      case 70:
        ref.onFunc('Print', res);
        break;
      case 71:
        ref.onFunc('OutputExcel', res);
        break;
      case 72:
        ref.onFunc('OutputPdf', res);
        break;
      case 80:
        // 子表增行
        ref.onFunc('AddRow', res);
        break;
      case 81:
        // 子表导入
        ref.onFunc('RowImport', res);
        break;
      case 82:
        // 子表导出
        ref.onFunc('RowExport', res);
        break;
    }
  };
  onBtnValueChange = (ref, ibtntypes) => {
    switch (ibtntypes) {
      case 2:
        if ('cansave' in this.objdata.btnstatus) {
          this.objdata.btnstatus.cansave = ref.onFunc('cansave');
        }
        break;
      case 3:
        if ('isnew' in this.objdata.btnstatus) {
          this.objdata.btnstatus.isnew = ref.onFunc('isnew');
        }
        if ('cannew' in this.objdata.btnstatus) {
          this.objdata.btnstatus.cannew = ref.onFunc('cannew');
        }
        console.log('this.objdata.btnstatus', this.objdata.btnstatus);
        break;
      case 4:
        if ('isedit' in this.objdata.btnstatus) {
          this.objdata.btnstatus.isedit = ref.onFunc('isedit');
        }
        if ('canedit' in this.objdata.btnstatus) {
          this.objdata.btnstatus.canedit = ref.onFunc('canedit');
        }
        break;
      case 5:
        if ('isedit' in this.objdata.btnstatus) {
          this.objdata.btnstatus.isedit = ref.onFunc('isedit');
        }
        if ('canedit_base' in this.objdata.btnstatus) {
          this.objdata.btnstatus.canedit_base = ref.onFunc('canedit_base');
        }
        break;
      case 6:
        if ('iscommit' in this.objdata.btnstatus) {
          this.objdata.btnstatus.iscommit = ref.onFunc('iscommit');
        }
        if ('cancommit' in this.objdata.btnstatus) {
          this.objdata.btnstatus.cancommit = ref.onFunc('cancommit');
        }
        break;
      case 7:
        if ('isverify' in this.objdata.btnstatus) {
          this.objdata.btnstatus.isverify = ref.onFunc('isverify');
        }
        if ('canverify' in this.objdata.btnstatus) {
          this.objdata.btnstatus.canverify = ref.onFunc('canverify');
        }
        break;
      case 8:
        if ('isclose' in this.objdata.btnstatus) {
          this.objdata.btnstatus.isclose = ref.onFunc('isclose');
        }
        if ('canclose' in this.objdata.btnstatus) {
          this.objdata.btnstatus.canclose = ref.onFunc('canclose');
        }
        break;
      case 13:
        if ('isnew_children' in this.objdata.btnstatus) {
          this.objdata.btnstatus.isnew_children = ref.onFunc('isnew_children');
        }
        if ('cannew_children' in this.objdata.btnstatus) {
          this.objdata.btnstatus.cannew_children = ref.onFunc('cannew_children');
        }
        break;
      case 17:
        if ('iscancel' in this.objdata.btnstatus) {
          this.objdata.btnstatus.iscancel = ref.onFunc('iscancel');
        }
        if ('cancancel' in this.objdata.btnstatus) {
          this.objdata.btnstatus.cancancel = ref.onFunc('cancancel');
        }
        break;
      case 18:
        if ('candelete' in this.objdata.btnstatus) {
          this.objdata.btnstatus.candelete = ref.onFunc('candelete');
        }
        break;
      case 80:
      case 81:
        if ('canaddrow' in this.objdata.btnstatus) {
          this.objdata.btnstatus.canaddrow = ref.onFunc('canaddrow');
        }
        break;
    }
  };
  onWatchBtnStatus = (ref, type, sourceType) => {
    // 1. 解构+可选链提取所有公共变量，统一兜底，减少重复调用
    const { mnus } = this.objsearch || {};
    const mnuData = mnus?.[sourceType] || {};
    const { lst = [], csysbar = '' } = mnuData;
    const targetList = this.objsearch?.initmuns?.[type]?.[csysbar] ?? [];

    // 2. 核心：抽离重复的按钮处理逻辑为独立函数（复用核心）
    const handleBtnItem = (btnItem) => {
      if (btnItem?.ibtntype === 8 || btnItem?.ibtntype === 11) {
        ref.onBtnValueChange(ref, btnItem?.ibtntypes);
      }
    };

    // 3. 抽离列表遍历逻辑（处理单层item+嵌套children）
    const traverseBtnList = (list) => {
      list.forEach((item) => {
        const children = item?.children ?? [];
        // 无子节点处理当前item，有子节点遍历子节点处理
        children.length === 0 ? handleBtnItem(item) : children.forEach(handleBtnItem);
      });
    };

    // 4. 精简判断条件，执行对应列表的遍历
    const isUseInitMuns = lst.length === 0 && csysbar !== '';
    traverseBtnList(isUseInitMuns ? targetList : lst);
  };
  fnformatOpt = (row, value, lst) => {
    if (!row || !lst) return;
    let idx_s = lst.findIndex((i) => i.value == value);
    if (idx_s != -1) return lst[idx_s].label;
    else return value;
  };
  deepClone(obj, cache = new WeakMap()) {
    // 1. 处理 null/undefined/基本类型（直接返回，兜底）
    if (obj === null || typeof obj !== 'object') return obj;

    // 2. 处理循环引用（关键：避免递归死循环）
    if (cache.has(obj)) return cache.get(obj);

    // 3. 处理 Vue 响应式对象（Proxy）- 先解包
    if (obj.__v_isReactive || obj.__v_isRef) {
      // 简易解包：如果项目引入了 Vue，也可以用 toRaw(obj)
      obj = JSON.parse(JSON.stringify(obj));
    }

    // 4. 处理 Date 类型
    if (obj instanceof Date) {
      const newDate = new Date(obj.getTime());
      cache.set(obj, newDate); // 加入缓存
      return newDate;
    }

    // 5. 处理 RegExp 类型
    if (obj instanceof RegExp) {
      const newReg = new RegExp(obj.source, obj.flags);
      cache.set(obj, newReg); // 加入缓存
      return newReg;
    }

    // 6. 处理数组
    if (Array.isArray(obj)) {
      const newArr = [];
      cache.set(obj, newArr); // 加入缓存
      obj.forEach((item, index) => {
        newArr[index] = this.deepClone(item, cache); // 注意：用 this. 调用自身
      });
      return newArr;
    }

    // 7. 处理纯对象（核心：加异常捕获）
    if (obj instanceof Object && !Array.isArray(obj)) {
      const newObj = {};
      cache.set(obj, newObj); // 加入缓存
      // 遍历属性 + try/catch 防止访问异常
      Reflect.ownKeys(obj).forEach(key => {
        try {
          newObj[key] = this.deepClone(obj[key], cache); // 注意：用 this. 调用自身
        } catch (e) {
          console.warn(`拷贝属性 ${String(key)} 失败:`, e);
          newObj[key] = obj[key]; // 降级返回原属性，避免整体崩溃
        }
      });
      return newObj;
    }

    // 8. 其他类型（函数/内置对象等，直接返回原引用）
    return obj;
  }
  isDeepEqual(a, b) {
    // 1. 先判断类型是否相同
    if (typeof a !== typeof b) return false;

    // 2. 处理 null/undefined
    if (a === null || b === null) return a === b;

    // 3. 处理基本类型（数字、字符串、布尔、Symbol）
    if (typeof a !== 'object') return a === b;

    // 4. 处理 Date 类型
    if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();

    // 5. 处理 Array 类型
    if (a instanceof Array && b instanceof Array) {
      // 先判断长度是否一致
      if (a.length !== b.length) return false;
      // 遍历每个元素，递归对比
      for (let i = 0; i < a.length; i++) {
        if (!this.isDeepEqual(a[i], b[i])) return false;
      }
      return true;
    }

    // 6. 处理 Object 类型（排除数组/Date）
    if (a instanceof Object && b instanceof Object) {
      // 获取所有自有属性名（包括不可枚举属性）
      const keysA = Reflect.ownKeys(a);
      const keysB = Reflect.ownKeys(b);
      // 先判断属性数量是否一致
      if (keysA.length !== keysB.length) return false;
      // 遍历每个属性，递归对比
      for (const key of keysA) {
        if (!keysB.includes(key)) return false; // 属性名不存在
        if (!this.isDeepEqual(a[key], b[key])) return false; // 属性值不一致
      }
      return true;
    }

    // 7. 其他类型（如 Function，判断引用是否一致）
    return a === b;
  }
  isObjectDeepEqual(obj1, obj2) {
    // 1. 首先严格判断是否为纯 Object 类型（排除数组、null、Date等）
    const isPureObject = (val) =>
      val !== null && typeof val === 'object' && !Array.isArray(val) && !(val instanceof Date);

    // 非纯对象直接返回 false
    if (!isPureObject(obj1) || !isPureObject(obj2)) return false;

    // 2. 获取两个对象的所有自有属性名（包括不可枚举、Symbol 属性）
    const keys1 = Reflect.ownKeys(obj1);
    const keys2 = Reflect.ownKeys(obj2);

    // 3. 属性数量不一致，直接不相等
    if (keys1.length !== keys2.length) return false;

    // 4. 遍历所有属性，递归对比值
    for (const key of keys1) {
      // 属性名不存在，直接不相等
      if (!keys2.includes(key)) return false;

      const val1 = obj1[key];
      const val2 = obj2[key];

      // 子值是纯对象：递归判断
      if (isPureObject(val1) && isPureObject(val2)) {
        if (!this.isObjectDeepEqual(val1, val2)) return false;
      }
      // 子值是基本类型/其他类型：直接严格相等判断
      else {
        // 特殊处理 Date 子值（如果对象属性里有 Date）
        if (val1 instanceof Date && val2 instanceof Date) {
          if (val1.getTime() !== val2.getTime()) return false;
        }
        // 数组子值：长度+每一项严格相等（可选，根据你的需求）
        else if (Array.isArray(val1) && Array.isArray(val2)) {
          if (val1.length !== val2.length || !val1.every((item, idx) => item === val2[idx])) {
            return false;
          }
        }
        // 基本类型/函数等：严格相等
        else if (val1 !== val2) {
          return false;
        }
      }
    }

    // 所有属性都匹配，返回相等
    return true;
  }
  parseCshowpc = (cshowpcStr, ishowpcVal, iname2Val) => {
    // {0: "Base Info|基础属性", 1: "Other Info|其它属性"}
    const cshowpcObj = {};
    cshowpcStr.split(',').forEach((item) => {
      const [key, value] = item.split(':');
      cshowpcObj[key] = value;
    });
    const rawValue = cshowpcObj[ishowpcVal];
    if (!rawValue) return '';
    let result = '';
    if (iname2Val != 0) {
      result = rawValue.replace('|', ' ');
    } else {
      result = rawValue.split('|')[0];
    }
    return result;
  };
  getTabLabel(mblstKey, defaultText, ishowpc) {
    // 提取head对象，减少重复链式调用
    const head = this.objdata?.views?.[mblstKey]?.head || {};
    // 提前获取cshowpc值，避免重复判断
    const cshowpc = head.cshowpc || '';

    // 如果cshowpc有值，先解析它
    if (cshowpc) {
      const parsedValue = this.parseCshowpc(cshowpc, ishowpc, head.iname2) || '';
      // 解析结果有值则返回，否则用cname或默认值
      return parsedValue || head.cname || defaultText;
    }

    // cshowpc无值时，直接用cname或默认值
    return head.cname || defaultText;
  }
  hotKey(event, ref) {
    if (event.keyCode == 38) {
      event.preventDefault();
      // console.log('上');
      if (this.objdata.index > 0) {
        this.objdata.index -= 1;
        ref.setCurrentRow(this.objdata.data.details[this.objdata.index]);
      }
    } else if (event.keyCode == 40) {
      event.preventDefault();
      // console.log('下');
      if (this.objdata.index < this.objdata.data.details.length - 1) {
        this.objdata.index += 1;
        ref.setCurrentRow(this.objdata.data.details[this.objdata.index]);
      }
    }
  }
  isEmptyObject(obj) {
    if (obj === null || typeof obj !== 'object' || Array.isArray(obj)) {
      return false;
    }
    // 遍历自有属性，有则返回false
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        return false;
      }
    }
    return true;
  }
  juageExt(cext) {
    const imageExts = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg', 'heic', 'tiff'];
    const videoExts = [
      'mp4',
      'mov',
      'avi',
      'mkv',
      'flv',
      'wmv',
      'webm',
      'mpeg',
      'mpg',
      '3gp',
      'rmvb',
      'mts',
    ];
    const ext = cext.toLowerCase();
    const obj = {
      isImage: false,
      isVideo: false,
      isDefault: false,
    };
    if (imageExts.includes(ext)) {
      obj.isImage = true;
    } else if (videoExts.includes(ext)) {
      obj.isVideo = true;
    } else obj.isDefault = true;
    return obj;
  };
}
class PageLI {
  constructor(config, objsearch, objdata, inidata) {
    try {
      this.config = config;
      this.objdata = objdata;
      this.objsearch = objsearch;
      this.detailinfo = this.config.proxy.$utils.comm.getRouteInfo(this.config.name);
      if (!this.detailinfo) this.detailinfo = { path: '', name: '', title: '' };
      this.objdata = objdata;
      this.objsearch = objsearch;
      this.objsearch.issearch = false;
      this.objsearch.loading = false;
      if (!this.objsearch.ipagesize) this.objsearch.ipagesize = 15;
      if (!this.objsearch.icurrpage) this.objsearch.icurrpage = 0;
      this.objsearch.list = [];
      //权限
      if (!this.objsearch.btn) this.objsearch.btn = {};
      if (inidata && inidata.rolst) {
        for (let i1 = 0; i1 <= inidata.rolst.length - 1; i1++) {
          objdata.btn[inidata.rolst[i1].cbaroper] = 1;
        }
      }
      if (!this.objsearch.columns) this.objsearch.columns = {};
      let result = {};
      if (inidata && inidata.views && Object.keys(inidata.views).length != 0) {
        for (let key in inidata.views) {
          if (inidata.views.hasOwnProperty(key)) {
            if (
              inidata.views[key].tablelst &&
              Object.keys(inidata.views[key].tablelst).length != 0
            ) {
              let col = [];
              for (let key1 in inidata.views[key].tablelst) {
                if (inidata.views[key].head && inidata.views[key].head.ilayout != 3) {
                  col = col.concat(inidata.views[key].tablelst[key1]);
                  result[key] = col;
                } else {
                  for (let key2 in inidata.views[key].tablelst[key1]) {
                    col = col.concat(inidata.views[key].tablelst[key1][key2]);
                    result[key] = col;
                  }
                }
              }
            } else {
              // tablelst = {} 就取查找paras的
              if (inidata && inidata.paras) {
                if (inidata.paras.hasOwnProperty(key)) {
                  result[key] = inidata.paras[key];
                }
              }
            }
          }
        }
      } else if (inidata && inidata.paras) {
        for (let key in inidata.paras) {
          if (inidata.paras.hasOwnProperty(key)) {
            // 确保是对象自有属性，不是原型链上的属性
            result[key] = inidata.paras[key];
          }
        }
      }
      for (let key in result) {
        if (result.hasOwnProperty(key)) {
          // 确保是对象自有属性，不是原型链上的属性
          this.objsearch.columns[key] = result[key];
          this.objsearch.com[key] = true;
          this.objsearch.focus[key] = false;
        }
      }
      if (!this.objsearch.objini) this.objsearch.objini = {};
      if (inidata && inidata.objini) {
        for (let key in inidata.objini) {
          if (inidata.objini.hasOwnProperty(key)) {
            // 确保是对象自有属性，不是原型链上的属性
            this.objsearch.objini[key] = inidata.objini[key].replace(/[\r\n]+/g, '');
          }
        }
      }
      console.log('create...end...', this.objsearch);
    } catch (e1) {
      console.log('create error......', e1);
    }
  }
  exportExcel = () => {
    if (this.objsearch.selectRow.length == 0) {
      this.config.proxy.$notify({
        title: '系统提示',
        message: '请先搜索获取数据后勾选需要导出的数据',
        type: 'warning',
      });
      return;
    }
    this.config.proxy.$utils.export.exportExcelAll(
      this.objsearch.selectRow,
      this.objsearch.columns.list.filter(
        (item) => item.iignore == 0 && item.ihide == 0 && item.itype != 99
      ),
      this.config.detailinfo.title == '' ? '导出' : this.config.detailinfo.title
    );
    this.config.callback({ iresult: 0, cerror: '', coper: 'exportExcel', data: null });
  };
  exportExcelAll = () => {
    if (this.objsearch.list.length == 0) {
      this.config.proxy.$notify({
        title: '系统提示',
        message: '无导出数据',
        type: 'warning',
      });
      return;
    }
    this.config.proxy.$utils.export.exportExcelAll(
      this.objsearch.list,
      this.objsearch.columns.list.filter(
        (item) => item.iignore == 0 && item.ihide == 0 && item.itype != 99
      ),
      this.config.detailinfo.title == '' ? '导出' : this.config.detailinfo.title
    );
    this.config.callback({ iresult: 0, cerror: '', coper: 'exportExcelAll', data: null });
  };
  exportExcelback = (objpara) => {
    let params = {
      cobject: this.config.cobjectt,
      coper: 'export',
      objpara: {
        ctheme: this.config.detailinfo.title + '导出',
        cpagename: this.config.name,
        ...this.objsearch.filter,
        ...objpara,
      },
    };
    this.config.proxy.$execute(params).then((res) => {
      this.objsearch.loading = false;
      if (res.iresult > 300) {
        alert(res.cerror);
        return;
      }
      if (res.iresult == 0) {
        if (res.data.length == 0) {
          this.config.proxy.$notify({
            title: '系统提示',
            message: '无导出数据',
            type: 'warning',
          });
          return;
        }
        this.config.proxy.$utils.export.exportExcelAll(
          res.data.lst ? res.data.lst : res.data,
          this.objsearch.columns.list.filter(
            (item) => item.iignore == 0 && item.ihide == 0 && item.itype != 99
          ),
          this.config.detailinfo.title == '' ? '导出' : this.config.detailinfo.title
        );
        this.config.callback({
          iresult: 0,
          cerror: '',
          coper: 'exportExcelback',
          data: null,
        });
      } else if (res.iresult == 1) {
        this.config.proxy.$message({
          showClose: true,
          message: '已加入任务列表',
          type: 'success',
        });
      }
    });
  };
  fnFileDownload = (idfile, cnamefile, bdown) => {
    FileDownload(idfile, cnamefile, bdown, fnhandleDownload);
  };
  fnFilePreview = (idfile, cnamefile) => {
    FilePreview(idfile, cnamefile);
  };
  fnhandleDownload = (dataurl, contenttype, cnamefile, blob) => {
    switch (contenttype) {
      case 'image/png':
      case 'image/jpeg':
      case 'image/jpg':
      case 'application/pdf': {
        let page = window.open(dataurl);
        setTimeout(() => {
          page.document.title = cnamefile;
        }, 500);
        break;
      }
      case 'application/vnd.ms-excel':
        //后台导出excel
        break;
    }
  };
  onSelectData = (res) => {
    this.objsearch.selectRow = res.data;
  };
  cansel = (res) => {
    if (res.data.row.id == '') {
      return false;
    } else {
      return true;
    }
  };
  fnexecute = (cobject, coper) => {
    let params = {
      cobject: cobject,
      coper: coper,
      objpara: {},
    };
    this.config.proxy.$execute(params).then((res) => {
      if (res.iresult != 0) {
        this.config.proxy.$msgbox.alert(res.cerror);
        return;
      }
      this.config.proxy.$message({
        showClose: true,
        message: '操作成功',
        type: 'success',
      });
    });
  };
  fnsearch = (boolean) => {
    this.objsearch.issearch = true;
    let params = {
      cobject: this.config.cobjectt,
      coper: this.objsearch.search_oper != '' ? this.objsearch.search_oper : 'search',
      objpara: {
        ...this.objsearch.filter,
        ipagesize: this.objsearch.ipagesize,
        ipage: this.objsearch.icurrpage,
      },
    };
    this.config.proxy.$execute(params).then((res) => {
      if (res.iresult != 0) {
        this.config.proxy.$msgbox.alert(res.cerror);
        return;
      }
      this.objsearch.list.length = 0;
      this.objsearch.sumlst.length = 0;
      if (res?.data?.hasOwnProperty('lst')) {
        this.objsearch.list.push(...res.data.lst);
        // if (boolean) {
        if (res?.data?.hasOwnProperty('itot')) this.objsearch.itot = res.data.itot;
        else if (res.data.sum) {
          if (res.data.sum.itot) this.objsearch.itot = res.data.sum.itot;
        } else if (
          this.objsearch.list.length !== 0 &&
          this.objsearch.list[0].itot !== null &&
          this.objsearch.list[0].itot !== 0 &&
          this.objsearch.list[0].itot &&
          boolean
        ) {
          this.objsearch.itot = this.objsearch.list[0].itot;
        } else {
          this.objsearch.itot = this.objsearch.list.length;
        }
        // }
      } else {
        this.objsearch.list.push(...res.data);
        if (boolean) {
          if (
            this.objsearch.list.length !== 0 &&
            this.objsearch.list[0].itot !== null &&
            this.objsearch.list[0].itot !== 0 &&
            this.objsearch.list[0].itot
          ) {
            this.objsearch.itot = this.objsearch.list[0].itot;
          } else {
            this.objsearch.itot = this.objsearch.list.length;
          }
        }
      }
      if (
        res.data &&
        typeof res.data === 'object' &&
        'drtotpg' in res.data &&
        res.data.drtotpg != null
      ) {
        this.objsearch.sumlst.push({
          ...res.data.drtotpg,
          iindex: '页小计',
        });
      }
      if (
        res.data &&
        typeof res.data === 'object' &&
        'drtot' in res.data &&
        res.data.drtot != null
      ) {
        this.objsearch.sumlst.push({
          ...res.data.drtot,
          iindex: '总计',
        });
      }
      if (res.data.szmap) this.objsearch.szmap = res.data.szmap;
      this.objsearch.issearch = false;
      this.config.callback({ iresult: 0, cerror: '', coper: 'search', data: res.data });
    });
  };
  onSearch = () => {
    this.objsearch.icurrpage = 1;
    this.fnsearch(true);
  };
  onSizeChange = (size) => {
    this.objsearch.ipagesize = size;
    this.fnsearch(false);
  };
  onCurrentChange = (val) => {
    this.objsearch.icurrpage = val;
    this.fnsearch(false);
  };
  fnload = (res, objpara) => {
    let params = {
      cobject: this.config.cobjectt,
      coperation: 'search',
      objparameter: objpara
        ? objpara
        : {
          ...this.objsearch.filter,
          idparent: res.id,
          ipagesize: this.objsearch.ipagesize,
          ipage: this.objsearch.icurrpage,
        },
    };
    this.config.proxy.$execute(params).then((result) => {
      if (result.iresult != 0) {
        alert(result.cerror);
        return;
      }
      this.objdata.rowlazy = res.rowlazy;
      if (result.data.lst) {
        res.callback(result.data.lst);
      } else res.callback(result.data);
    });
  };

  fnExpChange = (force, row, expanded, objpara) => {
    if (!row) return;
    // 获取到之前保存的全局变量
    const curr = this.objdata.rowlazy[row.id];
    // 展开次数 +1
    curr.expandCount++;
    // 如果是展开状态，且展开次数大于1，且上一次的状态为折叠，则请求api数据，更新子菜单
    if (expanded && (force || (curr.expandCount > 1 && !curr.prevStatus))) {
      let params = {
        cobject: this.config.cobjectt,
        coperation: 'search',
        objparameter: objpara
          ? objpara
          : {
            ...this.objsearch.filter,
            idparent: this.objdata.rowlazy[row.id].row.id,
            ipagesize: this.objsearch.ipagesize,
            ipage: this.objsearch.icurrpage,
          },
      };
      this.config.proxy.$execute(params).then((res) => {
        if (res.iresult != 0) {
          alert(res.cerror);
          return;
        }
        if (res?.data?.hasOwnProperty('lst')) {
          curr.resolve(res.data.lst);
        } else curr.resolve(res.data);
      });
    }
    // 保存本次的展开或折叠状态，用于下次判断
    curr.prevStatus = expanded;
  };
  fnselectrow_search = (res) => {
    this.objsearch.currrow = res.data.row;
  };
  fnselectrow = (res) => {
    this.objdata.currrow = res.data.row;
    this.objdata.index = res.index;
  };
  onChange = (res) => {
    if (!res) return;
    let cscope = res.cscope ? res.cscope : '';
    let cfield = res.cfield ? res.cfield : '';
    let itype = res.column.itype ? res.column.itype : 0;
    let isearch = res.column.isearch ? res.column.isearch : 0;
    switch (cscope) {
      case 'filter':
        this.onSearch();
        break;
    }
  };
  onSaveSwitch = (res) => {
    setTimeout(() => {
      let params = {
        cobject: this.config.cobjectt,
        coperation: 'save_switch',
        objparameter: {
          id: res.data.id,
          iswitch: res.data.value,
          cswitch: res.data.cswitch,
          [res.data.cswitch]: res.data.value,
        },
      };
      this.config.proxy.$execute(params).then((res) => {
        if (res.iresult != 0) {
          alert(res.cerror);
          return;
        }
        this.config.proxy.$message({
          showClose: true,
          message: '修改成功~',
          type: 'success',
        });
      });
    }, 300);
  };
  fnmoveid = () => {
    if (this.objdata.currrow === null) {
      alert('请选择订单');
      return;
    }
    if (!this.config.detailinfo) {
      alert('详情路由信息不存在');
      return;
    }
    this.config.proxy.$router.push({
      path: this.config.detailinfo.path,
      query: {
        id: this.objdata.currrow.id,
        tagsViewName: this.config.detailinfo.title + '_' + this.objdata.currrow.ccode,
        coper: 'moveid',
      },
    });
  };
  fnnew = () => {
    console.log('-----');
    if (!this.config.detailinfo) {
      alert('详情路由信息不存在');
      return;
    }
    this.config.proxy.$router.push({
      path: this.config.detailinfo.path,
      query: {
        tagsViewName:
          this.config.detailinfo.title +
          '_' +
          Math.round(new Date().getTime() / 1000)
            .toString()
            .slice(4, 10),
        coper: 'new',
      },
    });
  };
  fnedit = () => {
    if (this.objdata.currrow === null) {
      alert('请选择行');
      return;
    }
    if (!this.config.detailinfo) {
      alert('详情路由信息不存在');
      return;
    }
    this.config.proxy.$router.push({
      path: this.config.detailinfo.path,
      query: {
        id: this.objdata.currrow.id,
        tagsViewName: this.config.detailinfo.title + '_' + this.objdata.currrow.ccode,
        coper: 'edit',
      },
    });
  };
  get canedit() {
    if (this.objdata.currrow === null) {
      return false;
    }
    if (this.objdata.currrow.id != '' && this.objdata.currrow.istatus === 0) {
      return true;
    } else {
      return false;
    }
  }
  get canedit_base() {
    if (this.objdata.currrow === null) {
      return false;
    }
    if (this.objdata.currrow.id != '') {
      return true;
    } else {
      return false;
    }
  }
  get isverify() {
    if (this.objdata.currrow === null) {
      return false;
    }
    if (this.objdata.currrow.istatus === 20) {
      return true;
    } else {
      return false;
    }
  }
  get canverify() {
    if (this.objdata.currrow === null) {
      return false;
    }
    if (
      this.objdata.currrow.id != '' &&
      this.objdata.currrow.istatus >= 0 &&
      this.objdata.currrow.istatus <= 20
    ) {
      return true;
    } else return false;
  }
  get iscommit() {
    if (this.objdata.currrow === null) {
      return false;
    }
    if (this.objdata.currrow.istatus === 10) {
      return true;
    } else {
      return false;
    }
  }
  get cancommit() {
    if (this.objdata.currrow === null) {
      return false;
    }
    if (
      this.objdata.currrow.id != '' &&
      this.objdata.currrow.istatus >= 0 &&
      this.objdata.currrow.istatus <= 10
    ) {
      return true;
    } else return false;
  }
  get iscancel() {
    if (this.objdata.currrow === null) {
      return false;
    }
    if (this.objdata.currrow.istatus === 99) {
      return true;
    } else {
      return false;
    }
  }
  get cancancel() {
    if (this.objdata.currrow === null) {
      return false;
    }
    if (
      (this.objdata.currrow.id != '' && this.objdata.currrow.istatus <= 19) ||
      this.objdata.currrow.istatus >= 99
    ) {
      return true;
    } else return false;
  }
  get cansync() {
    if (this.objdata.currrow === null) {
      return false;
    }
    if (
      this.objdata.currrow.id != '' &&
      this.objdata.currrow.istatus == 20 &&
      this.objdata.currrow.istexch >= 0 &&
      this.objdata.currrow.istexch <= 19
    ) {
      return true;
    } else return false;
  }
  get cancelsync() {
    if (this.objdata.currrow === null) {
      return false;
    }
    if (
      this.objdata.currrow.id != '' &&
      this.objdata.currrow.istatus == 20 &&
      this.objdata.currrow.istexch > 0 &&
      this.objdata.currrow.istexch <= 20
    ) {
      return true;
    } else return false;
  }
  fnsellist = (e) => {
    this.objsearch.selectRow = e;
  };
  fnverify = (obj) => {
    if (this.objdata.currrow === null) {
      this.config.proxy.$msgbox.alert('请选择行');
      return;
    }
    if (!obj) obj = {};
    let params = {
      cobject: this.config.cobjectt,
      coper: this.objdata.currrow.istatus === 20 ? 'verifyr' : 'verify',
      objpara: {
        ...obj,
        id: this.objdata.currrow.id,
      },
    };
    this.config.proxy.$execute(params).then((res) => {
      if (res.iresult == 0) {
        this.objdata.currrow.istatus = res.data;
        this.objdata.currrow.cstatus = res.data == 20 ? '审核' : '新建';
        this.objsearch.list.some((item) => {
          if (item.id === res.data.id) {
            item.istatus = res.data;
            return true;
          }
        });
        this.config.proxy.$message({
          showClose: true,
          message: this.objdata.currrow.istatus === 20 ? '审核成功~' : '反审核成功',
          type: 'success',
        });
      } else {
        this.config.proxy.$msgbox(res.cerror);
      }
      this.config.callback({ iresult: 0, cerror: '', coper: 'verify', data: res.data });
    });
  };
  fnverifybat = () => {
    if (this.objsearch.selectRow.length == 0) {
      this.config.proxy.$msgbox.alert('请选择需审核数据');
      return;
    }
    let params = {
      cobject: this.config.cobjectt,
      coper: 'verifybt',
      objpara: {
        lst: this.objsearch.selectRow,
      },
    };
    this.config.proxy.$execute(params).then((res) => {
      if (res.iresult == 0) {
        for (let i1 = 0; i1 < this.objsearch.selectRow.length; i1++) {
          if (this.objsearch.selectRow[i1].istatus !== 99) {
            this.objsearch.selectRow[i1].istatus = 20;
            this.objsearch.selectRow[i1].cstatus = '审核';
          }
        }
        this.config.proxy.$message({
          showClose: true,
          message: '批量审核完成~',
          type: 'success',
        });
        this.config.callback({ iresult: 0, cerror: '', coper: 'verifybt', data: null });
      } else {
        this.config.proxy.$msgbox.alert(res.cerror);
        this.config.callback({ iresult: 0, cerror: '', coper: 'verifybt', data: null });
      }
    });
  };
  fnverifyrbat = () => {
    if (this.objsearch.selectRow.length == 0) {
      this.config.proxy.$msgbox.alert('请选择需反审核数据');
      return;
    }
    let params = {
      cobject: this.config.cobjectt,
      coper: 'verifyrbt',
      objpara: {
        lst: this.objsearch.selectRow,
      },
    };
    this.config.proxy.$execute(params).then((res) => {
      if (res.iresult == 0) {
        for (let i1 = 0; i1 < this.objsearch.selectRow.length; i1++) {
          if (this.objsearch.selectRow[i1].istatus !== 99) {
            this.objsearch.selectRow[i1].istatus = 19;
            this.objsearch.selectRow[i1].cstatus = '新建';
          }
        }
        this.config.proxy.$message({
          showClose: true,
          message: '批量反审核完成~',
          type: 'success',
        });
        this.config.callback({ iresult: 0, cerror: '', coper: 'verifyrbt', data: null });
      } else {
        this.config.proxy.$msgbox.alert(res.cerror);
        this.config.callback({ iresult: 0, cerror: '', coper: 'verifyrbt', data: null });
      }
    });
  };
  fncommit = () => {
    if (this.objdata.currrow === null) {
      alert('请选择行');
    }
    // if (objdata.currrow >= 20) {
    //   alert('订单已审核,暂时不可反审核');
    //   return;
    // }
    let params = {
      cobject: this.config.cobjectt,
      coper: this.objdata.currrow.istatus === 10 ? 'commitr' : 'commit',
      objpara: {
        id: this.objdata.currrow.id,
      },
    };
    this.config.proxy.$execute(params).then((res) => {
      if (res.iresult == 0) {
        this.objdata.currrow.istatus = res.data;
        this.objdata.currrow.cstatus = res.data == 10 ? '提交' : '新建';
        this.objsearch.list.some((item) => {
          if (item.id === res.data.id) {
            item.istatus = res.data;
            return true;
          }
        });
        this.config.proxy.$message({
          showClose: true,
          message: this.objdata.currrow.istatus === 10 ? '提交成功~' : '反提交成功',
          type: 'success',
        });
      } else {
        this.config.proxy.$msgbox(res.cerror);
      }
    });
  };
  fncommitbat = () => {
    if (this.objsearch.selectRow.length == 0) {
      this.config.proxy.$msgbox.alert('请选择需提交数据');
      return;
    }
    let params = {
      cobject: this.config.cobjectt,
      coper: 'commitbt',
      objpara: {
        lst: this.objsearch.selectRow,
      },
    };
    this.config.proxy.$execute(params).then((res) => {
      if (res.iresult == 0) {
        for (let i1 = 0; i1 < this.objsearch.selectRow.length; i1++) {
          if (objsearch.selectRow[i1].istatus !== 99) {
            this.objsearch.selectRow[i1].istatus = 10;
            this.objsearch.selectRow[i1].cstatus = '提交';
          }
        }
        this.config.proxy.$message({
          showClose: true,
          message: '批量提交完成~',
          type: 'success',
        });
        this.config.callback({ iresult: 0, cerror: '', coper: 'commitbt', data: null });
      } else {
        this.config.proxy.$msgbox.alert(res.cerror);
        this.config.callback({ iresult: 0, cerror: '', coper: 'commitbt', data: null });
      }
    });
  };
  fncommitrbat = () => {
    if (this.objsearch.selectRow.length == 0) {
      this.config.proxy.$msgbox.alert('请选择需反提交数据');
      return;
    }
    let params = {
      cobject: this.config.cobjectt,
      coper: 'commitrbt',
      objpara: {
        lst: this.objsearch.selectRow,
      },
    };
    this.config.proxy.$execute(params).then((res) => {
      if (res.iresult == 0) {
        for (let i1 = 0; i1 < this.objsearch.selectRow.length; i1++) {
          if (this.objsearch.selectRow[i1].istatus !== 99) {
            this.objsearch.selectRow[i1].istatus = 0;
            this.objsearch.selectRow[i1].cstatus = '新建';
          }
        }
        this.config.proxy.$message({
          showClose: true,
          message: '批量反提交完成~',
          type: 'success',
        });
        this.config.callback({ iresult: 0, cerror: '', coper: 'commitrbt', data: null });
      } else {
        this.config.proxy.$msgbox.alert(res.cerror);
        this.config.callback({ iresult: 0, cerror: '', coper: 'commitrbt', data: null });
      }
    });
  };
  fncancelbat = () => {
    if (this.objsearch.selectRow.length == 0) {
      this.config.proxy.$msgbox.alert('请选择需作废数据');
      return;
    }
    this.config.proxy.$msgbox
      .confirm('确认作废?', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
      .then(() => {
        let params = {
          cobject: this.config.cobjectt,
          coper: 'cancelbt',
          objpara: {
            lst: this.objsearch.selectRow,
          },
        };
        this.config.proxy.$execute(params).then((res) => {
          if (res.iresult == 0) {
            for (let i1 = 0; i1 < this.objsearch.selectRow.length; i1++) {
              if (this.objsearch.selectRow[i1].istatus !== 20) {
                this.objsearch.selectRow[i1].istatus = 99;
                this.objsearch.selectRow[i1].cstatus = '作废';
              }
            }
            this.config.proxy.$message({
              showClose: true,
              message: '批量作废完成~',
              type: 'success',
            });
            this.config.callback({
              iresult: 0,
              cerror: '',
              coper: 'cancelbt',
              data: null,
            });
          } else {
            this.config.proxy.$msgbox.alert(res.cerror);
            this.config.callback({
              iresult: 0,
              cerror: '',
              coper: 'cancelbt',
              data: null,
            });
          }
        });
      });
  };
  fncancelrbat = () => {
    if (this.objsearch.selectRow.length == 0) {
      this.config.proxy.$msgbox.alert('请选择需反作废数据');
      return;
    }
    this.config.proxy.$msgbox
      .confirm('确认反作废?', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
      .then(() => {
        let params = {
          cobject: this.config.cobjectt,
          coper: 'cancelrbt',
          objpara: {
            lst: this.objsearch.selectRow,
          },
        };
        this.config.proxy.$execute(params).then((res) => {
          if (res.iresult == 0) {
            for (let i1 = 0; i1 < this.objsearch.selectRow.length; i1++) {
              if (objsearch.selectRow[i1].istatus !== 20) {
                this.objsearch.selectRow[i1].istatus = 19;
                this.objsearch.selectRow[i1].cstatus = '新建';
              }
            }
            this.config.proxy.$message({
              showClose: true,
              message: '批量反作废完成~',
              type: 'success',
            });
            this.config.callback({
              iresult: 0,
              cerror: '',
              coper: 'cancelrbt',
              data: null,
            });
          } else {
            this.config.proxy.$msgbox.alert(res.cerror);
            this.config.callback({
              iresult: 0,
              cerror: '',
              coper: 'cancelrbt',
              data: null,
            });
          }
        });
      });
  };
  fnCancel = () => {
    if (this.objdata.currrow === null) {
      alert('请选择订单');
      return;
    }
    if (this.objdata.currrow.istatus <= 99) {
      this.config.proxy.$msgbox
        .confirm(
          this.objdata.currrow.istatus === 99 ? '确认反作废?' : '确认作废',
          '提醒',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
        )
        .then(() => {
          let params = {
            cobject: this.config.cobjectt,
            coper: this.objdata.currrow.istatus === 99 ? 'cancelr' : 'cancel',
            objpara: {
              id: this.objdata.currrow.id,
            },
          };
          this.config.proxy.$execute(params).then((res) => {
            if (res.iresult == 0) {
              this.objdata.currrow.istatus = res.data;
              this.objdata.currrow.cstatus = res.data == 99 ? '作废' : '新建';
              this.objsearch.list.some((item) => {
                if (item.id === res.data.id) {
                  item.istatus = res.data;
                  return true;
                }
              });
              this.config.proxy.$message({
                showClose: true,
                message:
                  this.objdata.currrow.istatus === -80 ? '作废成功~' : '反作废成功',
                type: 'success',
              });
              this.onSearch();
            } else {
              this.config.proxy.$msgbox(res.cerror);
            }
          });
        });
    }
  };
  fndelete = (obj) => {
    if (!obj) obj = {};
    if (this.objdata.currrow === null) {
      this.config.proxy.$msgbox.alert('请选择删除记录');
      return;
    }
    this.config.proxy.$msgbox
      .confirm(
        `您确定要删除【${this.objdata.currrow.ccode}】${this.objdata.currrow.cname}吗？`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      )
      .then(() => {
        let params = {
          cobject: this.config.cobjectt,
          coper: 'delete',
          objpara: {
            ...obj,
            id: this.objdata.currrow.id,
          },
        };
        this.config.proxy.$execute(params).then((res) => {
          if (res.iresult == 0) {
            for (var i = 0; i < this.objsearch.list.length; i++) {
              if (this.objsearch.list[i].id === res.data.id)
                this.objsearch.list.splice(i, 1);
              return true;
            }
            this.config.proxy.$message({
              showClose: true,
              message: '已删除~',
              type: 'success',
            });
          } else {
            this.config.proxy.$msgbox.alert(res.cerror);
          }
        });
      })
      .catch(() => {
        this.config.proxy.$msgbox.alert('已取消删除操作');
      });
  };
  fndeletebt = (obj) => {
    if (!obj) obj = {};
    if (this.objsearch.selectRow.length == 0) {
      this.config.proxy.$msgbox.alert('请选择需删除数据');
      return;
    }
    this.config.proxy.$msgbox
      .confirm('确认删除?', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
      .then(() => {
        let params = {
          cobject: this.config.cobjectt,
          coper: 'deletebt',
          objpara: {
            ...obj,
            lst: this.objsearch.selectRow,
          },
        };
        this.config.proxy.$execute(params).then((res) => {
          if (res.iresult == 0) {
            this.config.proxy.$message({
              showClose: true,
              message: '批量删除完成~',
              type: 'success',
            });
            this.config.callback({
              iresult: 0,
              cerror: '',
              coper: 'deletebt',
              data: null,
            });
          } else {
            this.config.proxy.$msgbox.alert(res.cerror);
            this.config.callback({
              iresult: 0,
              cerror: '',
              coper: 'deletebt',
              data: null,
            });
          }
        });
      });
  };
  fnsync = (coper) => {
    if (this.objdata.currrow === null) {
      alert('请选择行');
      return;
    }
    let params = {
      cobject: this.config.cobjectt,
      coper: coper,
      objpara: {
        id: this.objdata.currrow.id,
      },
    };
    this.config.proxy.$execute(params).then((res) => {
      if (res.iresult != 0) {
        alert(res.cerror);
        return;
      }
      this.objdata.currrow.istexch = res.data.istexch;
      this.objdata.currrow.cstexch =
        res.data.istexch == 10
          ? '同步保存'
          : res.data.istexch == 11
            ? '正在审核'
            : res.data.istexch == 19
              ? '正在撤销'
              : res.data.istexch == 20
                ? '同步审核'
                : '未同步';
      if (coper === 'sync_ex') {
        this.config.proxy.$message({
          showClose: true,
          message: '同步成功~',
          type: 'success',
        });
      } else {
        this.config.proxy.$message({
          showClose: true,
          message: '撤销同步成功~',
          type: 'success',
        });
      }
    });
  };

  fnclearsearch = () => {
    this.objdata.csearch = '';
  };
  focusSelect = (event) => {
    if ('select' in event.target && typeof event.target.select == 'function') {
      event.target.select();
    }
  };
  fncreateobj = (cobj) => {
    let obj = null;
    let temp = null;
    let isAllSpaces = false;
    try {
      if (this.objsearch.columns[cobj]) {
        obj = {};
        for (let i1 = 0; i1 < this.objsearch.columns[cobj].length; i1++) {
          if (this.objsearch.columns[cobj][i1].cfield == '') {
            switch (this.objsearch.columns[cobj][i1].cobject) {
              case 'i':
                obj[this.objsearch.columns[cobj][i1].prop] = 0;
                continue;
              case 'o':
                obj[this.objsearch.columns[cobj][i1].prop] = {};
                continue;
              case 'a':
                obj[this.objsearch.columns[cobj][i1].prop] = [];
                continue;
            }
          }
          if (
            this.objsearch.columns[cobj][i1].cdefault &&
            this.objsearch.columns[cobj][i1].cdefault != '' &&
            this.objsearch.columns[cobj][i1].cdefault.startsWith('props')
          ) {
            let params = this.objsearch.columns[cobj][i1].cdefault.split('.');
            if (params.length >= 2) {
              obj[this.objsearch.columns[cobj][i1].prop] = this.objdata.props[params[1]];
            }
          } else if (
            this.objsearch.columns[cobj][i1].cdefault &&
            this.objsearch.columns[cobj][i1].cdefault != '' &&
            this.objsearch.columns[cobj][i1].cdefault.startsWith('paras')
          ) {
            let params = this.objsearch.columns[cobj][i1].cdefault.split('.');
            if (params.length >= 2) {
              obj[this.objdata.columns[cobj][i1].prop] = this.objdata.paras[params[1]];
            }
          } else {
            switch (this.objsearch.columns[cobj][i1].itype) {
              case 5:
                if (
                  this.objsearch.columns[cobj][i1].cdefault &&
                  this.objsearch.columns[cobj][i1].cdefault != ''
                ) {
                  isAllSpaces = /^ +$/.test(this.objsearch.columns[cobj][i1].cdefault);
                  temp = parseInt(this.objsearch.columns[cobj][i1].cdefault);
                  if (isAllSpaces)
                    obj[this.objsearch.columns[cobj][i1].prop] = this.objsearch.columns[
                      cobj
                    ][i1].cdefault;
                  else if (!isNaN(temp))
                    obj[this.objsearch.columns[cobj][i1].prop] = temp;
                  else if (this.objsearch.columns[cobj][i1].option.length > 0)
                    obj[this.objsearch.columns[cobj][i1].prop] = this.objsearch.columns[
                      cobj
                    ][i1].option[0].value;
                  else obj[this.objsearch.columns[cobj][i1].prop] = 0;
                } else {
                  if (this.objsearch.columns[cobj][i1].option.length > 0)
                    obj[this.objsearch.columns[cobj][i1].prop] = this.objsearch.columns[
                      cobj
                    ][i1].option[0].value;
                  else obj[this.objsearch.columns[cobj][i1].prop] = 0;
                }
                break;
              case 51:
                if (
                  this.objsearch.columns[cobj][i1].cdefault &&
                  this.objsearch.columns[cobj][i1].cdefault != ''
                ) {
                  isAllSpaces = /^ +$/.test(this.objsearch.columns[cobj][i1].cdefault);
                  temp = parseInt(this.objsearch.columns[cobj][i1].cdefault);
                  if (isAllSpaces)
                    obj[this.objsearch.columns[cobj][i1].prop] = this.objsearch.columns[
                      cobj
                    ][i1].cdefault;
                  else if (!isNaN(temp))
                    obj[this.objsearch.columns[cobj][i1].prop] = temp;
                  else obj[this.objsearch.columns[cobj][i1].prop] = 0;
                } else {
                  obj[this.objsearch.columns[cobj][i1].prop] = 0;
                }
                break;
              case 1:
              case 2:
                if (
                  this.objsearch.columns[cobj][i1].cdefault &&
                  this.objsearch.columns[cobj][i1].cdefault != ''
                ) {
                  temp = parseFloat(this.objsearch.columns[cobj][i1].cdefault);
                  if (!isNaN(temp)) obj[this.objsearch.columns[cobj][i1].prop] = temp;
                  else obj[this.objsearch.columns[cobj][i1].prop] = 0;
                } else {
                  obj[this.objsearch.columns[cobj][i1].prop] = 0;
                }
                break;
              case 6:
                if (
                  this.objsearch.columns[cobj][i1].cdefault &&
                  this.objsearch.columns[cobj][i1].cdefault != ''
                ) {
                  obj[
                    this.objsearch.columns[cobj][i1].prop
                  ] = this.config.proxy.$utils.dtformat.fomatTime(
                    new Date(),
                    this.objsearch.columns[cobj][i1].cdefault
                  );
                } else {
                  if (this.objsearch.columns[cobj][i1].imust > 0) {
                    obj[this.objsearch.columns[cobj][i1].prop] = new Date();
                  } else {
                    obj[this.objsearch.columns[cobj][i1].prop] = null;
                  }
                }
                if (
                  this.objsearch.columns[cobj][i1].prop2 &&
                  this.objsearch.columns[cobj][i1].prop2 != ''
                ) {
                  let prop2Obj = this.format_prop2(
                    this.objsearch.columns[cobj][i1].prop2
                  );
                  if (prop2Obj) {
                    if (prop2Obj.length == 1) {
                      obj[this.objsearch.columns[cobj][i1].prop2] = null;
                    } else {
                      for (const key in prop2Obj.obj) {
                        if (prop2Obj.obj.hasOwnProperty(key)) {
                          obj[key] = null;
                        }
                      }
                    }
                  }
                }
                if (
                  this.objsearch.columns[cobj][i1].propdp &&
                  this.objsearch.columns[cobj][i1].propdp != ''
                ) {
                  obj[this.objsearch.columns[cobj][i1].propdp] = null;
                }
                break;
              case 9:
                obj[this.objsearch.columns[cobj][i1].prop] = [''];
                if (
                  this.objsearch.columns[cobj][i1].prop2 &&
                  this.objsearch.columns[cobj][i1].prop2 != ''
                ) {
                  let prop2Obj = this.format_prop2(
                    this.objsearch.columns[cobj][i1].prop2
                  );
                  if (prop2Obj) {
                    if (prop2Obj.length == 1) {
                      obj[this.objsearch.columns[cobj][i1].prop2] = '';
                    } else {
                      for (const key in prop2Obj.obj) {
                        if (prop2Obj.obj.hasOwnProperty(key)) {
                          obj[key] = '';
                        }
                      }
                    }
                  }
                }
                if (
                  this.objsearch.columns[cobj][i1].propdp &&
                  this.objsearch.columns[cobj][i1].propdp != ''
                ) {
                  obj[this.objsearch.columns[cobj][i1].propdp] = '';
                }
                continue;
              case 90:
                obj[this.objsearch.columns[cobj][i1].prop] = [];
                continue;
              default:
                if (
                  this.objsearch.columns[cobj][i1].cdefault &&
                  this.objsearch.columns[cobj][i1].cdefault != ''
                ) {
                  if (this.objsearch.columns[cobj][i1].cdefault.startsWith('user')) {
                    let defaultlst = this.objsearch.columns[cobj][i1].cdefault.split('.');
                    if (defaultlst.length == 2) {
                      obj[
                        this.objsearch.columns[cobj][i1].prop
                      ] = this.config.proxy.$store.state.user[defaultlst[1]];
                    }
                  } else if (
                    this.objsearch.columns[cobj][i1].cdefault.startsWith('vouch')
                  ) {
                    let defaultlst = this.objsearch.columns[cobj][i1].cdefault.split('.');
                    if (defaultlst.length == 2) {
                      obj[this.objsearch.columns[cobj][i1].prop] = this.objdata.vouch[
                        defaultlst[1]
                      ];
                    }
                  } else {
                    obj[this.objsearch.columns[cobj][i1].prop] = this.objsearch.columns[
                      cobj
                    ][i1].cdefault;
                  }
                } else {
                  obj[this.objsearch.columns[cobj][i1].prop] = '';
                }

                if (
                  this.objsearch.columns[cobj][i1].prop2 &&
                  this.objsearch.columns[cobj][i1].prop2 != ''
                ) {
                  let prop2Obj = this.format_prop2(
                    this.objsearch.columns[cobj][i1].prop2
                  );
                  if (prop2Obj) {
                    if (prop2Obj.length == 1) {
                      obj[this.objsearch.columns[cobj][i1].prop2] = '';
                    } else {
                      for (const key in prop2Obj.obj) {
                        if (prop2Obj.obj.hasOwnProperty(key)) {
                          obj[key] = '';
                        }
                      }
                    }
                  }
                }
                if (
                  this.objsearch.columns[cobj][i1].propdp &&
                  this.objsearch.columns[cobj][i1].propdp != ''
                ) {
                  obj[this.objsearch.columns[cobj][i1].propdp] = '';
                }

                break;
            }
          }
        }
      }
    } catch (e) {
      console.log('createobj error....', e);
      this.config.proxy.$msgbox(e.message);
    }
    return obj;
  };
  format_prop2 = (prop2) => {
    if (prop2 == '') return null;
    let obj = {};
    let delobj = {};
    // let prop2 = 'idcust:id,cbarcust:cbar,cnamecust:cname,idorg:idsaorg,cnameorg:cnamesaorg';
    let prop2lst = prop2.split(',');
    for (let i1 = 0; i1 < prop2lst.length; i1++) {
      let params = prop2lst[i1].split(':');
      if (params.length >= 2) {
        const key = params[0];
        const value = params[1];
        let delvalue = '';
        if (params.length >= 3) {
          delvalue = params[2];
        }
        obj[key] = value;
        delobj[key] = delvalue;
      }
    }
    var res = {
      length: prop2lst.length,
      obj,
      delobj,
    };
    return res;
  };
  onFunc = (cfield) => {
    let result = {};
    switch (cfield) {
      case 'Refresh':
        this.fnrefresh();
        break;
      case 'Search':
        this.onSearch();
        break;
      case 'Save':
        this.fnsave(true);
        break;
      case 'New':
        this.fnnew();
        break;
      case 'NewChildren':
        this.fnnew2_children();
        break;
      case 'Edit':
        this.fnedit();
        break;
      case 'Commit':
        this.fncommit();
        break;
      case 'Verify':
        this.fnverify();
        break;
      case 'Close':
        this.fnClose();
        break;
      case 'Cancel':
        this.fnCancel();
        break;
      case 'Delete':
        this.fndelete();
        break;
      case 'Commitbt':
        this.fncommitbat();
        break;
      case 'Commitrbt':
        this.fncommitrbat();
        break;
      case 'Verifybt':
        this.fnverifybat();
        break;
      case 'Verifyrbt':
        this.fnverifyrbat();
        break;
      case 'Cancelbt':
        this.fncancelbat();
        break;
      case 'Verifyrbt':
        this.fncancelrbat();
        break;
      case 'Deletebt':
        this.fndeletebt();
        break;

      case 'Today':
        result = this.config.proxy.$utils.dtformat.getTodayRange();
        this.objsearch.filter.dstart = result.dstart;
        this.objsearch.filter.dend = result.dend;
        this.onSearch();
        break;
      case 'Week':
        result = this.config.proxy.$utils.dtformat.getThisWeekRange();
        this.objsearch.filter.dstart = result.dstart;
        this.objsearch.filter.dend = result.dend;
        this.onSearch();
        break;
      case 'Month':
        result = this.config.proxy.$utils.dtformat.getThisMonthRange();
        this.objsearch.filter.dstart = result.dstart;
        this.objsearch.filter.dend = result.dend;
        this.onSearch();
        break;
      case 'Year':
        result = this.config.proxy.$utils.dtformat.getThisYearRange();
        this.objsearch.filter.dstart = result.dstart;
        this.objsearch.filter.dend = result.dend;
        this.onSearch();
        break;

      case 'isnew':
        return this.isnew;
      case 'cannew':
        return this.cannew;
      case 'isnew_children':
        return this.isnew_children;
      case 'cannew_children':
        return this.cannew_children;
      case 'isedit':
        return this.isedit;
      case 'canedit':
        return this.canedit;
      case 'canedit_base':
        return this.canedit_base;
      case 'cansave':
        return this.cansave;
      case 'iscommit':
        return this.iscommit;
      case 'cancommit':
        return this.cancommit;
      case 'isverify':
        return this.isverify;
      case 'canverify':
        return this.canverify;
      case 'isclose':
        return this.isclose;
      case 'canclose':
        return this.canclose;
      case 'iscancel':
        return this.iscancel;
      case 'cancancel':
        return this.cancancel;
      case 'candelete':
        return this.candelete;
    }
  };
  onFormatBtnValue = (value, cfield) => {
    switch (cfield) {
      case 'iname':
      case 'idisabled':
        if (value) return 0;
        else return 1;
    }
  };
  onStandBtnClick = (res) => {
    this.onBtnClick(this, res.ibtntypes, res);
  };
  onBtnClick = (ref, ibtntypes, res) => {
    switch (ibtntypes) {
      case 0:
        ref.onFunc('Refresh', res);
        break;
      case 1:
        ref.onFunc('Search', res);
        break;
      case 2:
        ref.onFunc('Save', res);
        break;
      case 3:
        ref.onFunc('New', res);
        break;
      case 4:
      case 5:
        ref.onFunc('Edit', res);
        break;
      case 6:
        ref.onFunc('Commit', res);
        break;
      case 7:
        ref.onFunc('Verify', res);
        break;
      case 8:
        ref.onFunc('Close', res);
        break;
      case 13:
        ref.onFunc('NewChildren', res);
        break;
      case 17:
        ref.onFunc('Cancel', res);
        break;
      case 18:
      case 19:
        ref.onFunc('Delete', res);
        break;
      case 20:
        ref.onFunc('Commitbt', res);
        break;
      case 21:
        ref.onFunc('Commitrbt', res);
        break;
      case 22:
        ref.onFunc('Verifybt', res);
        break;
      case 23:
        ref.onFunc('Verifyrbt', res);
        break;
      case 26:
        ref.onFunc('Cancelbt', res);
        break;
      case 27:
        ref.onFunc('Cancelrbt', res);
        break;
      case 28:
      case 29:
        ref.onFunc('Deletebt', res);
        break;
      case 31:
        ref.onFunc('Today', res);
        break;
      case 32:
        ref.onFunc('Week', res);
        break;
      case 33:
        ref.onFunc('Month', res);
        break;
      case 34:
        ref.onFunc('Year', res);
        break;
      case 70:
        ref.onFunc('Print', res);
        break;
      case 71:
        ref.onFunc('OutputExcel', res);
        break;
      case 72:
        ref.onFunc('OutputPdf', res);
        break;
      case 80:
        // 子表增行
        break;
      case 81:
        // 子表导入
        break;
      case 82:
        // 子表导出
        break;
    }
  };
  onBtnValueChange = (ref, ibtntypes) => {
    switch (ibtntypes) {
      case 2:
        if ('cansave' in this.objdata.btnstatus) {
          this.objdata.btnstatus.cansave = ref.onFunc('cansave');
        }
        break;
      case 3:
        if ('isnew' in this.objdata.btnstatus) {
          this.objdata.btnstatus.isnew = ref.onFunc('isnew');
        }
        if ('cannew' in this.objdata.btnstatus) {
          this.objdata.btnstatus.cannew = true;
          // ref.onFunc('cannew');
        }
        break;
      case 4:
        if ('isedit' in this.objdata.btnstatus) {
          this.objdata.btnstatus.isedit = ref.onFunc('isedit');
        }
        if ('canedit' in this.objdata.btnstatus) {
          this.objdata.btnstatus.canedit = ref.onFunc('canedit');
        }
        break;
      case 5:
        if ('isedit' in this.objdata.btnstatus) {
          this.objdata.btnstatus.isedit = ref.onFunc('isedit');
        }
        if ('canedit_base' in this.objdata.btnstatus) {
          this.objdata.btnstatus.canedit_base = ref.onFunc('canedit_base');
        }
        break;
      case 6:
        if ('iscommit' in this.objdata.btnstatus) {
          this.objdata.btnstatus.iscommit = ref.onFunc('iscommit');
        }
        if ('cancommit' in this.objdata.btnstatus) {
          this.objdata.btnstatus.cancommit = ref.onFunc('cancommit');
        }
        break;
      case 7:
        if ('isverify' in this.objdata.btnstatus) {
          this.objdata.btnstatus.isverify = ref.onFunc('isverify');
        }
        if ('canverify' in this.objdata.btnstatus) {
          this.objdata.btnstatus.canverify = ref.onFunc('canverify');
        }
        break;
      case 8:
        if ('isclose' in this.objdata.btnstatus) {
          this.objdata.btnstatus.isclose = ref.onFunc('isclose');
        }
        if ('canclose' in this.objdata.btnstatus) {
          this.objdata.btnstatus.canclose = ref.onFunc('canclose');
        }
        break;
      case 13:
        if ('isnew_children' in this.objdata.btnstatus) {
          this.objdata.btnstatus.isnew_children = ref.onFunc('isnew_children');
        }
        if ('cannew_children' in this.objdata.btnstatus) {
          this.objdata.btnstatus.cannew_children = ref.onFunc('cannew_children');
        }
        break;
      case 17:
        if ('iscancel' in this.objdata.btnstatus) {
          this.objdata.btnstatus.iscancel = ref.onFunc('iscancel');
        }
        if ('cancancel' in this.objdata.btnstatus) {
          this.objdata.btnstatus.cancancel = ref.onFunc('cancancel');
        }
        break;
      case 18:
        if ('candelete' in this.objdata.btnstatus) {
          this.objdata.btnstatus.candelete = ref.onFunc('candelete');
        }
        break;
    }
  };
  onWatchBtnStatus = (ref, type, sourceType) => {
    // 1. 解构+可选链提取所有公共变量，统一兜底，减少重复调用
    const { mnus } = this.objsearch || {};
    const mnuData = mnus?.[sourceType] || {};
    const { lst = [], csysbar = '' } = mnuData;
    const targetList = this.objsearch?.initmuns?.[type]?.[csysbar] ?? [];

    // 2. 核心：抽离重复的按钮处理逻辑为独立函数（复用核心）
    const handleBtnItem = (btnItem) => {
      if (btnItem?.ibtntype === 8 || btnItem?.ibtntype === 11) {
        ref.onBtnValueChange(ref, btnItem?.ibtntypes);
      }
    };

    // 3. 抽离列表遍历逻辑（处理单层item+嵌套children）
    const traverseBtnList = (list) => {
      list.forEach((item) => {
        const children = item?.children ?? [];
        // 无子节点处理当前item，有子节点遍历子节点处理
        children.length === 0 ? handleBtnItem(item) : children.forEach(handleBtnItem);
      });
    };

    // 4. 精简判断条件，执行对应列表的遍历
    const isUseInitMuns = lst.length === 0 && csysbar !== '';
    traverseBtnList(isUseInitMuns ? targetList : lst);
  };
  fnformatOpt = (row, value, lst) => {
    if (!row || !lst) return;
    let idx_s = lst.findIndex((i) => i.value == value);
    if (idx_s != -1) return lst[idx_s].label;
    else return value;
  };
  deepClone(obj, cache = new WeakMap()) {
    // 1. 处理 null/undefined/基本类型（直接返回，兜底）
    if (obj === null || typeof obj !== 'object') return obj;

    // 2. 处理循环引用（关键：避免递归死循环）
    if (cache.has(obj)) return cache.get(obj);

    // 3. 处理 Vue 响应式对象（Proxy）- 先解包
    if (obj.__v_isReactive || obj.__v_isRef) {
      // 简易解包：如果项目引入了 Vue，也可以用 toRaw(obj)
      obj = JSON.parse(JSON.stringify(obj));
    }

    // 4. 处理 Date 类型
    if (obj instanceof Date) {
      const newDate = new Date(obj.getTime());
      cache.set(obj, newDate); // 加入缓存
      return newDate;
    }

    // 5. 处理 RegExp 类型
    if (obj instanceof RegExp) {
      const newReg = new RegExp(obj.source, obj.flags);
      cache.set(obj, newReg); // 加入缓存
      return newReg;
    }

    // 6. 处理数组
    if (Array.isArray(obj)) {
      const newArr = [];
      cache.set(obj, newArr); // 加入缓存
      obj.forEach((item, index) => {
        newArr[index] = this.deepClone(item, cache); // 注意：用 this. 调用自身
      });
      return newArr;
    }

    // 7. 处理纯对象（核心：加异常捕获）
    if (obj instanceof Object && !Array.isArray(obj)) {
      const newObj = {};
      cache.set(obj, newObj); // 加入缓存
      // 遍历属性 + try/catch 防止访问异常
      Reflect.ownKeys(obj).forEach(key => {
        try {
          newObj[key] = this.deepClone(obj[key], cache); // 注意：用 this. 调用自身
        } catch (e) {
          console.warn(`拷贝属性 ${String(key)} 失败:`, e);
          newObj[key] = obj[key]; // 降级返回原属性，避免整体崩溃
        }
      });
      return newObj;
    }

    // 8. 其他类型（函数/内置对象等，直接返回原引用）
    return obj;
  }
  isDeepEqual(a, b) {
    // 1. 先判断类型是否相同
    if (typeof a !== typeof b) return false;

    // 2. 处理 null/undefined
    if (a === null || b === null) return a === b;

    // 3. 处理基本类型（数字、字符串、布尔、Symbol）
    if (typeof a !== 'object') return a === b;

    // 4. 处理 Date 类型
    if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();

    // 5. 处理 Array 类型
    if (a instanceof Array && b instanceof Array) {
      // 先判断长度是否一致
      if (a.length !== b.length) return false;
      // 遍历每个元素，递归对比
      for (let i = 0; i < a.length; i++) {
        if (!isDeepEqual(a[i], b[i])) return false;
      }
      return true;
    }

    // 6. 处理 Object 类型（排除数组/Date）
    if (a instanceof Object && b instanceof Object) {
      // 获取所有自有属性名（包括不可枚举属性）
      const keysA = Reflect.ownKeys(a);
      const keysB = Reflect.ownKeys(b);
      // 先判断属性数量是否一致
      if (keysA.length !== keysB.length) return false;
      // 遍历每个属性，递归对比
      for (const key of keysA) {
        if (!keysB.includes(key)) return false; // 属性名不存在
        if (!isDeepEqual(a[key], b[key])) return false; // 属性值不一致
      }
      return true;
    }

    // 7. 其他类型（如 Function，判断引用是否一致）
    return a === b;
  }
  isObjectDeepEqual(obj1, obj2) {
    // 1. 首先严格判断是否为纯 Object 类型（排除数组、null、Date等）
    const isPureObject = (val) =>
      val !== null && typeof val === 'object' && !Array.isArray(val) && !(val instanceof Date);

    // 非纯对象直接返回 false
    if (!isPureObject(obj1) || !isPureObject(obj2)) return false;

    // 2. 获取两个对象的所有自有属性名（包括不可枚举、Symbol 属性）
    const keys1 = Reflect.ownKeys(obj1);
    const keys2 = Reflect.ownKeys(obj2);

    // 3. 属性数量不一致，直接不相等
    if (keys1.length !== keys2.length) return false;

    // 4. 遍历所有属性，递归对比值
    for (const key of keys1) {
      // 属性名不存在，直接不相等
      if (!keys2.includes(key)) return false;

      const val1 = obj1[key];
      const val2 = obj2[key];

      // 子值是纯对象：递归判断
      if (isPureObject(val1) && isPureObject(val2)) {
        if (!this.isObjectDeepEqual(val1, val2)) return false;
      }
      // 子值是基本类型/其他类型：直接严格相等判断
      else {
        // 特殊处理 Date 子值（如果对象属性里有 Date）
        if (val1 instanceof Date && val2 instanceof Date) {
          if (val1.getTime() !== val2.getTime()) return false;
        }
        // 数组子值：长度+每一项严格相等（可选，根据你的需求）
        else if (Array.isArray(val1) && Array.isArray(val2)) {
          if (val1.length !== val2.length || !val1.every((item, idx) => item === val2[idx])) {
            return false;
          }
        }
        // 基本类型/函数等：严格相等
        else if (val1 !== val2) {
          return false;
        }
      }
    }

    // 所有属性都匹配，返回相等
    return true;
  }
  parseCshowpc = (cshowpcStr, ishowpcVal, iname2Val) => {
    // {0: "Base Info|基础属性", 1: "Other Info|其它属性"}
    const cshowpcObj = {};
    cshowpcStr.split(',').forEach((item) => {
      const [key, value] = item.split(':');
      cshowpcObj[key] = value;
    });
    const rawValue = cshowpcObj[ishowpcVal];
    if (!rawValue) return '';
    let result = '';
    if (iname2Val != 0) {
      result = rawValue.replace('|', ' ');
    } else {
      result = rawValue.split('|')[0];
    }
    return result;
  };
  getTabLabel(mblstKey, defaultText, ishowpc) {
    // 提取head对象，减少重复链式调用
    const head = this.objdata?.views?.[mblstKey]?.head || {};
    // 提前获取cshowpc值，避免重复判断
    const cshowpc = head.cshowpc || '';

    // 如果cshowpc有值，先解析它
    if (cshowpc) {
      const parsedValue = this.parseCshowpc(cshowpc, ishowpc, head.iname2) || '';
      // 解析结果有值则返回，否则用cname或默认值
      return parsedValue || head.cname || defaultText;
    }

    // cshowpc无值时，直接用cname或默认值
    return head.cname || defaultText;
  }
  hotKey(event, ref) {
    if (event.keyCode == 38) {
      event.preventDefault();
      // console.log('上');
      if (this.objdata.index > 0) {
        this.objdata.index -= 1;
        ref.setCurrentRow(this.objdata.data.details[this.objdata.index]);
      }
    } else if (event.keyCode == 40) {
      event.preventDefault();
      // console.log('下');
      if (this.objdata.index < this.objdata.data.details.length - 1) {
        this.objdata.index += 1;
        ref.setCurrentRow(this.objdata.data.details[this.objdata.index]);
      }
    }
  }
  isEmptyObject(obj) {
    if (obj === null || typeof obj !== 'object' || Array.isArray(obj)) {
      return false;
    }
    // 遍历自有属性，有则返回false
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        return false;
      }
    }
    return true;
  }
  juageExt(cext) {
    const imageExts = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg', 'heic', 'tiff'];
    const videoExts = [
      'mp4',
      'mov',
      'avi',
      'mkv',
      'flv',
      'wmv',
      'webm',
      'mpeg',
      'mpg',
      '3gp',
      'rmvb',
      'mts',
    ];
    const ext = cext.toLowerCase();
    const obj = {
      isImage: false,
      isVideo: false,
      isDefault: false,
    };
    if (imageExts.includes(ext)) {
      obj.isImage = true;
    } else if (videoExts.includes(ext)) {
      obj.isVideo = true;
    } else obj.isDefault = true;
    return obj;
  };
}
class PageBD {
  constructor(config, objsearch, objdata, inidata) {
    try {
      this.config = config;
      this.objdata = objdata;
      this.objsearch = objsearch;
      this.detailinfo = this.config.proxy.$utils.comm.getRouteInfo(this.config.name);
      if (!this.detailinfo) this.detailinfo = { path: '', name: '', title: '' };
      this.objdata = objdata;
      this.objsearch = objsearch;
      this.objsearch.issearch = false;
      this.objsearch.loading = false;
      if (!this.objsearch.ipagesize) this.objsearch.ipagesize = 15;
      if (!this.objsearch.icurrpage) this.objsearch.icurrpage = 0;
      this.objsearch.list = [];
      //权限
      if (!this.objdata.btn) this.objdata.btn = {};
      if (inidata && inidata.rolst) {
        for (let i1 = 0; i1 <= inidata.rolst.length - 1; i1++) {
          objdata.btn[inidata.rolst[i1].cbaroper] = 1;
        }
      }
      if (!this.objdata.columns) this.objdata.columns = {};
      let result = {};
      if (inidata && inidata.views && Object.keys(inidata.views).length != 0) {
        for (let key in inidata.views) {
          if (inidata.views.hasOwnProperty(key)) {
            if (
              inidata.views[key].tablelst &&
              Object.keys(inidata.views[key].tablelst).length != 0
            ) {
              let col = [];
              for (let key1 in inidata.views[key].tablelst) {
                if (inidata.views[key].head && inidata.views[key].head.ilayout != 3) {
                  col = col.concat(inidata.views[key].tablelst[key1]);
                  result[key] = col;
                } else {
                  for (let key2 in inidata.views[key].tablelst[key1]) {
                    col = col.concat(inidata.views[key].tablelst[key1][key2]);
                    result[key] = col;
                  }
                }
              }
            } else {
              // tablelst = {} 就取查找paras的
              if (inidata && inidata.paras) {
                if (inidata.paras.hasOwnProperty(key)) {
                  result[key] = inidata.paras[key];
                }
              }
            }
          }
        }
      } else if (inidata && inidata.paras) {
        for (let key in inidata.paras) {
          if (inidata.paras.hasOwnProperty(key)) {
            // 确保是对象自有属性，不是原型链上的属性
            result[key] = inidata.paras[key];
          }
        }
      }
      for (let key in result) {
        if (result.hasOwnProperty(key)) {
          // 确保是对象自有属性，不是原型链上的属性
          this.objdata.columns[key] = result[key];
          this.objdata.com[key] = true;
          this.objdata.focus[key] = false;
          this.objsearch.columns[key] = result[key];
          this.objsearch.com[key] = true;
          this.objsearch.focus[key] = false;
        }
      }
      if (!this.objdata.objini) this.objdata.objini = {};
      if (inidata && inidata.objini) {
        for (let key in inidata.objini) {
          if (inidata.objini.hasOwnProperty(key)) {
            // 确保是对象自有属性，不是原型链上的属性
            this.objdata.objini[key] = inidata.objini[key].replace(/[\r\n]+/g, '');
          }
        }
      }
      console.log('create...end...', this.objdata);
    } catch (e1) {
      console.log('create error......', e1);
    }
  }
  pageMethods = (oper) => {
    const funcName = oper.replace(/\(.*\)/, '').trim();
    if (funcName in this.config.proxy.$obj) {
      console.log('*******funcName', funcName);
      this[funcName]();
    }
  };
  exportExcel = () => {
    if (this.objsearch.selectRow.length == 0) {
      this.config.proxy.$notify({
        title: '系统提示',
        message: '请先搜索获取数据后勾选需要导出的数据',
        type: 'warning',
      });
      return;
    }
    this.config.proxy.$utils.export.exportExcelAll(
      this.objsearch.selectRow,
      this.objsearch.columns.list.filter(
        (item) => item.iignore == 0 && item.ihide == 0 && item.itype != 99
      ),
      this.config.detailinfo.title == '' ? '导出' : this.config.detailinfo.title
    );
    this.config.callback({ iresult: 0, cerror: '', coper: 'exportExcel', data: null });
  };
  exportExcelAll = () => {
    if (this.objsearch.list.length == 0) {
      proxy.$notify({
        title: '系统提示',
        message: '无导出数据',
        type: 'warning',
      });
      return;
    }
    this.config.proxy.$utils.export.exportExcelAll(
      this.objsearch.list,
      this.objsearch.columns.list.filter(
        (item) => item.iignore == 0 && item.ihide == 0 && item.itype != 99
      ),
      this.config.detailinfo.title == '' ? '导出' : this.config.detailinfo.title
    );
    this.config.callback({ iresult: 0, cerror: '', coper: 'exportExcelAll', data: null });
  };
  exportExcelback = (objpara) => {
    let params = {
      cobject: this.config.cobjectt,
      coper: 'export',
      objpara: {
        ctheme: this.config.detailinfo.title + '导出',
        cpagename: this.config.name,
        ...this.objsearch.filter,
        ...objpara,
      },
    };
    this.config.proxy.$execute(params).then((res) => {
      this.objsearch.loading = false;
      if (res.iresult > 300) {
        alert(res.cerror);
        return;
      }
      if (res.iresult == 0) {
        if (res.data.length == 0) {
          this.config.proxy.$notify({
            title: '系统提示',
            message: '无导出数据',
            type: 'warning',
          });
          return;
        }
        this.config.proxy.$utils.export.exportExcelAll(
          res.data.lst ? res.data.lst : res.data,
          this.objsearch.columns.list.filter(
            (item) => item.iignore == 0 && item.ihide == 0 && item.itype != 99
          ),
          this.config.detailinfo.title == '' ? '导出' : this.config.detailinfo.title
        );
        this.config.callback({
          iresult: 0,
          cerror: '',
          coper: 'exportExcelback',
          data: null,
        });
      } else if (res.iresult == 1) {
        this.config.proxy.$message({
          showClose: true,
          message: '已加入任务列表',
          type: 'success',
        });
      }
    });
  };
  fnFileDownload = (idfile, cnamefile, bdown) => {
    FileDownload(idfile, cnamefile, bdown, fnhandleDownload);
  };
  fnFilePreview = (idfile, cnamefile) => {
    FilePreview(idfile, cnamefile);
  };
  fnhandleDownload = (dataurl, contenttype, cnamefile, blob) => {
    switch (contenttype) {
      case 'image/png':
      case 'image/jpeg':
      case 'image/jpg':
      case 'application/pdf': {
        let page = window.open(dataurl);
        setTimeout(() => {
          page.document.title = cnamefile;
        }, 500);
        break;
      }
      case 'application/vnd.ms-excel':
        //后台导出excel
        break;
    }
  };
  onSearch = () => {
    this.objsearch.icurrpage = 1;
    this.fnsearch(true);
  };
  fnsearch = (boolean) => {
    this.objsearch.issearch = true;
    let params = {
      cobject: this.config.cobjectt,
      coper: this.objsearch.search_oper != '' ? this.objsearch.search_oper : 'search',
      objpara: {
        ...this.objsearch.filter,
        ipage: this.objsearch.icurrpage,
        ipagesize: this.objsearch.ipagesize,
      },
    };
    this.config.proxy.$execute(params).then((res) => {
      if (res.iresult != 0) {
        this.config.proxy.$msgbox.alert(res.cerror);
        return;
      }
      this.objsearch.list.length = 0;
      if (res?.data?.hasOwnProperty('lst')) {
        this.objsearch.list.push(...res.data.lst);
        // if (boolean) {
        if (res?.data?.hasOwnProperty('itot')) this.objsearch.itot = res.data.itot;
        else if (res.data.sum) {
          if (res.data.sum.itot) this.objsearch.itot = res.data.sum.itot;
        } else if (
          this.objsearch.list.length !== 0 &&
          this.objsearch.list[0].itot !== null &&
          this.objsearch.list[0].itot !== 0 &&
          this.objsearch.list[0].itot &&
          boolean
        ) {
          this.objsearch.itot = this.objsearch.list[0].itot;
        } else {
          this.objsearch.itot = this.objsearch.list.length;
        }
        // }
      } else {
        this.objsearch.list.push(...res.data);
        if (boolean) {
          if (
            this.objsearch.list.length !== 0 &&
            this.objsearch.list[0].itot !== null &&
            this.objsearch.list[0].itot !== 0 &&
            this.objsearch.list[0].itot
          ) {
            this.objsearch.itot = this.objsearch.list[0].itot;
          } else {
            this.objsearch.itot = this.objsearch.list.length;
          }
        }
      }
      if (res.data.szmap) this.objsearch.szmap = res.data.szmap;
      this.objsearch.issearch = false;
      this.config.callback({ iresult: 0, cerror: '', coper: 'search', data: res.data });
    });
  };
  onSizeChange = (size) => {
    this.objsearch.ipagesize = size;
    this.fnsearch(false);
  };
  onCurrentChange = (currentPage) => {
    this.objsearch.icurrpage = currentPage;
    this.fnsearch(false);
  };
  fnload = (res, objpara) => {
    let params = {
      cobject: this.config.cobjectt,
      coperation: 'search',
      objparameter: objpara
        ? objpara
        : {
          ...this.objsearch.filter,
          idparent: res.id,
          ipagesize: this.objsearch.ipagesize,
          ipage: this.objsearch.icurrpage,
        },
    };
    this.config.proxy.$execute(params).then((result) => {
      if (result.iresult != 0) {
        alert(result.cerror);
        return;
      }
      this.objdata.rowlazy = res.rowlazy;
      if (result.data.lst) {
        res.callback(result.data.lst);
      } else res.callback(result.data);
    });
  };

  fnExpChange = (force, row, expanded, objpara) => {
    if (!row) return;
    // 获取到之前保存的全局变量
    const curr = this.objdata.rowlazy[row.id];
    // 展开次数 +1
    curr.expandCount++;
    // 如果是展开状态，且展开次数大于1，且上一次的状态为折叠，则请求api数据，更新子菜单
    if (expanded && (force || (curr.expandCount > 1 && !curr.prevStatus))) {
      let params = {
        cobject: this.config.cobjectt,
        coperation: 'search',
        objparameter: objpara
          ? objpara
          : {
            ...this.objsearch.filter,
            idparent: this.objdata.rowlazy[row.id].row.id,
            ipagesize: this.objsearch.ipagesize,
            ipage: this.objsearch.icurrpage,
          },
      };
      this.config.proxy.$execute(params).then((res) => {
        if (res.iresult != 0) {
          alert(res.cerror);
          return;
        }
        if (res?.data?.hasOwnProperty('lst')) {
          curr.resolve(res.data.lst);
        } else curr.resolve(res.data);
      });
    }
    // 保存本次的展开或折叠状态，用于下次判断
    curr.prevStatus = expanded;
  };
  onSelectData = (res) => {
    this.objsearch.selectRow = res.data;
  };
  cansel = (res) => {
    if (res.data.row.id == '') {
      return false;
    } else {
      return true;
    }
  };
  fnsellist = (e) => {
    this.objsearch.selectRow = e;
  };
  // 列表点击当前行
  fnselectrow_search = (res) => {
    this.objsearch.currrow = res.data.row;
    this.objsearch.index = res.index;
    this.objdata.data.head = JSON.parse(JSON.stringify(this.objsearch.currrow));
  };
  fnselectrow = (res) => {
    this.objdata.currrow = res.data.row;
    this.objdata.index = res.index;
    this.objdata.data.head = JSON.parse(JSON.stringify(this.objdata.currrow));
  };
  fnselectrow_moveid = (res) => {
    this.objdata.currrow = res.data.row;
    if (this.objdata.status.iflag != 0 || this.objdata.statusf.iflag != 0) return;
    this.fnmoveid(res.data.row.id, 'moveid');
  };
  onRowClick = (res) => {
    this.objdata.currrow = res.data.row;
    this.objdata.index = res.data.index;
  };
  get isnew() {
    if (this.objdata.status.iflag === 2 || this.objdata.statusf.iflag === 2) {
      return true;
    } else {
      return false;
    }
  }
  get isnew_children() {
    if (
      this.objdata.currrow &&
      (this.objdata.status.iflag === 2 || this.objdata.statusf.iflag === 2)
    ) {
      return true;
    } else {
      return false;
    }
  }
  get isedit() {
    if (this.objdata.status.iflag === 1 || this.objdata.statusf.iflag === 1) {
      return true;
    } else {
      return false;
    }
  }
  get cansave() {
    if (this.objdata.status.iflag > 0 || this.objdata.statusf.iflag > 0) {
      return true;
    } else {
      return false;
    }
  }
  get cannew() {
    if (
      this.objdata.status.iflag === 0 ||
      this.objdata.status.iflag === 2 ||
      this.objdata.statusf.iflag === 0 ||
      this.objdata.statusf.iflag === 2
    ) {
      return true;
    } else return false;
  }
  get cannew_children() {
    if (
      this.objdata.currrow &&
      (this.objdata.status.iflag === 0 ||
        this.objdata.status.iflag === 2 ||
        this.objdata.statusf.iflag === 0 ||
        this.objdata.statusf.iflag === 2)
    ) {
      return true;
    } else return false;
  }
  get canedit() {
    if (
      this.objdata.data.head &&
      this.objdata.data.head.id != '' &&
      this.objdata.data.head.istatus === 0 &&
      (this.objdata.status.iflag == 0 ||
        this.objdata.status.iflag == 1 ||
        this.objdata.statusf.iflag == 0 ||
        this.objdata.statusf.iflag == 1)
    ) {
      return true;
    } else return false;
  }
  get canedit_base() {
    if (
      this.objdata.data.head &&
      this.objdata.data.head.id != '' &&
      (this.objdata.status.iflag == 0 ||
        this.objdata.status.iflag == 1 ||
        this.objdata.statusf.iflag == 0 ||
        this.objdata.statusf.iflag == 1)
    ) {
      return true;
    } else return false;
  }
  get isverify() {
    if (this.objdata.data.head.id === '') {
      return false;
    }
    if (this.objdata.data.head.istatus === 20) {
      return true;
    } else {
      return false;
    }
  }
  get canverify() {
    if (
      this.objdata.data.head &&
      this.objdata.data.head.id != '' &&
      (this.objdata.status.iflag === 0 || this.objdata.statusf.iflag === 0) &&
      this.objdata.data.head.istatus >= 0 &&
      this.objdata.data.head.istatus <= 20
    ) {
      return true;
    } else return false;
  }
  get iscancel() {
    if (this.objdata.data.head.id === '') {
      return false;
    }
    if (this.objdata.data.head.istatus === -80) {
      return true;
    } else {
      return false;
    }
  }
  get cancancel() {
    if (
      this.objdata.data.head.id === '' ||
      this.objdata.status.iflag != 0 ||
      this.objdata.statusf.iflag != 0
    ) {
      return false;
    }
    if (
      (this.objdata.data.head &&
        this.objdata.data.head.id != '' &&
        this.objdata.data.head.istatus < 10) ||
      this.objdata.data.head.istatus >= 99
    ) {
      return true;
    } else return false;
  }
  get canaddrow() {
    if (this.objdata.status.iflag != 0 || this.objdata.statusf.iflag != 0) {
      return true;
    } else return false;
  }
  get isclose() {
    if (this.objdata.data.head.id === '') {
      return false;
    }
    if (this.objdata.data.head.istatus === 40) {
      return true;
    } else {
      return false;
    }
  }
  get canclose() {
    if (
      this.objdata.data.head.ccode != '' &&
      (this.objdata.status.iflag === 0 || this.objdata.statusf.iflag === 0) &&
      this.objdata.data.head.istatus >= 20 &&
      this.objdata.data.head.istatus <= 40
    ) {
      return true;
    } else return false;
  }
  get candelete() {
    if (
      this.objdata.data.head.id === '' ||
      this.objdata.status.iflag != 0 ||
      this.objdata.statusf.iflag != 0
    ) {
      return false;
    }
    if (
      (this.objdata.data.head &&
        this.objdata.data.head.id != '' &&
        this.objdata.data.head.istatus < 10) ||
      this.objdata.data.head.istatus >= 99
    ) {
      return true;
    } else return false;
  }
  fnverify = (obj) => {
    if (this.objdata.data.head.id === '') {
      this.config.proxy.$msgbox.alert('请选择行');
      return;
    }
    if (!obj) obj = {};
    let params = {
      cobject: this.config.cobjectt,
      coper: this.objdata.data.head.istatus === 20 ? 'verifyr' : 'verify',
      objpara: {
        ...obj,
        id: this.objdata.data.head.id,
      },
    };
    this.config.proxy.$execute(params).then((res) => {
      if (res.iresult == 0) {
        this.objdata.data.head.istatus = res.data;
        this.objdata.data.head.cstatus = res.data == 20 ? '审核' : '新建';
        if (this.objdata.currrow?.id == this.objdata.data.head.id) {
          this.objdata.currrow.istatus = res.data;
          this.objdata.currrow.cstatus = res.data == 20 ? '审核' : '新建';
        }
        this.config.proxy.$message({
          showClose: true,
          message: this.objdata.data.head.istatus === 20 ? '审核成功~' : '反审核成功',
          type: 'success',
        });
      } else {
        this.config.proxy.$msgbox(res.cerror);
      }
      this.config.callback({ iresult: 0, cerror: '', coper: 'verify', data: res.data });
    });
  };
  fnverifybat = () => {
    if (this.objsearch.selectRow.length == 0) {
      this.config.proxy.$msgbox.alert('请选择需审核数据');
      return;
    }
    let params = {
      cobject: this.config.cobjectt,
      coper: 'verifybt',
      objpara: {
        lst: this.objsearch.selectRow,
      },
    };
    this.config.proxy.$execute(params).then((res) => {
      if (res.iresult == 0) {
        for (let i1 = 0; i1 < this.objsearch.selectRow.length; i1++) {
          if (this.objsearch.selectRow[i1].istatus !== 99) {
            this.objsearch.selectRow[i1].istatus = 20;
            this.objsearch.selectRow[i1].cstatus = '审核';
          }
        }
        this.config.proxy.$message({
          showClose: true,
          message: '批量审核完成~',
          type: 'success',
        });
        this.config.callback({ iresult: 0, cerror: '', coper: 'verifybt', data: null });
      } else {
        this.config.proxy.$msgbox.alert(res.cerror);
        this.config.callback({ iresult: 0, cerror: '', coper: 'verifybt', data: null });
      }
    });
  };
  fnverifyrbat = () => {
    if (this.objsearch.selectRow.length == 0) {
      this.config.proxy.$msgbox.alert('请选择需反审核数据');
      return;
    }
    let params = {
      cobject: this.config.cobjectt,
      coper: 'verifyrbt',
      objpara: {
        lst: this.objsearch.selectRow,
      },
    };
    this.config.proxy.$execute(params).then((res) => {
      if (res.iresult == 0) {
        for (let i1 = 0; i1 < this.objsearch.selectRow.length; i1++) {
          if (this.objsearch.selectRow[i1].istatus !== 99) {
            this.objsearch.selectRow[i1].istatus = 19;
            this.objsearch.selectRow[i1].cstatus = '新建';
          }
        }
        this.config.proxy.$message({
          showClose: true,
          message: '批量反审核完成~',
          type: 'success',
        });
        this.config.callback({ iresult: 0, cerror: '', coper: 'verifyrbt', data: null });
      } else {
        this.config.proxy.$msgbox.alert(res.cerror);
        this.config.callback({ iresult: 0, cerror: '', coper: 'verifyrbt', data: null });
      }
    });
  };
  fncancelbat = () => {
    if (this.objsearch.selectRow.length == 0) {
      this.config.proxy.$msgbox.alert('请选择需作废数据');
      return;
    }
    this.config.proxy.$msgbox
      .confirm('确认作废?', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
      .then(() => {
        let params = {
          cobject: this.config.cobjectt,
          coper: 'cancelbt',
          objpara: {
            lst: this.objsearch.selectRow,
          },
        };
        this.config.proxy.$execute(params).then((res) => {
          if (res.iresult == 0) {
            for (let i1 = 0; i1 < this.objsearch.selectRow.length; i1++) {
              if (this.objsearch.selectRow[i1].istatus !== 20) {
                this.objsearch.selectRow[i1].istatus = 99;
                this.objsearch.selectRow[i1].cstatus = '作废';
              }
            }
            this.config.proxy.$message({
              showClose: true,
              message: '批量作废完成~',
              type: 'success',
            });
            this.config.callback({
              iresult: 0,
              cerror: '',
              coper: 'cancelbt',
              data: null,
            });
          } else {
            this.config.proxy.$msgbox.alert(res.cerror);
            this.config.callback({
              iresult: 0,
              cerror: '',
              coper: 'cancelbt',
              data: null,
            });
          }
        });
      });
  };
  fncancelrbat = () => {
    if (this.objsearch.selectRow.length == 0) {
      this.config.proxy.$msgbox.alert('请选择需反作废数据');
      return;
    }
    this.config.proxy.$msgbox
      .confirm('确认反作废?', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
      .then(() => {
        let params = {
          cobject: this.config.cobjectt,
          coper: 'cancelrbt',
          objpara: {
            lst: this.objsearch.selectRow,
          },
        };
        this.config.proxy.$execute(params).then((res) => {
          if (res.iresult == 0) {
            for (let i1 = 0; i1 < this.objsearch.selectRow.length; i1++) {
              if (objsearch.selectRow[i1].istatus !== 20) {
                this.objsearch.selectRow[i1].istatus = 19;
                this.objsearch.selectRow[i1].cstatus = '新建';
              }
            }
            this.config.proxy.$message({
              showClose: true,
              message: '批量反作废完成~',
              type: 'success',
            });
            this.config.callback({
              iresult: 0,
              cerror: '',
              coper: 'cancelrbt',
              data: null,
            });
          } else {
            this.config.proxy.$msgbox.alert(res.cerror);
            this.config.callback({
              iresult: 0,
              cerror: '',
              coper: 'cancelrbt',
              data: null,
            });
          }
        });
      });
  };
  fnCancel = () => {
    if (this.objdata.data.head.id === '') {
      this.config.proxy.$msgbox.alert('请选择行');
    }
    if (this.objdata.data.head.istatus >= -80) {
      this.config.proxy.$msgbox
        .confirm(
          this.objdata.data.head.istatus === -80 ? '确认反作废?' : '确认作废',
          '提醒',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
        )
        .then(() => {
          let params = {
            cobject: this.config.cobjectt,
            coper: this.objdata.data.head.istatus === -80 ? 'cancelr' : 'cancel',
            objpara: {
              id: this.objdata.data.head.id,
            },
          };
          this.config.proxy.$execute(params).then((res) => {
            if (res.iresult == 0) {
              this.objdata.data.head.istatus = res.data;
              this.objdata.data.head.cstatus = res.data == -80 ? '作废' : '新建';
              this.config.proxy.$message({
                showClose: true,
                message:
                  this.objdata.data.head.istatus === -80 ? '作废成功~' : '反作废成功',
                type: 'success',
              });
              this.onSearch();
            } else {
              this.config.proxy.$msgbox(res.cerror);
            }
          });
        });
    }
  };

  onChange = (res) => {
    if (!res) return;
    let cscope = res.cscope ? res.cscope : '';
    let cfield = res.cfield ? res.cfield : '';
    let itype = res.column.itype ? res.column.itype : 0;
    let isearch = res.column.isearch ? res.column.isearch : 0;
    switch (cscope) {
      case 'filter':
        this.onSearch();
        break;
    }
  };
  onSaveSwitch = (res) => {
    setTimeout(() => {
      let params = {
        cobject: this.config.cobjectt,
        coperation: 'save_switch',
        objparameter: {
          id: res.data.id,
          iswitch: res.data.value,
          cswitch: res.data.cswitch,
          [res.data.cswitch]: res.data.value,
        },
      };
      this.config.proxy.$execute(params).then((res) => {
        if (res.iresult != 0) {
          alert(res.cerror);
          return;
        }
        this.config.proxy.$message({
          showClose: true,
          message: '修改成功~',
          type: 'success',
        });
      });
    }, 300);
  };
  getRowKeys = (row) => {
    return row.id;
  };
  fnClose = () => {
    if (this.objdata.data.head.id === '') {
      alert('请选择行');
      return;
    }
    if (this.objdata.data.head.istatus <= 40) {
      this.config.proxy.$msgbox
        .confirm(
          this.objdata.data.head.istatus === 40 ? '确认反关闭?' : '确认关闭',
          '提醒',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
        )
        .then(() => {
          let params = {
            cobject: this.config.cobjectt,
            coperation: this.objdata.data.head.istatus === 40 ? 'closer' : 'close',
            objparameter: {
              id: this.objdata.data.head.id,
            },
          };
          this.config.proxy.$execute(params).then((res) => {
            if (res.iresult == 0) {
              this.objdata.data.head.istatus = res.data;
              this.config.proxy.$message({
                showClose: true,
                message:
                  this.objdata.data.head.istatus === 40 ? '关闭成功~' : '反关闭成功',
                type: 'success',
              });
            } else {
              this.config.proxy.$msgbox(res.cerror);
            }
          });
        });
    }
  };
  fninitobj = () => {
    if (this.objdata.props) {
      this.objdata.data.head = this.fncreateobj('head');
    } else {
      Object.keys(this.objdata.data.head).forEach(
        (key) => (this.objdata.data.head[key] = this.objdata.init[key])
      );
    }
    // this.objdata.data.head.id = this.config.proxy.$utils.comm.getGuid();
    if ('irowstatus' in this.objdata.data.head) {
      this.objdata.data.head.irowstatus = 2;
    }
    if (this.objdata.status.iflag == 0) {
      this.objdata.data.head.ddate = new Date().toISOString();
    }
    if (this.objdata.data.ctl)
      Object.keys(this.objdata.data.ctl).forEach(
        (key) => (this.objdata.data.ctl[key] = this.objdata.initctl[key])
      );
    for (let key in this.objdata.data) {
      if (this.objdata.data.hasOwnProperty(key)) {
        if (Object.keys(this.objdata.islst).length !== 0) {
          if (this.objdata.islst[key] && this.objdata.islst[key] == 1) {
            this.objdata.data[key] = [];
          } else if (key != 'head' && key != 'ctl') {
            let obj = null;
            obj = this.fncreateobj(key);
            if (obj) {
              this.objdata.data[key] = obj;
            }
          }
        } else {
          if (key != 'head' && key != 'ctl') {
            if (key == 'details') {
              this.objdata.data[key] = [];
            } else if (key.indexOf('lst') !== -1) {
              this.objdata.data[key] = [];
            } else {
              let obj = null;
              obj = this.fncreateobj(key);
              if (obj) {
                this.objdata.data[key] = obj;
              }
            }
          }
        }

        if (this.objdata.status.iflag == 0 || this.objdata.statusf.iflag == 0) {
          if (key == 'details') {
            this.fnaddrow('details');
          }
        }
      }
    }

    for (let key in this.objdata.del) {
      if (this.objdata.del.hasOwnProperty(key)) {
        this.objdata.del[key] = [];
      }
    }
    this.objdata.isshowstate = false;
    this.objsearch.iiptype = 0;
    this.objsearch.itype = 0;
    this.config.callback({ iresult: 0, cerror: '', coper: 'initobj', data: null });
  };
  fnaddrow = (lst) => {
    if (lst) {
      this.objdata.newrow = this.fncreateobj(lst);
      if (!this.objdata.newrow) return;
      if ('iorder' in this.objdata.newrow) {
        this.objdata.newrow.iorder = this.objdata.data[lst].length + 1;
      }
      if ('id' in this.objdata.newrow) {
        this.objdata.newrow.id = this.config.proxy.$utils.comm.getGuid();
      }
      if ('irowstatus' in this.objdata.newrow) {
        this.objdata.newrow.irowstatus = 2;
      }
      this.objdata.data[lst].push(this.objdata.newrow);
    } else {
      this.objdata.newrow = this.fncreateobj('details');
      if (!this.objdata.newrow) return;
      if ('iorder' in this.objdata.newrow) {
        this.objdata.newrow.iorder = this.objdata.data.details.length + 1;
      }
      if ('irowstatus' in this.objdata.newrow) {
        this.objdata.newrow.irowstatus = 2;
      }
      this.objdata.data.details.push(this.objdata.newrow);
    }
    if ('details' in this.objdata.data) {
      if (this.objdata.data.details.length == 1) {
        this.objdata.currrow = this.objdata.data.details[0];
        this.objdata.index = 0;
      }
    }
    this.config.callback({ iresult: 0, cerror: '', coper: 'addrow', data: lst });
  };
  fnaddrows = (lst) => {
    if (lst) {
      this.objdata.newrow = this.fncreateobj(lst);
      if ('id' in this.objdata.newrow) {
        this.objdata.newrow.id = this.config.proxy.$utils.comm.getGuid();
      }
      if ('irowstatus' in this.objdata.newrow) {
        this.objdata.newrow.irowstatus = 2;
      }
    } else {
      this.objdata.newrow = this.fncreateobj('detailb');
      if ('irowstatus' in this.objdata.newrow) {
        this.objdata.newrow.irowstatus = 2;
      }
    }
    this.config.callback({ iresult: 0, cerror: '', coper: 'addrows', data: lst });
  };
  fnrefresh = () => {
    if (this.objdata.status.iflag > 0 || this.objdata.statusf.iflag > 0) {
      this.config.proxy.$msgbox
        .confirm('您确定要放弃当前编辑吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          this.objdata.status.iflag = 0;
          this.objdata.statusf.iflag = 0;
          if (
            (this.objdata.data.head.id == '' || this.objdata.data.head.id == null) &&
            this.config.proxy.$router.currentRoute.query.id
          ) {
            this.fnmoveid(this.config.proxy.$router.currentRoute.query.id, 'moveid');
          } else {
            this.fnmoveid(this.objdata.data.head.id, 'moveid');
          }
          if (this.objdata.data.head.idwf !== '' || this.objdata.data.head.idwfe !== '') {
            this.objdata.wf.isload = true;
            setTimeout(() => {
              this.objdata.wf.isload = false;
            }, 100);
          }
        })
        .catch(() => {
          this.config.proxy.$message({
            showClose: true,
            message: '已取消~',
            type: 'success',
          });
        });
    } else {
      if (
        (this.objdata.data.head.id == '' || this.objdata.data.head.id == null) &&
        this.config.proxy.$router.currentRoute.query.id
      ) {
        this.fnmoveid(this.config.proxy.$router.currentRoute.query.id, 'moveid');
      } else {
        this.fnmoveid(this.objdata.data.head.id, 'moveid');
      }
      if (this.objdata.data.head.idwf !== '' || this.objdata.data.head.idwfe !== '') {
        this.objdata.wf.isload = true;
        setTimeout(() => {
          this.objdata.wf.isload = false;
        }, 100);
      }
    }
  };
  fnmoveid = (id, coper, obj) => {
    if (!obj) obj = {};
    if (id == '' || id == null) return;
    this.objdata.loading = true;
    let params = {
      cobject: this.config.cobjectt,
      coper: 'moveid',
      objpara: {
        id: id,
        ...obj,
      },
    };
    this.config.proxy.$execute(params).then((res) => {
      if (res.iresult !== 0) {
        alert(res.cerror);
        this.objdata.loading = false;
        return;
      }
      this.objdata.data = res.data;
      // 初始化删除列表
      for (let key in this.objdata.del) {
        if (this.objdata.del.hasOwnProperty(key)) {
          // 确保是对象自身的属性，而不是继承的属性
          // 对每个属性进行赋值操作
          this.objdata.del[key] = []; // 例如，将每个属性的值乘以2
        }
      }
      this.objdata.isshow = true;
      this.objdata.isshowstate = true;
      this.objdata.printlst.length = 0;
      // if (res.data.head?.idwf !== '' || res.data.head?.idwfe !== '') {
      //   this.objdata.wf.isload = true;
      //   setTimeout(() => {
      //     this.objdata.wf.isload = false;
      //   }, 100);
      // }
      setTimeout(() => {
        this.objdata.loading = false;
      }, 1000);
      if (coper && coper == 'edit') this.fnedit();
      this.config.callback({
        iresult: 0,
        cerror: '',
        coper: 'moveid',
        data: JSON.stringify(res.data),
      });
    });
  };
  fnnew = (itype) => {
    this.objdata.inewtype = itype;
    if (this.objdata.data.head.id && this.objdata.data.head.id !== '') {
      if (!this.config.detailinfo) {
        alert('详情路由信息不存在');
        return;
      }
      this.config.proxy.$router.push({
        path: this.config.detailinfo.path,
        query: {
          tagsViewName:
            this.config.detailinfo.title +
            '_' +
            Math.round(new Date().getTime() / 1000)
              .toString()
              .slice(4, 10),
          coper: itype == 1 ? 'newquick' : 'new',
        },
      });
      return;
    }
    if (this.objdata.status.iflag === 0 || this.objdata.statusf.iflag === 0) {
      this.fninitobj();
      this.objdata.showadd = true;
      this.objdata.status.iflag = 2;
      this.objdata.statusf.iflag = 2;
      // this.fnaddrow();
      this.objdata.isshowstate = false;
      if (itype == 1) {
        this.objsearch.isshownew = true;
      }
    } else if (this.objdata.status.iflag === 2 || this.objdata.statusf.iflag === 2) {
      this.fninitobj();
      this.objdata.showadd = false;
      this.objdata.status.iflag = 0;
      this.objdata.statusf.iflag = 0;
      this.objdata.isshowstate = false;
      if (itype == 1) {
        this.objsearch.itype = 1;
        this.objsearch.isshownew = false;
      }
    }
  };
  fnedit = () => {
    if (this.objdata.status.iflag === 0 || this.objdata.statusf.iflag === 0) {
      this.objdata.status.iflag = 1;
      this.objdata.statusf.iflag = 1;
      this.objdata.showadd = true;
      this.objdata.isshow = true;
      // if (this.objdata.inewtype == 0) this.fnaddrow();
      this.objdata.isshowstate = false;
    } else if (this.objdata.status.iflag === 1 || this.objdata.statusf.iflag === 1) {
      this.objdata.status.iflag = 0;
      this.objdata.statusf.iflag = 0;
      // this.objdata.data.details.splice(this.objdata.inewrow, 1);
      // this.objdata.newrow = null;
      if (this.objdata.data.head.id == '') this.fninitobj();
      else this.fnmoveid(this.objdata.data.head.id, 'moveid');
      this.objdata.showadd = false;
      this.objdata.isshowstate = true;
      this.objdata.isshow = false;
    }
  };
  fnnew2 = () => {
    if (this.objdata.status.iflag === 0 || this.objdata.statusf.iflag === 0) {
      this.fninitobj();
      this.objdata.status.iflag = 2;
      this.objdata.statusf.iflag = 2;
      this.objdata.isshow = true;
    } else {
      this.fninitobj();
      setTimeout(() => {
        this.objdata.status.iflag = 0;
        this.objdata.statusf.iflag = 0;
        this.objdata.isshow = false;
      }, 100);
    }
  };
  fnnew2_children = () => {
    if (this.objdata.status.iflag === 0 || this.objdata.statusf.iflag === 0) {
      if (
        this.objdata.curr.idparent == '' &&
        (this.objdata.currrow == null || this.objdata.currrow.id == '')
      ) {
        this.config.proxy.$msgbox.alert('请选择上级');
        return;
      }
      this.fninitobj();
      this.objdata.status.iflag = 2;
      this.objdata.statusf.iflag = 2;
      const head = this.objdata.data?.head;
      const { curr, currrow } = this.objdata;
      if ('idparent' in head) {
        head.idparent = curr.idparent || currrow.id || '';
      }
      if ('cbarparent' in head) {
        head.cbarparent = curr.cbarparent || currrow.cbar || '';
      }
      if ('ccodeparent' in head) {
        head.ccodeparent = curr.ccodeparent || currrow.ccode || '';
      }
      if ('cnameparent' in head) {
        head.cnameparent = curr.cnameparent || currrow.cname || '';
      }
      if ('itier' in head) {
        head.itier = curr.itier === 0
          ? currrow.itier ? currrow.itier + 1 : 1
          : curr.itier + 1;
      }
      if ('idpath' in head) {
        head.idpath = curr.idpath || currrow.idpath || '';
      }
      if ('cbarpath' in head) {
        head.cbarpath = curr.cbarpath || currrow.cbarpath || '';
      }
      if ('ccodepath' in head) {
        head.ccodepath = curr.ccodepath || currrow.ccodepath || '';
      }
      if ('cnamepath' in head) {
        head.cnamepath = curr.cnamepath || currrow.cnamepath || '';
      }
      this.objdata.isshow = true;
    } else {
      this.fninitobj();
      this.objdata.status.iflag = 0;
      this.objdata.statusf.iflag = 0;
      this.objdata.isshow = false;
    }
  };
  fnedit2 = () => {
    if (this.objdata.currrow == null) {
      this.config.proxy.$msgbox.alert('请选择行');
      return;
    }
    if (this.objdata.status.iflag === 0 || this.objdata.statusf.iflag === 0) {
      this.objdata.status.iflag = 1;
      this.objdata.statusf.iflag = 1;
      // this.objdata.data.head = JSON.parse(JSON.stringify(this.objdata.currrow));
      this.fnmoveid(this.objdata.currrow.id, 'moveid');
      this.objdata.data.head.irowstatus = 1;
      this.objdata.isshow = true;
    } else {
      this.objdata.status.iflag = 0;
      this.objdata.statusf.iflag = 0;
      this.objdata.isshow = false;
    }
  };
  fnmoveid2 = () => {
    this.objdata.data.head = JSON.parse(JSON.stringify(this.objdata.currrow));
    // this.objdata.data.head.irowstatus = 1;
    this.objdata.isshow = true;
  };
  fntomoveid = () => {
    if (this.objdata.currrow === null) {
      alert('请选择行');
      return;
    }
    if (!this.config.detailinfo) {
      alert('详情路由信息不存在');
      return;
    }
    this.config.proxy.$router.push({
      path: this.config.detailinfo.path,
      query: {
        id: this.objdata.currrow.id,
        tagsViewName: this.config.detailinfo.title + '_' + this.objdata.currrow.ccode,
        coper: 'moveid',
      },
    });
  };
  fncancel2 = () => {
    this.objdata.status.iflag = 0;
    this.objdata.statusf.iflag = 0;
    this.objdata.isshow = false;
  };
  fnclose2 = () => {
    this.objdata.status.iflag = 0;
    this.objdata.statusf.iflag = 0;
    this.objdata.isshow = false;
  };
  fnsave = (boolean, obj) => {
    if (!obj) obj = {};
    for (let key in this.objdata.columns) {
      if (this.objdata.columns.hasOwnProperty(key) && key == 'head') {
        for (let i1 = 0; i1 < this.objdata.columns[key].length; i1++) {
          if (
            this.objdata.columns[key][i1].imust == 1 &&
            this.objdata.columns[key][i1].prop != 'id' &&
            this.objdata.columns[key][i1].prop != 'ccode' &&
            this.objdata.columns[key][i1].ihide !== 1 &&
            this.objdata.columns[key][i1].iignore !== 1
          ) {
            if (this.objdata.data[key][this.objdata.columns[key][i1].prop] === '') {
              this.config.proxy.$msgbox.alert(
                `${key} - ${this.objdata.columns[key][i1].prop} - ${this.objdata.columns[key][i1].label}必填`
              );
              return;
            }
          }
        }
      }
    }
    if (this.objdata.data.head.ccode === null || this.objdata.data.head.ccode === '') {
      this.objdata.data.head.ccode = this.objdata.data.head.cbar;
    }
    let params = {
      cobject: this.config.cobjectt,
      coperation: 'save',
      objparameter: {
        ...obj,
        data: this.objdata.data,
        del: this.objdata.del,
      },
    };

    this.config.proxy.$execute(params).then((res) => {
      if (res.iresult == 0) {
        this.objdata.data = res.data;
        // 初始化删除列表
        for (let key in this.objdata.del) {
          if (this.objdata.del.hasOwnProperty(key)) {
            // 确保是对象自身的属性，而不是继承的属性
            // 对每个属性进行赋值操作
            this.objdata.del[key] = []; // 例如，将每个属性的值乘以2
          }
        }
        this.objdata.status.iflag = 0;
        this.objdata.statusf.iflag = 0;
        this.objdata.isshow = false;
        // this.objdata.data.head.irowstatus = 0;
        const head = this.objdata.data?.head;
        const currrow = this.objdata.currrow;
        const resData = res.data?.head ?? res.data;

        // 1. 先判断新建/编辑
        if (head?.irowstatus === 2) {
          // 新建
          if (head?.idparent) {
            this.fnExpChange(true, this.objdata.rowlazy[head.idparent]?.row, true);
          } else {
            this.objsearch.list.push({ ...resData });
            this.objdata.currrow = resData;
          }
        } else {
          // 编辑
          if (currrow?.idparent) {
            this.fnExpChange(true, this.objdata.rowlazy[currrow.idparent]?.row, true);
          } else {
            this.objdata.currrow = { ...currrow, ...resData };
          }
        }

        if (this.objdata.data.head.istatus < 20) {
          this.config.proxy.$message({
            showClose: true,
            message: '保存成功,审核才生效哦~',
            type: 'success',
          });
        } else {
          this.config.proxy.$message({
            showClose: true,
            message: '保存成功~',
            type: 'success',
          });
        }

        if (boolean) this.onSearch();
        this.config.callback({ iresult: 0, cerror: '', coper: 'save', data: res });
      } else {
        this.config.proxy.$msgbox(res.cerror);
      }
    });
  };
  fndelete = (obj) => {
    if (!obj) obj = {};
    if (this.objdata.data.head.id == '') {
      this.config.proxy.$msgbox.alert('请选择删除记录');
      return;
    }

    this.config.proxy.$msgbox
      .confirm(
        `您确定要删除【${this.objdata.data.head.ccode}】${this.objdata.data.head.cname}吗？`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      )
      .then(() => {
        let params = {
          cobject: this.config.cobjectt,
          coper: 'delete',
          objpara: {
            ...obj,
            id: this.objdata.data.head.id,
          },
        };
        this.config.proxy.$execute(params).then((res) => {
          if (res.iresult == 0) {
            this.config.proxy.$message({
              showClose: true,
              message: '已删除~',
              type: 'success',
            });
            if (
              this.objdata.data.head?.idparent != '' &&
              !this.isEmptyObject(this.objdata.rowlazy)
            ) {
              this.fnExpChange(
                true,
                this.objdata.rowlazy[this.objdata.data.head?.idparent].row,
                true
              );
            } else {
              this.fnsearch();
            }
          } else {
            this.config.proxy.$msgbox.alert(res.cerror);
          }
        });
      })
      .catch(() => {
        this.config.proxy.$msgbox.alert('已取消删除操作');
      });
  };
  fndelete_li = (obj) => {
    if (!obj) obj = {};
    if (this.objdata.data.head.id == '') {
      this.config.proxy.$msgbox.alert('请选择删除记录');
      return;
    }

    this.config.proxy.$msgbox
      .confirm(
        `您确定要删除【${this.objdata.data.head.ccode}】${this.objdata.data.head.cname}吗？`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      )
      .then(() => {
        let params = {
          cobject: this.config.cobjectt,
          coper: 'delete',
          objpara: {
            ...obj,
            id: this.objdata.data.head.id,
          },
        };
        this.config.proxy.$execute(params).then((res) => {
          if (res.iresult == 0) {
            let idx = this.objsearch.list.findIndex(
              (item) => item.id == this.objdata.data.head.id
            );
            if (idx != -1) {
              this.objsearch.list.splice(idx, 1);
            }
            this.config.proxy.$message({
              showClose: true,
              message: '已删除~',
              type: 'success',
            });
            this.fninitobj();
          } else {
            this.config.proxy.$msgbox.alert(res.cerror);
          }
        });
      })
      .catch(() => {
        this.config.proxy.$msgbox.alert('已取消删除操作');
      });
  };
  focusSelect = (event) => {
    if ('select' in event.target && typeof event.target.select == 'function') {
      event.target.select();
    }
  };
  fncreateobj = (cobj) => {
    let obj = null;
    let temp = null;
    let isAllSpaces = false;
    try {
      if (this.objdata.columns[cobj]) {
        obj = {};
        for (let i1 = 0; i1 < this.objdata.columns[cobj].length; i1++) {
          if (this.objdata.columns[cobj][i1].cfield == '') {
            switch (this.objdata.columns[cobj][i1].cobject) {
              case 'i':
                obj[this.objdata.columns[cobj][i1].prop] = 0;
                continue;
              case 'o':
                obj[this.objdata.columns[cobj][i1].prop] = {};
                continue;
              case 'a':
                obj[this.objdata.columns[cobj][i1].prop] = [];
                continue;
            }
          }
          if (
            this.objdata.columns[cobj][i1].cdefault &&
            this.objdata.columns[cobj][i1].cdefault != '' &&
            this.objdata.columns[cobj][i1].cdefault.startsWith('props')
          ) {
            let params = this.objdata.columns[cobj][i1].cdefault.split('.');
            if (params.length >= 2) {
              obj[this.objdata.columns[cobj][i1].prop] = this.objdata.props[params[1]];
            }
          } else if (
            this.objdata.columns[cobj][i1].cdefault &&
            this.objdata.columns[cobj][i1].cdefault != '' &&
            this.objdata.columns[cobj][i1].cdefault.startsWith('paras')
          ) {
            let params = this.objdata.columns[cobj][i1].cdefault.split('.');
            if (params.length >= 2) {
              obj[this.objdata.columns[cobj][i1].prop] = this.objdata.paras[params[1]];
            }
          } else {
            switch (this.objdata.columns[cobj][i1].itype) {
              case 5:
                if (
                  this.objdata.columns[cobj][i1].cdefault &&
                  this.objdata.columns[cobj][i1].cdefault != ''
                ) {
                  isAllSpaces = /^ +$/.test(this.objdata.columns[cobj][i1].cdefault);
                  temp = parseInt(this.objdata.columns[cobj][i1].cdefault);
                  if (isAllSpaces)
                    obj[this.objdata.columns[cobj][i1].prop] = this.objdata.columns[cobj][
                      i1
                    ].cdefault;
                  else if (!isNaN(temp)) obj[this.objdata.columns[cobj][i1].prop] = temp;
                  else if (this.objdata.columns[cobj][i1].option.length > 0)
                    obj[this.objdata.columns[cobj][i1].prop] = this.objdata.columns[cobj][
                      i1
                    ].option[0].value;
                  else obj[this.objdata.columns[cobj][i1].prop] = 0;
                } else {
                  if (this.objdata.columns[cobj][i1].option.length > 0)
                    obj[this.objdata.columns[cobj][i1].prop] = this.objdata.columns[cobj][
                      i1
                    ].option[0].value;
                  else obj[this.objdata.columns[cobj][i1].prop] = 0;
                }
                break;
              case 51:
                if (
                  this.objdata.columns[cobj][i1].cdefault &&
                  this.objdata.columns[cobj][i1].cdefault != ''
                ) {
                  isAllSpaces = /^ +$/.test(this.objdata.columns[cobj][i1].cdefault);
                  temp = parseInt(this.objdata.columns[cobj][i1].cdefault);
                  if (isAllSpaces)
                    obj[this.objdata.columns[cobj][i1].prop] = this.objdata.columns[cobj][
                      i1
                    ].cdefault;
                  else if (!isNaN(temp)) obj[this.objdata.columns[cobj][i1].prop] = temp;
                  else obj[this.objdata.columns[cobj][i1].prop] = 0;
                } else {
                  obj[this.objdata.columns[cobj][i1].prop] = 0;
                }
                break;
              case 1:
              case 2:
                if (
                  this.objdata.columns[cobj][i1].cdefault &&
                  this.objdata.columns[cobj][i1].cdefault != ''
                ) {
                  temp = parseFloat(this.objdata.columns[cobj][i1].cdefault);
                  if (!isNaN(temp)) obj[this.objdata.columns[cobj][i1].prop] = temp;
                  else obj[this.objdata.columns[cobj][i1].prop] = 0;
                } else {
                  obj[this.objdata.columns[cobj][i1].prop] = 0;
                }
                break;
              case 6:
                if (
                  this.objdata.columns[cobj][i1].cdefault &&
                  this.objdata.columns[cobj][i1].cdefault != ''
                ) {
                  obj[
                    this.objdata.columns[cobj][i1].prop
                  ] = this.config.proxy.$utils.dtformat.fomatTime(
                    new Date(),
                    this.objdata.columns[cobj][i1].cdefault
                  );
                } else {
                  if (this.objdata.columns[cobj][i1].imust > 0) {
                    obj[this.objdata.columns[cobj][i1].prop] = new Date();
                  } else {
                    obj[this.objdata.columns[cobj][i1].prop] = null;
                  }
                }
                if (
                  this.objdata.columns[cobj][i1].prop2 &&
                  this.objdata.columns[cobj][i1].prop2 != ''
                ) {
                  let prop2Obj = this.format_prop2(this.objdata.columns[cobj][i1].prop2);
                  if (prop2Obj) {
                    if (prop2Obj.length == 1) {
                      obj[this.objdata.columns[cobj][i1].prop2] = null;
                    } else {
                      for (const key in prop2Obj.obj) {
                        if (prop2Obj.obj.hasOwnProperty(key)) {
                          obj[key] = null;
                        }
                      }
                    }
                  }
                }
                if (
                  this.objdata.columns[cobj][i1].propdp &&
                  this.objdata.columns[cobj][i1].propdp != ''
                ) {
                  obj[this.objdata.columns[cobj][i1].propdp] = null;
                }
                break;
              case 9:
                obj[this.objdata.columns[cobj][i1].prop] = [''];
                if (
                  this.objdata.columns[cobj][i1].prop2 &&
                  this.objdata.columns[cobj][i1].prop2 != ''
                ) {
                  let prop2Obj = this.format_prop2(this.objdata.columns[cobj][i1].prop2);
                  if (prop2Obj) {
                    if (prop2Obj.length == 1) {
                      obj[this.objdata.columns[cobj][i1].prop2] = '';
                    } else {
                      for (const key in prop2Obj.obj) {
                        if (prop2Obj.obj.hasOwnProperty(key)) {
                          obj[key] = '';
                        }
                      }
                    }
                  }
                }
                if (
                  this.objdata.columns[cobj][i1].propdp &&
                  this.objdata.columns[cobj][i1].propdp != ''
                ) {
                  obj[this.objdata.columns[cobj][i1].propdp] = '';
                }
                continue;
              case 90:
                obj[this.objdata.columns[cobj][i1].prop] = [];
                continue;
              default:
                if (
                  this.objdata.columns[cobj][i1].cdefault &&
                  this.objdata.columns[cobj][i1].cdefault != ''
                ) {
                  if (this.objdata.columns[cobj][i1].cdefault.startsWith('user')) {
                    let defaultlst = this.objdata.columns[cobj][i1].cdefault.split('.');
                    if (defaultlst.length == 2) {
                      obj[
                        this.objdata.columns[cobj][i1].prop
                      ] = this.config.proxy.$store.state.user[defaultlst[1]];
                    }
                  } else if (
                    this.objdata.columns[cobj][i1].cdefault.startsWith('vouch')
                  ) {
                    let defaultlst = this.objdata.columns[cobj][i1].cdefault.split('.');
                    if (defaultlst.length == 2) {
                      obj[this.objdata.columns[cobj][i1].prop] = this.objdata.vouch[
                        defaultlst[1]
                      ];
                    }
                  } else {
                    obj[this.objdata.columns[cobj][i1].prop] = this.objdata.columns[cobj][
                      i1
                    ].cdefault;
                  }
                } else {
                  obj[this.objdata.columns[cobj][i1].prop] = '';
                }

                if (
                  this.objdata.columns[cobj][i1].prop2 &&
                  this.objdata.columns[cobj][i1].prop2 != ''
                ) {
                  let prop2Obj = this.format_prop2(this.objdata.columns[cobj][i1].prop2);
                  if (prop2Obj) {
                    if (prop2Obj.length == 1) {
                      obj[this.objdata.columns[cobj][i1].prop2] = '';
                    } else {
                      for (const key in prop2Obj.obj) {
                        if (prop2Obj.obj.hasOwnProperty(key)) {
                          obj[key] = '';
                        }
                      }
                    }
                  }
                }
                if (
                  this.objdata.columns[cobj][i1].propdp &&
                  this.objdata.columns[cobj][i1].propdp != ''
                ) {
                  obj[this.objdata.columns[cobj][i1].propdp] = '';
                }

                break;
            }
          }
        }
      }
    } catch (e) {
      console.log('createobj error....', e);
      this.config.proxy.$msgbox(e.message);
    }
    return obj;
  };
  format_prop2 = (prop2) => {
    if (prop2 == '') return null;
    let obj = {};
    let delobj = {};
    // let prop2 = 'idcust:id,cbarcust:cbar,cnamecust:cname,idorg:idsaorg,cnameorg:cnamesaorg';
    let prop2lst = prop2.split(',');
    for (let i1 = 0; i1 < prop2lst.length; i1++) {
      let params = prop2lst[i1].split(':');
      if (params.length >= 2) {
        const key = params[0];
        const value = params[1];
        let delvalue = '';
        if (params.length >= 3) {
          delvalue = params[2];
        }
        obj[key] = value;
        delobj[key] = delvalue;
      }
    }
    var res = {
      length: prop2lst.length,
      obj,
      delobj,
    };
    return res;
  };
  onOper = (res) => {
    if (!res) return;
    let cscope = res.cscope ? res.cscope : '';
    switch (res.data.oper) {
      case 'ondelete':
        this.objdata.index = res.data.index;
        this.objdata.currrow = res.data.row;
        this.config.pageobj.deleteRow(this.objdata.index, this.objdata.currrow, cscope);
        break;
    }
  };
  deleteRow = (index, row, scope) => {
    if (this.objdata.status.iflag == 0 || this.objdata.statusf.iflag == 0) return;
    this.config.proxy.$msgbox
      .confirm('确认删除?', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
      .then(() => {
        if (row.irowstatus !== 2) {
          this.objdata.del[scope].push(row.id);
        }
        this.objdata.data[scope].splice(index, 1);
        this.objdata.inewrow = this.objdata.data[scope].length - 1;
      })
      .catch(() => { });
  };
  onFunc = (cfield) => {
    switch (cfield) {
      case 'Refresh':
        this.fnrefresh();
        break;
      case 'Search':
        this.onSearch();
        break;
      case 'Save':
        this.fnsave(true);
        break;
      case 'New':
        this.fnnew2();
        break;
      case 'NewChildren':
        this.fnnew2_children();
        break;
      case 'Edit':
        this.fnedit();
        break;
      case 'Commit':
        this.fncommit();
        break;
      case 'Verify':
        this.fnverify();
        break;
      case 'Close':
        this.fnClose();
        break;
      case 'Cancel':
        this.fnCancel();
        break;
      case 'Delete':
        this.fndelete();
        break;
      case 'Commitbt':
        this.fncommitbat();
        break;
      case 'Commitrbt':
        this.fncommitrbat();
        break;
      case 'Verifybt':
        this.fnverifybat();
        break;
      case 'Verifyrbt':
        this.fnverifyrbat();
        break;
      case 'Cancelbt':
        this.fncancelbat();
        break;
      case 'Verifyrbt':
        this.fncancelrbat();
        break;
      case 'Deletebt':
        this.fndeletebt();
        break;

      case 'Today':
        result = this.config.proxy.$utils.dtformat.getTodayRange();
        this.objsearch.filter.dstart = result.dstart;
        this.objsearch.filter.dend = result.dend;
        this.onSearch();
        break;
      case 'Week':
        result = this.config.proxy.$utils.dtformat.getThisWeekRange();
        this.objsearch.filter.dstart = result.dstart;
        this.objsearch.filter.dend = result.dend;
        this.onSearch();
        break;
      case 'Month':
        result = this.config.proxy.$utils.dtformat.getThisMonthRange();
        this.objsearch.filter.dstart = result.dstart;
        this.objsearch.filter.dend = result.dend;
        this.onSearch();
        break;
      case 'Year':
        result = this.config.proxy.$utils.dtformat.getThisYearRange();
        this.objsearch.filter.dstart = result.dstart;
        this.objsearch.filter.dend = result.dend;
        this.onSearch();
        break;

      case 'Print':
        this.fnprint();
        break;
      case 'OutputExcel':
        this.exportExcelVO();
        break;
      case 'OutputPdf':
        this.fnprint();
        break;

      case 'AddRow':
        this.fnaddrow('details');
        break;
      case 'RowImport':
        this.RowImport();
        break;
      case 'RowExport':
        this.RowExport();
        break;

      case 'isnew':
        return this.isnew;
      case 'cannew':
        return this.cannew;
      case 'isnew_children':
        return this.isnew_children;
      case 'cannew_children':
        return this.cannew_children;
      case 'isedit':
        return this.isedit;
      case 'canedit':
        return this.canedit;
      case 'canedit_base':
        return this.canedit_base;
      case 'cansave':
        return this.cansave;
      case 'iscommit':
        return this.iscommit;
      case 'cancommit':
        return this.cancommit;
      case 'isverify':
        return this.isverify;
      case 'canverify':
        return this.canverify;
      case 'isclose':
        return this.isclose;
      case 'canclose':
        return this.canclose;
      case 'iscancel':
        return this.iscancel;
      case 'cancancel':
        return this.cancancel;
      case 'candelete':
        return this.candelete;
      case 'canaddrow':
        return this.canaddrow;
    }
  };
  onFormatBtnValue = (value, cfield) => {
    switch (cfield) {
      case 'iname':
      case 'idisabled':
        if (value) return 0;
        else return 1;
    }
  };
  onStandBtnClick = (res) => {
    this.onBtnClick(this, res.ibtntypes, res);
  };
  onBtnClick = (ref, ibtntypes, res) => {
    switch (ibtntypes) {
      case 0:
        ref.onFunc('Refresh', res);
        break;
      case 1:
        ref.onFunc('Search', res);
        break;
      case 2:
        ref.onFunc('Save', res);
        break;
      case 3:
        ref.onFunc('New', res);
        break;
      case 4:
      case 5:
        ref.onFunc('Edit', res);
        break;
      case 6:
        ref.onFunc('Commit', res);
        break;
      case 7:
        ref.onFunc('Verify', res);
        break;
      case 8:
        ref.onFunc('Close', res);
        break;
      case 13:
        ref.onFunc('NewChildren', res);
        break;
      case 17:
        ref.onFunc('Cancel', res);
        break;
      case 18:
      case 19:
        ref.onFunc('Delete', res);
        break;
      case 20:
        ref.onFunc('Commitbt', res);
        break;
      case 21:
        ref.onFunc('Commitrbt', res);
        break;
      case 22:
        ref.onFunc('Verifybt', res);
        break;
      case 23:
        ref.onFunc('Verifyrbt', res);
        break;
      case 26:
        ref.onFunc('Cancelbt', res);
        break;
      case 27:
        ref.onFunc('Cancelrbt', res);
        break;
      case 28:
      case 29:
        ref.onFunc('Deletebt', res);
        break;
      case 31:
        ref.onFunc('Today', res);
        break;
      case 32:
        ref.onFunc('Week', res);
        break;
      case 33:
        ref.onFunc('Month', res);
        break;
      case 34:
        ref.onFunc('Year', res);
        break;
      case 70:
        ref.onFunc('Print', res);
        break;
      case 71:
        ref.onFunc('OutputExcel', res);
        break;
      case 72:
        ref.onFunc('OutputPdf', res);
        break;
      case 80:
        // 子表增行
        ref.onFunc('AddRow', res);
        break;
      case 81:
        // 子表导入
        ref.onFunc('RowImport', res);
        break;
      case 82:
        // 子表导出
        ref.onFunc('RowExport', res);
        break;
    }
  };
  onBtnValueChange = (ref, ibtntypes) => {
    switch (ibtntypes) {
      case 2:
        if ('cansave' in this.objdata.btnstatus) {
          this.objdata.btnstatus.cansave = ref.onFunc('cansave');
        }
        break;
      case 3:
        if ('isnew' in this.objdata.btnstatus) {
          this.objdata.btnstatus.isnew = ref.onFunc('isnew');
        }
        if ('cannew' in this.objdata.btnstatus) {
          this.objdata.btnstatus.cannew = ref.onFunc('cannew');
        }
        break;
      case 4:
        if ('isedit' in this.objdata.btnstatus) {
          this.objdata.btnstatus.isedit = ref.onFunc('isedit');
        }
        if ('canedit' in this.objdata.btnstatus) {
          this.objdata.btnstatus.canedit = ref.onFunc('canedit');
        }
        break;
      case 5:
        if ('isedit' in this.objdata.btnstatus) {
          this.objdata.btnstatus.isedit = ref.onFunc('isedit');
        }
        if ('canedit_base' in this.objdata.btnstatus) {
          this.objdata.btnstatus.canedit_base = ref.onFunc('canedit_base');
        }
        break;
      case 6:
        if ('iscommit' in this.objdata.btnstatus) {
          this.objdata.btnstatus.iscommit = ref.onFunc('iscommit');
        }
        if ('cancommit' in this.objdata.btnstatus) {
          this.objdata.btnstatus.cancommit = ref.onFunc('cancommit');
        }
        break;
      case 7:
        if ('isverify' in this.objdata.btnstatus) {
          this.objdata.btnstatus.isverify = ref.onFunc('isverify');
        }
        if ('canverify' in this.objdata.btnstatus) {
          this.objdata.btnstatus.canverify = ref.onFunc('canverify');
        }
        break;
      case 8:
        if ('isclose' in this.objdata.btnstatus) {
          this.objdata.btnstatus.isclose = ref.onFunc('isclose');
        }
        if ('canclose' in this.objdata.btnstatus) {
          this.objdata.btnstatus.canclose = ref.onFunc('canclose');
        }
        break;
      case 13:
        if ('isnew_children' in this.objdata.btnstatus) {
          this.objdata.btnstatus.isnew_children = ref.onFunc('isnew_children');
        }
        if ('cannew_children' in this.objdata.btnstatus) {
          this.objdata.btnstatus.cannew_children = ref.onFunc('cannew_children');
        }
        break;
      case 17:
        if ('iscancel' in this.objdata.btnstatus) {
          this.objdata.btnstatus.iscancel = ref.onFunc('iscancel');
        }
        if ('cancancel' in this.objdata.btnstatus) {
          this.objdata.btnstatus.cancancel = ref.onFunc('cancancel');
        }
        break;
      case 18:
        if ('candelete' in this.objdata.btnstatus) {
          this.objdata.btnstatus.candelete = ref.onFunc('candelete');
        }
        break;
      case 80:
      case 81:
        if ('canaddrow' in this.objdata.btnstatus) {
          this.objdata.btnstatus.canaddrow = ref.onFunc('canaddrow');
        }
        break;
    }
  };
  onWatchBtnStatus = (ref, type, sourceType) => {
    // 1. 解构+可选链提取所有公共变量，统一兜底，减少重复调用
    const { mnus } = this.objsearch || {};
    const mnuData = mnus?.[sourceType] || {};
    const { lst = [], csysbar = '' } = mnuData;
    const targetList = this.objsearch?.initmuns?.[type]?.[csysbar] ?? [];

    // 2. 核心：抽离重复的按钮处理逻辑为独立函数（复用核心）
    const handleBtnItem = (btnItem) => {
      if (btnItem?.ibtntype === 8 || btnItem?.ibtntype === 11) {
        ref.onBtnValueChange(ref, btnItem?.ibtntypes);
      }
    };

    // 3. 抽离列表遍历逻辑（处理单层item+嵌套children）
    const traverseBtnList = (list) => {
      list.forEach((item) => {
        const children = item?.children ?? [];
        // 无子节点处理当前item，有子节点遍历子节点处理
        children.length === 0 ? handleBtnItem(item) : children.forEach(handleBtnItem);
      });
    };

    // 4. 精简判断条件，执行对应列表的遍历
    const isUseInitMuns = lst.length === 0 && csysbar !== '';
    traverseBtnList(isUseInitMuns ? targetList : lst);
  };
  fnformatOpt = (row, value, lst) => {
    if (!row || !lst) return;
    let idx_s = lst.findIndex((i) => i.value == value);
    if (idx_s != -1) return lst[idx_s].label;
    else return value;
  };
  deepClone(obj, cache = new WeakMap()) {
    // 1. 处理 null/undefined/基本类型（直接返回，兜底）
    if (obj === null || typeof obj !== 'object') return obj;

    // 2. 处理循环引用（关键：避免递归死循环）
    if (cache.has(obj)) return cache.get(obj);

    // 3. 处理 Vue 响应式对象（Proxy）- 先解包
    if (obj.__v_isReactive || obj.__v_isRef) {
      // 简易解包：如果项目引入了 Vue，也可以用 toRaw(obj)
      obj = JSON.parse(JSON.stringify(obj));
    }

    // 4. 处理 Date 类型
    if (obj instanceof Date) {
      const newDate = new Date(obj.getTime());
      cache.set(obj, newDate); // 加入缓存
      return newDate;
    }

    // 5. 处理 RegExp 类型
    if (obj instanceof RegExp) {
      const newReg = new RegExp(obj.source, obj.flags);
      cache.set(obj, newReg); // 加入缓存
      return newReg;
    }

    // 6. 处理数组
    if (Array.isArray(obj)) {
      const newArr = [];
      cache.set(obj, newArr); // 加入缓存
      obj.forEach((item, index) => {
        newArr[index] = this.deepClone(item, cache); // 注意：用 this. 调用自身
      });
      return newArr;
    }

    // 7. 处理纯对象（核心：加异常捕获）
    if (obj instanceof Object && !Array.isArray(obj)) {
      const newObj = {};
      cache.set(obj, newObj); // 加入缓存
      // 遍历属性 + try/catch 防止访问异常
      Reflect.ownKeys(obj).forEach(key => {
        try {
          newObj[key] = this.deepClone(obj[key], cache); // 注意：用 this. 调用自身
        } catch (e) {
          console.warn(`拷贝属性 ${String(key)} 失败:`, e);
          newObj[key] = obj[key]; // 降级返回原属性，避免整体崩溃
        }
      });
      return newObj;
    }

    // 8. 其他类型（函数/内置对象等，直接返回原引用）
    return obj;
  }
  isDeepEqual(a, b) {
    // 1. 先判断类型是否相同
    if (typeof a !== typeof b) return false;

    // 2. 处理 null/undefined
    if (a === null || b === null) return a === b;

    // 3. 处理基本类型（数字、字符串、布尔、Symbol）
    if (typeof a !== 'object') return a === b;

    // 4. 处理 Date 类型
    if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();

    // 5. 处理 Array 类型
    if (a instanceof Array && b instanceof Array) {
      // 先判断长度是否一致
      if (a.length !== b.length) return false;
      // 遍历每个元素，递归对比
      for (let i = 0; i < a.length; i++) {
        if (!this.isDeepEqual(a[i], b[i])) return false;
      }
      return true;
    }

    // 6. 处理 Object 类型（排除数组/Date）
    if (a instanceof Object && b instanceof Object) {
      // 获取所有自有属性名（包括不可枚举属性）
      const keysA = Reflect.ownKeys(a);
      const keysB = Reflect.ownKeys(b);
      // 先判断属性数量是否一致
      if (keysA.length !== keysB.length) return false;
      // 遍历每个属性，递归对比
      for (const key of keysA) {
        if (!keysB.includes(key)) return false; // 属性名不存在
        if (!this.isDeepEqual(a[key], b[key])) return false; // 属性值不一致
      }
      return true;
    }

    // 7. 其他类型（如 Function，判断引用是否一致）
    return a === b;
  }

  isObjectDeepEqual(obj1, obj2) {
    // 1. 首先严格判断是否为纯 Object 类型（排除数组、null、Date等）
    const isPureObject = (val) =>
      val !== null && typeof val === 'object' && !Array.isArray(val) && !(val instanceof Date);

    // 非纯对象直接返回 false
    if (!isPureObject(obj1) || !isPureObject(obj2)) return false;

    // 2. 获取两个对象的所有自有属性名（包括不可枚举、Symbol 属性）
    const keys1 = Reflect.ownKeys(obj1);
    const keys2 = Reflect.ownKeys(obj2);

    // 3. 属性数量不一致，直接不相等
    if (keys1.length !== keys2.length) return false;

    // 4. 遍历所有属性，递归对比值
    for (const key of keys1) {
      // 属性名不存在，直接不相等
      if (!keys2.includes(key)) return false;

      const val1 = obj1[key];
      const val2 = obj2[key];

      // 子值是纯对象：递归判断
      if (isPureObject(val1) && isPureObject(val2)) {
        if (!this.isObjectDeepEqual(val1, val2)) return false;
      }
      // 子值是基本类型/其他类型：直接严格相等判断
      else {
        // 特殊处理 Date 子值（如果对象属性里有 Date）
        if (val1 instanceof Date && val2 instanceof Date) {
          if (val1.getTime() !== val2.getTime()) return false;
        }
        // 数组子值：长度+每一项严格相等（可选，根据你的需求）
        else if (Array.isArray(val1) && Array.isArray(val2)) {
          if (val1.length !== val2.length || !val1.every((item, idx) => item === val2[idx])) {
            return false;
          }
        }
        // 基本类型/函数等：严格相等
        else if (val1 !== val2) {
          return false;
        }
      }
    }

    // 所有属性都匹配，返回相等
    return true;
  }
  parseCshowpc = (cshowpcStr, ishowpcVal, iname2Val) => {
    // {0: "Base Info|基础属性", 1: "Other Info|其它属性"}
    const cshowpcObj = {};
    cshowpcStr.split(',').forEach((item) => {
      const [key, value] = item.split(':');
      cshowpcObj[key] = value;
    });
    const rawValue = cshowpcObj[ishowpcVal];
    if (!rawValue) return '';
    let result = '';
    if (iname2Val != 0) {
      result = rawValue.replace('|', ' ');
    } else {
      result = rawValue.split('|')[0];
    }
    return result;
  };
  getTabLabel(mblstKey, defaultText, ishowpc) {
    // 提取head对象，减少重复链式调用
    const head = this.objdata?.views?.[mblstKey]?.head || {};
    // 提前获取cshowpc值，避免重复判断
    const cshowpc = head.cshowpc || '';

    // 如果cshowpc有值，先解析它
    if (cshowpc) {
      const parsedValue = this.parseCshowpc(cshowpc, ishowpc, head.iname2) || '';
      // 解析结果有值则返回，否则用cname或默认值
      return parsedValue || head.cname || defaultText;
    }

    // cshowpc无值时，直接用cname或默认值
    return head.cname || defaultText;
  }
  hotKey(event, ref) {
    if (event.keyCode == 38) {
      event.preventDefault();
      // console.log('上');
      if (this.objdata.index > 0) {
        this.objdata.index -= 1;
        ref.setCurrentRow(this.objdata.data.details[this.objdata.index]);
      }
    } else if (event.keyCode == 40) {
      event.preventDefault();
      // console.log('下');
      if (this.objdata.index < this.objdata.data.details.length - 1) {
        this.objdata.index += 1;
        ref.setCurrentRow(this.objdata.data.details[this.objdata.index]);
      }
    }
  }
  isEmptyObject(obj) {
    if (obj === null || typeof obj !== 'object' || Array.isArray(obj)) {
      return false;
    }
    // 遍历自有属性，有则返回false
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        return false;
      }
    }
    return true;
  }
  juageExt(cext) {
    const imageExts = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg', 'heic', 'tiff'];
    const videoExts = [
      'mp4',
      'mov',
      'avi',
      'mkv',
      'flv',
      'wmv',
      'webm',
      'mpeg',
      'mpg',
      '3gp',
      'rmvb',
      'mts',
    ];
    const ext = cext.toLowerCase();
    const obj = {
      isImage: false,
      isVideo: false,
      isDefault: false,
    };
    if (imageExts.includes(ext)) {
      obj.isImage = true;
    } else if (videoExts.includes(ext)) {
      obj.isVideo = true;
    } else obj.isDefault = true;
    return obj;
  };
}
